<app-loader></app-loader>

<div class="lp-redesign bg-[#030204] text-slate-100 selection:bg-[#C71650] selection:text-[#FAF4EB]">

<!-- ==========================================================
     LUCKYCREST — THE ROYAL PASS
     Single HTML file: HTML + CSS
     Angular-compatible | Responsive | Premium redesign
     ========================================================== -->

<style>
  .lc-pass {
    --lc-ink: #030204;
    --lc-wine: #0D070C;
    --lc-burgundy: #C71650;
    --lc-rose: #E7CA96;
    --lc-gold: #E7CA96;
    --lc-cream: #F6E9D5;

    position: fixed;
    z-index: 1000;
    top: 18px;
    left: 0;
    width: 100%;
    padding: 0 4%;
    pointer-events: none;
    font-family: inherit;
  }

  .lc-pass *,
  .lc-pass *::before,
  .lc-pass *::after {
    box-sizing: border-box;
  }

  /* MAIN FRAME */

  .lc-pass__frame {
    position: relative;
    display: grid;
    grid-template-columns: minmax(220px, 1fr) auto minmax(240px, 1fr);
    align-items: center;
    gap: 24px;
    width: 100%;
    max-width: 1480px;
    min-height: 88px;
    margin: 0 auto;
    padding: 12px 20px;
    overflow: visible;
    border: 1px solid rgba(231, 202, 150, 0.25);
    border-radius: 15px 15px 15px 4px;
    background:
      linear-gradient(
        105deg,
        rgba(199, 22, 80, 0.13),
        transparent 33%,
        rgba(231, 202, 150, 0.035) 68%,
        rgba(199, 22, 80, 0.10)
      ),
      rgba(3, 2, 4, 0.96);
    box-shadow:
      0 18px 55px rgba(0, 0, 0, 0.38),
      inset 0 1px rgba(246, 233, 213, 0.055);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    pointer-events: auto;
  }

  .lc-pass__frame::before {
    content: "";
    position: absolute;
    top: -1px;
    left: 30px;
    width: 105px;
    height: 2px;
    background: linear-gradient(
      90deg,
      transparent,
      var(--lc-gold),
      var(--lc-rose),
      transparent
    );
  }

  .lc-pass__frame::after {
    content: "";
    position: absolute;
    bottom: -1px;
    right: 22px;
    width: 68px;
    height: 2px;
    background: linear-gradient(90deg, transparent, var(--lc-burgundy));
  }

  /* BRAND / CREST */

  .lc-pass__brand {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
    width: fit-content;
    color: var(--lc-cream);
    text-decoration: none;
    cursor: pointer;
  }

  .lc-pass__crest {
    position: relative;
    display: grid;
    place-items: center;
    flex: 0 0 60px;
    width: 60px;
    height: 62px;
    isolation: isolate;
  }

  .lc-pass__crest-shape {
    position: absolute;
    inset: 2px 4px 3px;
    z-index: -1;
    background: linear-gradient(
      145deg,
      #452035 0%,
      #1B0B15 48%,
      #030204 100%
    );
    border: 1px solid rgba(231, 202, 150, 0.72);
    clip-path: polygon(
      50% 0%,
      94% 17%,
      90% 64%,
      75% 83%,
      50% 100%,
      25% 83%,
      10% 64%,
      6% 17%
    );
    filter: drop-shadow(0 4px 12px rgba(199, 22, 80, 0.28));
  }

  .lc-pass__crest::before {
    content: "";
    position: absolute;
    inset: 7px 10px 9px;
    z-index: -1;
    border: 1px solid rgba(231, 202, 150, 0.27);
    clip-path: polygon(
      50% 0%,
      94% 17%,
      90% 64%,
      75% 83%,
      50% 100%,
      25% 83%,
      10% 64%,
      6% 17%
    );
  }

  .lc-pass__logo {
    display: block;
    width: 46px;
    height: 46px;
    object-fit: contain;
    filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.45));
  }

  .lc-pass__crest-star {
    position: absolute;
    top: -2px;
    right: -1px;
    color: var(--lc-gold);
    font-size: 14px;
    text-shadow: 0 0 12px rgba(231, 202, 150, 0.45);
  }

  .lc-pass__brand-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .lc-pass__wordmark {
    color: var(--lc-cream);
    font-family: Georgia, "Times New Roman", serif;
    font-size: 21px;
    font-weight: 500;
    letter-spacing: 1.1px;
    line-height: 1;
    white-space: nowrap;
  }

  .lc-pass__wordmark span {
    color: var(--lc-gold);
  }

  .lc-pass__descriptor {
    display: flex;
    align-items: center;
    gap: 7px;
    color: var(--lc-rose);
    font-size: 8px;
    font-weight: 600;
    letter-spacing: 2.65px;
    white-space: nowrap;
  }

  .lc-pass__descriptor::before {
    content: "";
    width: 13px;
    height: 1px;
    background: var(--lc-gold);
    opacity: 0.75;
  }

  /* CENTER NAVIGATION */

  .lc-pass__navigation {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 9px;
  }

  .lc-pass__eyebrow {
    display: flex;
    align-items: center;
    gap: 9px;
    color: rgba(246, 233, 213, 0.43);
    font-size: 8px;
    font-weight: 600;
    letter-spacing: 3px;
    white-space: nowrap;
  }

  .lc-pass__eyebrow::before,
  .lc-pass__eyebrow::after {
    content: "";
    width: 19px;
    height: 1px;
    background: rgba(231, 202, 150, 0.38);
  }

  .lc-pass__links {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .lc-pass__link {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 39px;
    padding: 0 12px;
    border: 1px solid transparent;
    border-radius: 5px;
    background: transparent;
    color: rgba(246, 233, 213, 0.68);
    font: inherit;
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    transition:
      color 220ms ease,
      background 220ms ease,
      border-color 220ms ease;
  }

  .lc-pass__link::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--lc-gold);
    box-shadow: 0 0 9px rgba(231, 202, 150, 0.7);
    opacity: 0;
    transform: translateX(-50%) scale(0.5);
    transition: opacity 220ms ease, transform 220ms ease;
  }

  .lc-pass__link:hover,
  .lc-pass__link.lc-pass__link--active {
    color: var(--lc-cream);
    border-color: rgba(231, 202, 150, 0.16);
    background: linear-gradient(
      180deg,
      rgba(199, 22, 80, 0.19),
      rgba(199, 22, 80, 0.035)
    );
  }

  .lc-pass__link:hover::before,
  .lc-pass__link.lc-pass__link--active::before {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }

  .lc-pass__link-icon {
    color: var(--lc-rose);
    font-size: 15px;
    line-height: 1;
    transition: color 220ms ease;
  }

  .lc-pass__link:hover .lc-pass__link-icon,
  .lc-pass__link--active .lc-pass__link-icon {
    color: var(--lc-gold);
  }

  /* RIGHT-SIDE ACTIONS */

  .lc-pass__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    min-width: 0;
  }

  .lc-pass__sound {
    display: grid;
    place-items: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border: 1px solid rgba(231, 202, 150, 0.21);
    border-radius: 50%;
    background: rgba(246, 233, 213, 0.025);
    cursor: pointer;
    transition: border-color 220ms ease, background 220ms ease;
  }

  .lc-pass__sound:hover {
    border-color: var(--lc-gold);
    background: rgba(199, 22, 80, 0.2);
  }

  .lc-pass__sound-bars {
    display: flex;
    align-items: center;
    gap: 3px;
    height: 15px;
  }

  .lc-pass__sound-bars i {
    display: block;
    width: 2px;
    height: 7px;
    border-radius: 2px;
    background: var(--lc-gold);
    animation: lc-pass-wave 750ms ease-in-out infinite alternate;
  }

  .lc-pass__sound-bars i:nth-child(2) {
    height: 13px;
    animation-delay: 130ms;
  }

  .lc-pass__sound-bars i:nth-child(3) {
    height: 9px;
    animation-delay: 260ms;
  }

  .lc-pass__sound-bars i:nth-child(4) {
    height: 12px;
    animation-delay: 80ms;
  }

  .lc-pass__sound-bars--muted i {
    height: 3px;
    animation: none;
    opacity: 0.48;
  }

  @keyframes lc-pass-wave {
    from { transform: scaleY(0.48); }
    to { transform: scaleY(1); }
  }

  .lc-pass__divider {
    width: 1px;
    height: 31px;
    background: linear-gradient(
      180deg,
      transparent,
      rgba(231, 202, 150, 0.38),
      transparent
    );
  }

  .lc-pass__login {
    padding: 10px 0;
    border: 0;
    background: transparent;
    color: var(--lc-cream);
    font: inherit;
    font-size: 11px;
    white-space: nowrap;
    cursor: pointer;
    transition: color 200ms ease;
  }

  .lc-pass__login:hover {
    color: var(--lc-gold);
  }

  /* PREMIUM TICKET CTA */

  .lc-pass__ticket {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 48px;
    padding: 0 14px;
    border: 1px solid rgba(231, 202, 150, 0.72);
    border-radius: 12px;
    background:
      linear-gradient(
        110deg,
        rgba(231, 202, 150, 0.98),
        rgba(246, 233, 213, 0.96) 48%,
        rgba(217, 172, 131, 0.98)
      );
    color: #1A0A12;
    font: inherit;
    cursor: pointer;
    box-shadow: inset 0 1px rgba(255, 255, 255, 0.42);
    transition:
      transform 220ms ease,
      box-shadow 220ms ease;
  }

  .lc-pass__ticket::before,
  .lc-pass__ticket::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--lc-ink);
    transform: translateY(-50%);
  }

  .lc-pass__ticket::before {
    left: -4px;
  }

  .lc-pass__ticket::after {
    right: -4px;
  }

  .lc-pass__ticket:hover {
    transform: translateY(-2px);
    box-shadow:
      0 9px 24px rgba(231, 202, 150, 0.17),
      inset 0 1px rgba(255, 255, 255, 0.42);
  }

  .lc-pass__ticket-copy {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .lc-pass__ticket-overline {
    font-size: 7px;
    font-weight: 700;
    letter-spacing: 1.8px;
    opacity: 0.7;
  }

  .lc-pass__ticket-title {
    font-family: Georgia, "Times New Roman", serif;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .lc-pass__ticket-arrow {
    display: grid;
    place-items: center;
    width: 26px;
    height: 26px;
    border: 1px solid rgba(26, 10, 18, 0.2);
    border-radius: 50%;
    font-size: 15px;
    transition: transform 220ms ease;
  }

  .lc-pass__ticket:hover .lc-pass__ticket-arrow {
    transform: translate(2px, -1px);
  }

  /* MEMBER LOUNGE */

  .lc-pass__lounge {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    min-height: 45px;
    padding: 0 12px;
    border: 1px solid rgba(231, 202, 150, 0.35);
    border-radius: 12px;
    background: rgba(199, 22, 80, 0.16);
    color: var(--lc-gold);
    font: inherit;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    white-space: nowrap;
    cursor: pointer;
    transition: background 220ms ease, border-color 220ms ease;
  }

  .lc-pass__lounge:hover {
    border-color: var(--lc-gold);
    background: rgba(199, 22, 80, 0.3);
  }

  .lc-pass__lounge-emblem {
    display: grid;
    place-items: center;
    width: 26px;
    height: 26px;
    border: 1px solid rgba(231, 202, 150, 0.36);
    border-radius: 50%;
    font-size: 14px;
  }

  .lc-pass__lounge-arrow {
    color: var(--lc-rose);
    font-size: 14px;
  }

  /* MOBILE MENU BUTTON */

  .lc-pass__menu-toggle {
    display: none;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 5px;
    flex: 0 0 43px;
    width: 43px;
    height: 43px;
    border: 1px solid rgba(231, 202, 150, 0.28);
    border-radius: 12px;
    background: rgba(199, 22, 80, 0.12);
    cursor: pointer;
  }

  .lc-pass__menu-line {
    display: block;
    width: 18px;
    height: 1.5px;
    background: var(--lc-gold);
    transition: transform 220ms ease;
  }

  .lc-pass__menu-line--top-open {
    transform: translateY(3.25px) rotate(45deg);
  }

  .lc-pass__menu-line--bottom-open {
    transform: translateY(-3.25px) rotate(-45deg);
  }

  /* MOBILE DRAWER */

  .lc-pass__mobile {
    position: relative;
    width: 100%;
    max-width: 1480px;
    margin: 9px auto 0;
    padding: 20px;
    border: 1px solid rgba(231, 202, 150, 0.23);
    border-radius: 4px 15px 4px 15px;
    background:
      radial-gradient(
        ellipse at 100% 0%,
        rgba(199, 22, 80, 0.22),
        transparent 52%
      ),
      #0B060A;
    box-shadow: 0 20px 55px rgba(0, 0, 0, 0.45);
    pointer-events: auto;
    animation: lc-pass-open 230ms ease both;
  }

  @keyframes lc-pass-open {
    from {
      opacity: 0;
      transform: translateY(-7px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .lc-pass__mobile-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(231, 202, 150, 0.14);
  }

  .lc-pass__mobile-heading {
    color: var(--lc-cream);
    font-family: Georgia, "Times New Roman", serif;
    font-size: 15px;
    letter-spacing: 0.4px;
  }

  .lc-pass__mobile-edition {
    color: var(--lc-rose);
    font-size: 8px;
    font-weight: 600;
    letter-spacing: 1.8px;
  }

  .lc-pass__mobile-link {
    display: grid;
    grid-template-columns: 38px 1fr 24px;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 57px;
    padding: 0 5px;
    border: 0;
    border-bottom: 1px solid rgba(231, 202, 150, 0.09);
    background: transparent;
    color: var(--lc-cream);
    text-align: left;
    font: inherit;
    font-size: 13px;
    cursor: pointer;
    transition: padding 180ms ease, background 180ms ease;
  }

  .lc-pass__mobile-link:hover {
    padding-left: 11px;
    background: rgba(199, 22, 80, 0.12);
  }

  .lc-pass__mobile-number {
    color: var(--lc-rose);
    font-family: Georgia, "Times New Roman", serif;
    font-size: 12px;
  }

  .lc-pass__mobile-arrow {
    color: var(--lc-gold);
    text-align: right;
    font-size: 16px;
  }

  .lc-pass__mobile-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 16px;
  }

  .lc-pass__mobile-login,
  .lc-pass__mobile-join {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 45px;
    padding: 0 10px;
    border-radius: 12px;
    font: inherit;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
  }

  .lc-pass__mobile-login {
    border: 1px solid rgba(231, 202, 150, 0.28);
    background: transparent;
    color: var(--lc-cream);
  }

  .lc-pass__mobile-join {
    border: 1px solid rgba(231, 202, 150, 0.6);
    background: linear-gradient(110deg, #E7CA96, #D9AC83);
    color: #1A0A12;
  }

  .lc-pass__mobile-member {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 45px;
    margin-top: 16px;
    padding: 0 13px;
    border: 1px solid rgba(231, 202, 150, 0.35);
    background: rgba(199, 22, 80, 0.16);
    color: var(--lc-gold);
    font: inherit;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
  }

  .lc-pass__mobile-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 16px;
    padding-top: 13px;
    border-top: 1px solid rgba(231, 202, 150, 0.12);
  }

  .lc-pass__mobile-brand {
    color: var(--lc-gold);
    font-family: Georgia, "Times New Roman", serif;
    font-size: 10px;
    letter-spacing: 2px;
  }

  .lc-pass__mobile-tagline {
    color: rgba(246, 233, 213, 0.4);
    font-size: 7px;
    letter-spacing: 1px;
    text-align: right;
  }

  /* RESPONSIVE TABLET */

  @media (max-width: 1280px) {
    .lc-pass {
      padding: 0 2.5%;
    }

    .lc-pass__frame {
      grid-template-columns: minmax(195px, 1fr) auto minmax(205px, 1fr);
      gap: 12px;
      padding-right: 14px;
      padding-left: 14px;
    }

    .lc-pass__brand {
      gap: 10px;
    }

    .lc-pass__crest {
      flex-basis: 54px;
      width: 54px;
      height: 57px;
    }

    .lc-pass__logo {
      width: 42px;
      height: 42px;
    }

    .lc-pass__wordmark {
      font-size: 18px;
    }

    .lc-pass__descriptor {
      font-size: 7px;
      letter-spacing: 2px;
    }

    .lc-pass__link {
      gap: 5px;
      padding-right: 8px;
      padding-left: 8px;
      font-size: 10px;
    }

    .lc-pass__link-icon {
      font-size: 13px;
    }

    .lc-pass__actions {
      gap: 8px;
    }

    .lc-pass__ticket {
      gap: 8px;
      padding: 0 10px;
    }

    .lc-pass__ticket-overline {
      letter-spacing: 1px;
    }
  }

  /* COLLAPSE TO MOBILE NAV */

  @media (max-width: 1060px) {
    .lc-pass {
      top: 11px;
      padding: 0 18px;
    }

    .lc-pass__frame {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      min-height: 80px;
      padding: 8px 13px;
      border-radius: 12px 12px 12px 3px;
    }

    .lc-pass__navigation,
    .lc-pass__divider,
    .lc-pass__login,
    .lc-pass__ticket,
    .lc-pass__lounge {
      display: none;
    }

    .lc-pass__actions {
      gap: 9px;
    }

    .lc-pass__menu-toggle {
      display: flex;
    }
  }

  @media (max-width: 480px) {
    .lc-pass {
      top: 8px;
      padding: 0 10px;
    }

    .lc-pass__frame {
      min-height: 73px;
      padding: 7px 9px;
    }

    .lc-pass__brand {
      gap: 9px;
    }

    .lc-pass__crest {
      flex-basis: 49px;
      width: 49px;
      height: 52px;
    }

    .lc-pass__logo {
      width: 38px;
      height: 38px;
    }

    .lc-pass__wordmark {
      font-size: 16px;
      letter-spacing: 0.5px;
    }

    .lc-pass__descriptor {
      gap: 5px;
      font-size: 6px;
      letter-spacing: 1.6px;
    }

    .lc-pass__descriptor::before {
      width: 8px;
    }

    .lc-pass__sound {
      flex-basis: 35px;
      width: 35px;
      height: 35px;
    }

    .lc-pass__menu-toggle {
      flex-basis: 39px;
      width: 39px;
      height: 39px;
    }

    .lc-pass__mobile {
      padding: 15px;
    }

    .lc-pass__mobile-edition {
      font-size: 7px;
      letter-spacing: 1px;
    }

    .lc-pass__mobile-bottom {
      gap: 7px;
    }

    .lc-pass__mobile-login,
    .lc-pass__mobile-join {
      font-size: 10px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .lc-pass *,
    .lc-pass *::before,
    .lc-pass *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
</style>

<!-- ROYAL PASS NAVBAR -->

<header class="lc-pass">
  <nav class="lc-pass__frame" aria-label="Main navigation">

    <!-- BRAND -->
    <a
      href="javascript:void(0)"
      class="lc-pass__brand"
      (click)="scrollToTop()"
      aria-label="LuckyCrest home"
    >
      <span class="lc-pass__crest">
        <span class="lc-pass__crest-shape"></span>

        <img
          src="mainLogo.webp"
          onerror="this.onerror=null;this.src='assets/images/logo.png'"
          alt="LuckyCrest logo"
          class="lc-pass__logo"
        />

        <span class="lc-pass__crest-star">✦</span>
      </span>

      <span class="lc-pass__brand-copy">
        <span class="lc-pass__wordmark">LUCKY<span>CREST</span></span>
        <span class="lc-pass__descriptor">SOCIAL CASINO</span>
      </span>
    </a>

    <!-- DESKTOP NAVIGATION -->
    <div class="lc-pass__navigation">
      <span class="lc-pass__eyebrow">THE PRIVILEGED PLAY</span>

      <div class="lc-pass__links">

        <button
          type="button"
          class="lc-pass__link"
          [class.lc-pass__link--active]="activeNav === 'games'"
          (click)="scrollTo('gameScrollSection')"
        >
          <span class="lc-pass__link-icon">♧</span>
          <span>Games</span>
        </button>

        <button
          type="button"
          class="lc-pass__link"
          [class.lc-pass__link--active]="activeNav === 'rewards'"
          (click)="scrollTo('spinnerScrollSection')"
        >
          <span class="lc-pass__link-icon">✧</span>
          <span>Rewards</span>
        </button>

        <button
          type="button"
          class="lc-pass__link"
          [class.lc-pass__link--active]="activeNav === 'scratch'"
          (click)="scrollTo('scratchScrollSection')"
        >
          <span class="lc-pass__link-icon">▧</span>
          <span>Scratch</span>
        </button>

        <button
          type="button"
          class="lc-pass__link"
          [class.lc-pass__link--active]="activeNav === 'reviews'"
          (click)="scrollTo('reviewsScrollSection')"
        >
          <span class="lc-pass__link-icon">☆</span>
          <span>Community</span>
        </button>

      </div>
    </div>

    <!-- ACTIONS -->
    <div class="lc-pass__actions">

      <button
        type="button"
        class="lc-pass__sound"
        (click)="toggleMusic()"
        [attr.aria-label]="isMusicMuted ? 'Unmute music' : 'Mute music'"
        title="Toggle music"
      >
        <span
          class="lc-pass__sound-bars"
          [class.lc-pass__sound-bars--muted]="isMusicMuted"
        >
          <i></i><i></i><i></i><i></i>
        </span>
      </button>

      <span class="lc-pass__divider" aria-hidden="true"></span>

      <ng-container *ngIf="isToken; else royalPassGuestActions">
        <button
          type="button"
          class="lc-pass__lounge"
          (click)="goToDashboard()"
        >
          <span class="lc-pass__lounge-emblem">♛</span>
          <span>MY LOUNGE</span>
          <span class="lc-pass__lounge-arrow">↗</span>
        </button>
      </ng-container>

      <ng-template #royalPassGuestActions>
        <button
          type="button"
          class="lc-pass__login"
          (click)="RedirectToLogin()"
        >
          Sign in
        </button>

        <button
          type="button"
          class="lc-pass__ticket"
          (click)="RedirectToSignUp()"
        >
          <span class="lc-pass__ticket-copy">
            <span class="lc-pass__ticket-overline">YOUR INVITATION</span>
            <span class="lc-pass__ticket-title">Enter the Club</span>
          </span>
          <span class="lc-pass__ticket-arrow">↗</span>
        </button>
      </ng-template>

      <!-- MOBILE TOGGLE -->
      <button
        type="button"
        class="lc-pass__menu-toggle"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen"
        aria-label="Toggle navigation menu"
      >
        <span
          class="lc-pass__menu-line"
          [class.lc-pass__menu-line--top-open]="isMobileMenuOpen"
        ></span>
        <span
          class="lc-pass__menu-line"
          [class.lc-pass__menu-line--bottom-open]="isMobileMenuOpen"
        ></span>
      </button>

    </div>
  </nav>

  <!-- MOBILE NAVIGATION -->
  <div class="lc-pass__mobile" *ngIf="isMobileMenuOpen">

    <div class="lc-pass__mobile-head">
      <span class="lc-pass__mobile-heading">Explore the experience</span>
      <span class="lc-pass__mobile-edition">THE ROYAL PASS ✦</span>
    </div>

    <button
      type="button"
      class="lc-pass__mobile-link"
      (click)="scrollTo('gameScrollSection'); toggleMobileMenu()"
    >
      <span class="lc-pass__mobile-number">01</span>
      <span>Explore Games</span>
      <span class="lc-pass__mobile-arrow">↗</span>
    </button>

    <button
      type="button"
      class="lc-pass__mobile-link"
      (click)="scrollTo('spinnerScrollSection'); toggleMobileMenu()"
    >
      <span class="lc-pass__mobile-number">02</span>
      <span>Fortune &amp; Rewards</span>
      <span class="lc-pass__mobile-arrow">↗</span>
    </button>

    <button
      type="button"
      class="lc-pass__mobile-link"
      (click)="scrollTo('scratchScrollSection'); toggleMobileMenu()"
    >
      <span class="lc-pass__mobile-number">03</span>
      <span>Scratch Cards</span>
      <span class="lc-pass__mobile-arrow">↗</span>
    </button>

    <button
      type="button"
      class="lc-pass__mobile-link"
      (click)="scrollTo('reviewsScrollSection'); toggleMobileMenu()"
    >
      <span class="lc-pass__mobile-number">04</span>
      <span>Community</span>
      <span class="lc-pass__mobile-arrow">↗</span>
    </button>

    <div class="lc-pass__mobile-bottom" *ngIf="!isToken">
      <button
        type="button"
        class="lc-pass__mobile-login"
        (click)="RedirectToLogin(); toggleMobileMenu()"
      >
        Sign in
      </button>

      <button
        type="button"
        class="lc-pass__mobile-join"
        (click)="RedirectToSignUp(); toggleMobileMenu()"
      >
        Join LuckyCrest <span>↗</span>
      </button>
    </div>

    <button
      *ngIf="isToken"
      type="button"
      class="lc-pass__mobile-member"
      (click)="goToDashboard(); toggleMobileMenu()"
    >
      <span>Open My Lounge</span>
      <span>↗</span>
    </button>

    <div class="lc-pass__mobile-footer">
      <span class="lc-pass__mobile-brand">LUCKYCREST</span>
      <span class="lc-pass__mobile-tagline">YOUR MOMENT. YOUR FORTUNE.</span>
    </div>

  </div>
</header>



<section class="relative isolate min-h-screen overflow-hidden bg-[#030204] text-white">

  <!-- Background -->
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
    <img
      src="auth-bg.webp"
      alt=""
      class="absolute inset-0 h-full w-full object-cover opacity-[0.12]"
    />

    <div class="absolute inset-0 bg-gradient-to-b from-[#030204]/70 via-[#030204]/85 to-[#030204]"></div>

    <div class="absolute left-1/2 top-0 h-[500px] w-[700px] -translate-x-1/2 rounded-full bg-[#9B0F3B]/25 blur-[150px]"></div>

    <div class="absolute right-[-10%] top-[35%] h-[350px] w-[350px] rounded-full bg-[#C71650]/10 blur-[130px]"></div>

    <div class="absolute bottom-0 left-[-10%] h-[350px] w-[350px] rounded-full bg-[#4D0A24]/25 blur-[120px]"></div>

    <div
      class="absolute inset-0 opacity-[0.035]"
      style="background-image:linear-gradient(rgba(231, 202, 150,.5) 1px,transparent 1px),linear-gradient(90deg,rgba(231, 202, 150,.5) 1px,transparent 1px);background-size:55px 55px">
    </div>
  </div>

  <div class="mx-auto max-w-[1500px] px-5 pb-10 pt-24 sm:px-8 sm:pt-28 lg:px-12">

    <!-- Hero -->
    <div class="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-8">

      <!-- Left Content -->
      <div class="relative z-10 text-center lg:text-left">

        <div class="mb-7 inline-flex items-center gap-3 rounded-full border border-[#E7CA96]/20 bg-[#9B0F3B]/15 px-4 py-2">
          <span class="relative flex h-2 w-2">
            <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#C71650] opacity-60"></span>
            <span class="relative inline-flex h-2 w-2 rounded-full bg-[#C71650]"></span>
          </span>

          <span class="text-[9px] font-bold uppercase tracking-[0.22em] text-[#F6E9D5] sm:text-[10px]">
            A Different Kind Of Play
          </span>
        </div>

        <h1 class="text-[17vw] font-black uppercase leading-[0.83] tracking-[-0.075em] sm:text-8xl lg:text-[6.5rem] xl:text-[7.7rem]">
          PLAY
          <span class="mt-2 block bg-gradient-to-r from-[#F6E9D5] via-[#E7CA96] to-[#C72A69] bg-clip-text pb-2 text-transparent">
            WITHOUT
          </span>
          LIMITS<span class="text-[#E7CA96]">.</span>
        </h1>

        <p class="mx-auto mt-7 max-w-lg text-sm leading-7 text-slate-400 sm:text-base lg:mx-0">
          Enter a world of slots, instant-play challenges and fortune wheels.
          Discover your next favorite gaming experience.
        </p>

        <!-- Action Buttons -->
        <div class="mt-8 flex flex-col justify-center gap-3 sm:flex-row lg:justify-start">

          <button
            (click)="scrollTo('gameScrollSection')"
            class="group flex min-h-[54px] items-center justify-center gap-4 rounded-full bg-gradient-to-r from-[#C71650] via-[#9B0F3B] to-[#680825] border border-[#E7CA96]/50 px-7 text-sm font-black text-[#FAF4EB] shadow-[0_8px_35px_rgba(199,22,80,.45)] transition duration-300 hover:-translate-y-1 hover:bg-[#F6E9D5] active:scale-95">

            Explore Games

            <span class="flex h-7 w-7 items-center justify-center rounded-full bg-[#030204] text-[#E7CA96] transition-transform duration-300 group-hover:rotate-45">
              <i class="fas fa-arrow-right text-[10px]"></i>
            </span>
          </button>

          <button
            (click)="RedirectToSignUp()"
            class="flex min-h-[54px] items-center justify-center gap-2 rounded-full border border-[#E7CA96]/30 bg-white/[0.03] px-7 text-sm font-bold text-[#F6E9D5] backdrop-blur-md transition duration-300 hover:-translate-y-1 hover:border-[#E7CA96] hover:bg-[#9B0F3B]/25">

            <i class="fas fa-sparkles text-[#E7CA96]"></i>
            Get Started
          </button>

          <button
            *ngIf="showInstallButton"
            (click)="installApp()"
            class="flex min-h-[54px] items-center justify-center gap-2 rounded-full border border-white/10 px-6 text-sm font-semibold text-slate-300 transition hover:border-[#E7CA96]/50 hover:text-[#F6E9D5]">

            <i class="fas fa-download text-[#E7CA96]"></i>
            Install App
          </button>

        </div>

        <!-- Quick Highlights -->
        <div class="mx-auto mt-10 flex max-w-md items-center justify-center gap-5 border-t border-white/[0.08] pt-6 sm:gap-8 lg:mx-0 lg:justify-start">

          <div>
            <p class="text-xl font-black text-[#F6E9D5]">
              150<span class="text-[#E7CA96]">+</span>
            </p>
            <p class="mt-1 text-[9px] uppercase tracking-wider text-slate-500">
              Games to explore
            </p>
          </div>

          <div class="h-9 w-px bg-white/10"></div>

          <div>
            <p class="text-xl font-black text-[#F6E9D5]">03</p>
            <p class="mt-1 text-[9px] uppercase tracking-wider text-slate-500">
              Ways to play
            </p>
          </div>

          <div class="h-9 w-px bg-white/10"></div>

          <div>
            <p class="text-xl font-black text-[#F6E9D5]">
              FUN<span class="text-[#E7CA96]">.</span>
            </p>
            <p class="mt-1 text-[9px] uppercase tracking-wider text-slate-500">
              Your next adventure
            </p>
          </div>

        </div>
      </div>

      <!-- Right Visual Composition -->
      <div class="relative mx-auto min-h-[470px] w-full max-w-[560px] sm:min-h-[540px] lg:min-h-[570px]">

        <!-- Decorative Rings -->
        <div class="absolute left-1/2 top-1/2 aspect-square w-[75%] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#E7CA96]/10"></div>

        <div class="absolute left-1/2 top-1/2 aspect-square w-[58%] -translate-x-1/2 -translate-y-1/2 rounded-full border border-dashed border-[#E7CA96]/20"></div>

        <!-- Central Portal -->
        <div class="absolute left-1/2 top-1/2 z-0 flex aspect-square w-[43%] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[#E7CA96]/30 bg-gradient-to-br from-[#9B0F3B]/60 via-[#160A13]/90 to-[#030204] shadow-[0_0_100px_rgba(107,15,51,.35)]">

          <div class="absolute inset-3 rounded-full border border-[#E7CA96]/15"></div>

          <div class="flex flex-col items-center">
            <i class="fas fa-dharmachakra animate-[spin_24s_linear_infinite] text-4xl text-[#E7CA96] sm:text-6xl"></i>

            <span class="mt-3 text-center text-[7px] font-bold uppercase tracking-[0.2em] text-[#F6E9D5] sm:text-[9px]">
              Enter The Game
            </span>
          </div>
        </div>

        <!-- Four Balanced Gaming Cards -->
        <div class="absolute inset-0 z-10">

          <!-- Card 1: Scratch & Win -->
          <div
            class="group absolute left-0 top-[5%] w-[44%] max-w-[225px] -rotate-3 overflow-hidden rounded-2xl border border-[#E7CA96]/25 bg-gradient-to-br from-[#25101D]/95 to-[#10080F]/95 p-3 shadow-[0_15px_50px_rgba(0,0,0,.4)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:rotate-0 hover:border-[#E7CA96]/60 sm:left-[2%] sm:top-[7%] sm:p-5">

            <div class="absolute right-0 top-0 h-20 w-20 rounded-full bg-[#9B0F3B]/25 blur-2xl"></div>

            <div class="relative mb-3 flex items-center justify-between sm:mb-4">
              <div class="flex h-9 w-9 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#9B0F3B]/30 text-[#E7CA96] sm:h-11 sm:w-11">
                <i class="fas fa-ticket-alt text-lg"></i>
              </div>

              <span class="rounded-full border border-white/[0.08] px-2 py-1 text-[8px] font-bold tracking-wider text-slate-400">
                01
              </span>
            </div>

            <p class="relative text-xs font-black text-[#F6E9D5] sm:text-base">
              Scratch & Win
            </p>

            <p class="relative mt-1.5 text-[9px] leading-4 text-slate-400 sm:text-xs">
              Quick-play adventures
            </p>

            <div class="relative mt-3 h-1 overflow-hidden rounded-full bg-white/[0.08] sm:mt-4">
              <div class="h-full w-2/3 rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
            </div>

            <div class="relative mt-3 flex items-center justify-between">
              <span class="text-[8px] font-bold uppercase tracking-widest text-[#E7CA96]">
                Discover
              </span>
              <i class="fas fa-arrow-right text-[10px] text-[#E7CA96] transition-transform group-hover:translate-x-1"></i>
            </div>
          </div>

          <!-- Card 2: Premium Slots -->
          <div
            class="group absolute right-0 top-[7%] w-[44%] max-w-[225px] rotate-3 overflow-hidden rounded-2xl border border-[#E7CA96]/25 bg-gradient-to-br from-[#25101D]/95 to-[#10080F]/95 p-3 shadow-[0_15px_50px_rgba(0,0,0,.4)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:rotate-0 hover:border-[#E7CA96]/60 sm:right-[2%] sm:top-[9%] sm:p-5">

            <div class="absolute right-0 top-0 h-20 w-20 rounded-full bg-[#C71650]/10 blur-2xl"></div>

            <div class="relative mb-3 flex items-center justify-between sm:mb-4">
              <div class="flex h-9 w-9 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#C71650]/10 text-[#E7CA96] sm:h-11 sm:w-11">
                <i class="fas fa-gem text-lg"></i>
              </div>

              <span class="rounded-full border border-white/[0.08] px-2 py-1 text-[8px] font-bold tracking-wider text-slate-400">
                02
              </span>
            </div>

            <p class="relative text-xs font-black text-[#F6E9D5] sm:text-base">
              Premium Slots
            </p>

            <p class="relative mt-1.5 text-[9px] leading-4 text-slate-400 sm:text-xs">
              Find your next favorite
            </p>

            <div class="relative mt-3 h-1 overflow-hidden rounded-full bg-white/[0.08] sm:mt-4">
              <div class="h-full w-4/5 rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
            </div>

            <div class="relative mt-3 flex items-center justify-between">
              <span class="text-[8px] font-bold uppercase tracking-widest text-[#E7CA96]">
                Explore
              </span>
              <i class="fas fa-arrow-right text-[10px] text-[#E7CA96] transition-transform group-hover:translate-x-1"></i>
            </div>
          </div>

          <!-- Card 3: Fortune Wheels -->
          <div
            class="group absolute bottom-[7%] left-0 w-[44%] max-w-[225px] rotate-3 overflow-hidden rounded-2xl border border-[#E7CA96]/25 bg-gradient-to-br from-[#25101D]/95 to-[#10080F]/95 p-3 shadow-[0_15px_50px_rgba(0,0,0,.4)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:rotate-0 hover:border-[#E7CA96]/60 sm:bottom-[8%] sm:left-[2%] sm:p-5">

            <div class="absolute right-0 top-0 h-20 w-20 rounded-full bg-[#9B0F3B]/25 blur-2xl"></div>

            <div class="relative mb-3 flex items-center justify-between sm:mb-4">
              <div class="flex h-9 w-9 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#9B0F3B]/30 text-[#E7CA96] sm:h-11 sm:w-11">
                <i class="fas fa-dharmachakra text-lg"></i>
              </div>

              <span class="rounded-full border border-white/[0.08] px-2 py-1 text-[8px] font-bold tracking-wider text-slate-400">
                03
              </span>
            </div>

            <p class="relative text-xs font-black text-[#F6E9D5] sm:text-base">
              Fortune Wheels
            </p>

            <p class="relative mt-1.5 text-[9px] leading-4 text-slate-400 sm:text-xs">
              Spin into the action
            </p>

            <div class="relative mt-3 h-1 overflow-hidden rounded-full bg-white/[0.08] sm:mt-4">
              <div class="h-full w-3/4 rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
            </div>

            <div class="relative mt-3 flex items-center justify-between">
              <span class="text-[8px] font-bold uppercase tracking-widest text-[#E7CA96]">
                Spin
              </span>
              <i class="fas fa-arrow-right text-[10px] text-[#E7CA96] transition-transform group-hover:translate-x-1"></i>
            </div>
          </div>

          <!-- Card 4: Game Zone -->
          <div
            class="group absolute bottom-[5%] right-0 w-[44%] max-w-[225px] -rotate-3 overflow-hidden rounded-2xl border border-[#E7CA96]/25 bg-gradient-to-br from-[#25101D]/95 to-[#10080F]/95 p-3 shadow-[0_15px_50px_rgba(0,0,0,.4)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:rotate-0 hover:border-[#E7CA96]/60 sm:bottom-[6%] sm:right-[2%] sm:p-5">

            <div class="absolute right-0 top-0 h-20 w-20 rounded-full bg-[#C71650]/10 blur-2xl"></div>

            <div class="relative mb-3 flex items-center justify-between sm:mb-4">
              <div class="flex h-9 w-9 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#C71650]/10 text-[#E7CA96] sm:h-11 sm:w-11">
                <i class="fas fa-gamepad text-lg"></i>
              </div>

              <span class="rounded-full border border-white/[0.08] px-2 py-1 text-[8px] font-bold tracking-wider text-slate-400">
                04
              </span>
            </div>

            <p class="relative text-xs font-black text-[#F6E9D5] sm:text-base">
              Game Zone
            </p>

            <p class="relative mt-1.5 text-[9px] leading-4 text-slate-400 sm:text-xs">
              Your next adventure
            </p>

            <div class="relative mt-3 h-1 overflow-hidden rounded-full bg-white/[0.08] sm:mt-4">
              <div class="h-full w-full rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
            </div>

            <div class="relative mt-3 flex items-center justify-between">
              <span class="text-[8px] font-bold uppercase tracking-widest text-[#E7CA96]">
                Play
              </span>
              <i class="fas fa-arrow-right text-[10px] text-[#E7CA96] transition-transform group-hover:translate-x-1"></i>
            </div>
          </div>

        </div>

        <!-- Portal Glow -->
        <div class="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-52 w-52 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#9B0F3B]/25 blur-[80px]"></div>

      </div>
    </div>

    <!-- Benefits Section -->
    <div class="mt-10 grid grid-cols-1 gap-3 border-t border-white/[0.08] pt-7 sm:grid-cols-3 sm:gap-5 lg:mt-14">

      <div class="flex items-center gap-4 rounded-2xl border border-white/[0.06] bg-white/[0.02] p-4 transition hover:border-[#E7CA96]/20 hover:bg-[#9B0F3B]/10">
        <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#9B0F3B]/25 text-[#E7CA96]">
          <i class="fas fa-shield-alt text-lg"></i>
        </div>

        <div>
          <p class="text-xs font-bold text-white">Fair Play Principles</p>
          <p class="mt-1 text-[10px] text-slate-500">Verification where supported</p>
        </div>
      </div>

      <div class="flex items-center gap-4 rounded-2xl border border-white/[0.06] bg-white/[0.02] p-4 transition hover:border-[#E7CA96]/20 hover:bg-[#9B0F3B]/10">
        <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#9B0F3B]/25 text-[#E7CA96]">
          <i class="fas fa-bolt text-lg"></i>
        </div>

        <div>
          <p class="text-xs font-bold text-white">Fast-Paced Entertainment</p>
          <p class="mt-1 text-[10px] text-slate-500">Jump straight into the action</p>
        </div>
      </div>

      <div class="flex items-center gap-4 rounded-2xl border border-white/[0.06] bg-white/[0.02] p-4 transition hover:border-[#E7CA96]/20 hover:bg-[#9B0F3B]/10">
        <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#9B0F3B]/25 text-[#F6E9D5]">
          <i class="fas fa-headset text-lg"></i>
        </div>

        <div>
          <p class="text-xs font-bold text-white">Help When You Need It</p>
          <p class="mt-1 text-[10px] text-slate-500">Support information available</p>
        </div>
      </div>

    </div>

    <!-- Responsible Play -->
    <p class="mt-6 text-center text-[10px] leading-5 text-slate-600">
      18+ only. Play responsibly. Availability and promotions may vary by location.
    </p>

  </div>
</section>




<!-- =========================================================================
     03. PREMIUM PERFORMANCE METRICS
     Original burgundy / rose-gold palette preserved
     Angular + Tailwind CSS
     ========================================================================= -->

<section class="relative isolate overflow-hidden border-y border-white/[0.08] bg-[#070306] py-14 sm:py-16 lg:py-20">

  <!-- Ambient Background Glow -->
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
    <div class="absolute -top-24 left-1/2 h-56 w-[500px] -translate-x-1/2 rounded-full bg-[#9B0F3B]/20 blur-[110px]"></div>
    <div class="absolute -bottom-28 right-[-5%] h-64 w-64 rounded-full bg-[#C71650]/[0.07] blur-[100px]"></div>
    <div class="absolute bottom-0 left-[-5%] h-56 w-56 rounded-full bg-[#4D0A24]/20 blur-[100px]"></div>
  </div>

  <div class="relative z-10 mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-12">

    <!-- Section Heading -->
    <div class="mb-9 text-center sm:mb-12">

      <div class="mb-4 inline-flex items-center gap-3">
        <span class="h-px w-7 bg-[#C71650]/70"></span>

        <span class="text-[10px] font-bold uppercase tracking-[0.28em] text-[#E7CA96] sm:text-xs">
          The Numbers Behind The Experience
        </span>

        <span class="h-px w-7 bg-[#C71650]/70"></span>
      </div>

      <h2 class="text-2xl font-black tracking-tight text-[#F6E9D5] sm:text-3xl lg:text-4xl">
        Built For The <span class="bg-gradient-to-r from-[#E7CA96] to-[#C72A69] bg-clip-text text-transparent">Experience.</span>
      </h2>

      <p class="mx-auto mt-3 max-w-xl text-xs leading-6 text-slate-400 sm:text-sm">
        A closer look at the numbers that define our gaming platform.
      </p>

    </div>

    <!-- Metrics Grid -->
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">

      <!-- Metric 1: Players -->
      <div class="group relative flex min-h-[205px] flex-col items-center justify-center overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-b from-[#180B16]/90 to-[#0D070C]/95 p-6 text-center shadow-[0_12px_35px_rgba(0,0,0,.18)] transition-all duration-300 hover:-translate-y-1 hover:border-[#E7CA96]/40 hover:shadow-[0_15px_40px_rgba(107,15,51,.16)] sm:min-h-[225px]">

        <div class="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-[#9B0F3B]/20 blur-3xl transition-colors duration-300 group-hover:bg-[#9B0F3B]/40"></div>

        <div class="relative mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#9B0F3B]/20 text-[#E7CA96] shadow-[0_0_25px_rgba(107,15,51,.12)] transition-all duration-300 group-hover:scale-110 group-hover:border-[#E7CA96]/40 sm:h-14 sm:w-14">
          <i class="fas fa-users text-lg sm:text-xl"></i>
        </div>

        <h3 class="relative text-3xl font-black tracking-tight text-[#F6E9D5] sm:text-4xl">
          25,000<span class="text-[#E7CA96]">+</span>
        </h3>

        <p class="relative mt-2 text-xs font-semibold text-slate-300 sm:text-sm">
          Verified Players Worldwide
        </p>

        <div class="relative mt-4 h-1 w-12 overflow-hidden rounded-full bg-white/10 transition-all duration-300 group-hover:w-20">
          <div class="h-full w-full rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
        </div>

        <span class="absolute right-4 top-4 text-[9px] font-bold tracking-widest text-white/20">
          01
        </span>
      </div>

      <!-- Metric 2: Games -->
      <div class="group relative flex min-h-[205px] flex-col items-center justify-center overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-b from-[#180B16]/90 to-[#0D070C]/95 p-6 text-center shadow-[0_12px_35px_rgba(0,0,0,.18)] transition-all duration-300 hover:-translate-y-1 hover:border-[#E7CA96]/40 hover:shadow-[0_15px_40px_rgba(107,15,51,.16)] sm:min-h-[225px]">

        <div class="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-[#C71650]/[0.06] blur-3xl transition-colors duration-300 group-hover:bg-[#C71650]/15"></div>

        <div class="relative mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#C71650]/[0.08] text-[#E7CA96] transition-all duration-300 group-hover:scale-110 group-hover:border-[#E7CA96]/40 sm:h-14 sm:w-14">
          <i class="fas fa-gamepad text-lg sm:text-xl"></i>
        </div>

        <h3 class="relative text-3xl font-black tracking-tight text-[#F6E9D5] sm:text-4xl">
          150<span class="text-[#E7CA96]">+</span>
        </h3>

        <p class="relative mt-2 text-xs font-semibold text-slate-300 sm:text-sm">
          Premium Games
        </p>

        <div class="relative mt-4 h-1 w-12 overflow-hidden rounded-full bg-white/10 transition-all duration-300 group-hover:w-20">
          <div class="h-full w-full rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
        </div>

        <span class="absolute right-4 top-4 text-[9px] font-bold tracking-widest text-white/20">
          02
        </span>
      </div>

      <!-- Metric 3: Prizes -->
      <div class="group relative flex min-h-[205px] flex-col items-center justify-center overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-b from-[#180B16]/90 to-[#0D070C]/95 p-6 text-center shadow-[0_12px_35px_rgba(0,0,0,.18)] transition-all duration-300 hover:-translate-y-1 hover:border-[#E7CA96]/40 hover:shadow-[0_15px_40px_rgba(107,15,51,.16)] sm:min-h-[225px]">

        <div class="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-[#E7CA96]/[0.06] blur-3xl transition-colors duration-300 group-hover:bg-[#E7CA96]/15"></div>

        <div class="relative mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#E7CA96]/[0.08] text-[#E7CA96] transition-all duration-300 group-hover:scale-110 group-hover:border-[#E7CA96]/40 sm:h-14 sm:w-14">
          <i class="fas fa-trophy text-lg sm:text-xl"></i>
        </div>

        <h3 class="relative text-3xl font-black tracking-tight text-[#F6E9D5] sm:text-4xl">
          $2.8M<span class="text-[#E7CA96]">+</span>
        </h3>

        <p class="relative mt-2 text-xs font-semibold text-slate-300 sm:text-sm">
          Prizes Distributed
        </p>

        <div class="relative mt-4 h-1 w-12 overflow-hidden rounded-full bg-white/10 transition-all duration-300 group-hover:w-20">
          <div class="h-full w-full rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
        </div>

        <span class="absolute right-4 top-4 text-[9px] font-bold tracking-widest text-white/20">
          03
        </span>
      </div>

      <!-- Metric 4: Uptime -->
      <div class="group relative flex min-h-[205px] flex-col items-center justify-center overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-b from-[#180B16]/90 to-[#0D070C]/95 p-6 text-center shadow-[0_12px_35px_rgba(0,0,0,.18)] transition-all duration-300 hover:-translate-y-1 hover:border-[#E7CA96]/40 hover:shadow-[0_15px_40px_rgba(107,15,51,.16)] sm:min-h-[225px]">

        <div class="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-[#9B0F3B]/20 blur-3xl transition-colors duration-300 group-hover:bg-[#9B0F3B]/40"></div>

        <div class="relative mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-[#E7CA96]/20 bg-[#9B0F3B]/20 text-[#F6E9D5] transition-all duration-300 group-hover:scale-110 group-hover:border-[#E7CA96]/40 sm:h-14 sm:w-14">
          <i class="fas fa-check-circle text-lg sm:text-xl"></i>
        </div>

        <h3 class="relative text-3xl font-black tracking-tight text-[#F6E9D5] sm:text-4xl">
          99.9<span class="text-[#E7CA96]">%</span>
        </h3>

        <p class="relative mt-2 text-xs font-semibold text-slate-300 sm:text-sm">
          Platform Uptime
        </p>

        <div class="relative mt-4 h-1 w-12 overflow-hidden rounded-full bg-white/10 transition-all duration-300 group-hover:w-20">
          <div class="h-full w-full rounded-full bg-gradient-to-r from-[#9B0F3B] to-[#C71650]"></div>
        </div>

        <span class="absolute right-4 top-4 text-[9px] font-bold tracking-widest text-white/20">
          04
        </span>
      </div>

    </div>

    <!-- Footer Note -->
    <p class="mt-6 text-center text-[10px] leading-5 text-slate-500">
      Platform statistics should reflect verified and up-to-date information.
    </p>

  </div>
</section>



<!-- 04. LIVE RECENT WINNERS TICKER RIBBON -->
<app-top-winners></app-top-winners>


<!-- =========================================================================
     05. GAMES ARENA SHOWCASE
     ========================================================================= -->
<section id="gameScrollSection" class="bg-[#030204] py-16 sm:py-20 relative">
  <div class="max-w-[1600px] mx-auto px-4 sm:px-8 mb-8">
    <div
      class="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 border-b border-white/10 pb-6"
    >
      <div>
        <div
          class="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#9B0F3B]/35 border border-[#E7CA96]/25 text-[#E7CA96] text-xs font-bold tracking-wider uppercase mb-2.5 shadow-sm"
        >
          <i class="fas fa-fire text-[#E7CA96]"></i>
          Explore Game Catalog
        </div>
        <h2 class="text-white font-black text-2xl sm:text-3xl lg:text-4xl tracking-tight">
          Trending Games, <span class="text-slate-400 font-normal">Real Cash Rewards</span>
        </h2>
      </div>

      <button (click)="RedirectToSignUp()" class="cyber-shimmer-btn px-5 py-2.5 rounded-xl text-xs font-black text-white bg-gradient-to-r from-[#680825] via-[#9B0F3B] to-[#C71650] hover:brightness-115 shadow-md shadow-[#C71650]/35 transition flex items-center gap-2">
        <span>View All Games</span>
        <i class="fas fa-arrow-right text-[10px]"></i>
      </button>
    </div>
  </div>

  <app-games-landing></app-games-landing>
</section>



<!-- =========================================================
     LUCKYCREST — SIGNATURE LUXURY EXPERIENCE
     Tailwind CSS + Font Awesome
     ========================================================= -->

<section class="relative isolate overflow-hidden bg-[#030204] py-24 sm:py-32 lg:py-36">

  <!-- CINEMATIC BACKGROUND -->
  <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(199, 22, 80,0.22),transparent_50%),radial-gradient(ellipse_at_100%_80%,rgba(231, 202, 150,0.08),transparent_35%)]"></div>

  <div class="pointer-events-none absolute -left-52 top-32 h-[500px] w-[500px] rounded-full bg-[#C71650]/20 blur-[170px]"></div>
  <div class="pointer-events-none absolute -right-52 top-1/3 h-[500px] w-[500px] rounded-full bg-[#B82A62]/15 blur-[170px]"></div>

  <!-- Subtle grid -->
  <div class="pointer-events-none absolute inset-0 opacity-[0.12] [background-image:linear-gradient(rgba(231, 202, 150,0.12)_1px,transparent_1px),linear-gradient(90deg,rgba(231, 202, 150,0.12)_1px,transparent_1px)] [background-size:72px_72px] [mask-image:linear-gradient(to_bottom,black,transparent_85%)]"></div>

  <!-- Decorative orbital rings -->
  <div class="pointer-events-none absolute left-1/2 top-[-430px] h-[720px] w-[1100px] -translate-x-1/2 rounded-[50%] border border-[#E7CA96]/10"></div>
  <div class="pointer-events-none absolute left-1/2 top-[-390px] h-[640px] w-[940px] -translate-x-1/2 rounded-[50%] border border-[#B82A62]/10"></div>

  <div class="relative z-10 mx-auto max-w-[1480px] px-4 sm:px-8 lg:px-12">

    <!-- =====================================================
         PREMIUM SECTION HEADER
         ===================================================== -->

    <div class="mb-16 grid items-end gap-8 lg:mb-20 lg:grid-cols-[1fr_auto]">

      <div class="max-w-4xl">

        <div class="mb-7 inline-flex items-center gap-3">
          <span class="h-px w-10 bg-gradient-to-r from-transparent to-[#E7CA96]"></span>

          <span class="text-[10px] font-bold uppercase tracking-[0.38em] text-[#E7CA96] sm:text-xs">
            The Luckycrest Standard
          </span>

          <span class="h-px w-10 bg-gradient-to-l from-transparent to-[#E7CA96]"></span>
        </div>

        <h2 class="font-serif text-4xl font-bold leading-[1.1] tracking-[-0.035em] text-[#FAF4EB] sm:text-6xl lg:text-7xl">
          Not Just A Game.
          <span class="mt-3 block bg-gradient-to-r from-[#B82A62] via-[#FFBBA3] to-[#F6E9D5] bg-clip-text pb-2 text-transparent">
            An Entire Experience.
          </span>
        </h2>

        <p class="mt-7 max-w-2xl text-sm leading-8 text-[#C2ABA3] sm:text-base">
          Every detail is designed to elevate your journey — from a refined
          gaming experience to personalized rewards and security-conscious
          technology.
        </p>

      </div>

      <!-- Brand signature panel -->
      <div class="relative hidden min-w-[235px] overflow-hidden rounded-2xl border border-[#E7CA96]/20 bg-gradient-to-br from-[#29101D]/90 to-[#070306]/90 p-5 backdrop-blur-xl lg:block">

        <div class="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#B82A62]/20 blur-2xl"></div>

        <div class="relative flex items-center gap-4">
          <div class="flex h-14 w-14 items-center justify-center rounded-xl border border-[#E7CA96]/30 bg-[#C71650]/20 shadow-[0_0_25px_rgba(184,42,98,0.12)]">
            <i class="fas fa-gem text-2xl text-[#E7CA96]"></i>
          </div>

          <div>
            <p class="font-serif text-lg font-bold tracking-wide text-[#FAF4EB]">
              LUCKYCREST
            </p>
            <p class="mt-1 text-[9px] uppercase tracking-[0.25em] text-[#C2ABA3]">
              Crafted to stand apart
            </p>
          </div>
        </div>

        <div class="mt-5 h-px bg-gradient-to-r from-[#E7CA96]/50 via-[#C71650]/30 to-transparent"></div>

        <p class="mt-4 text-xs leading-5 text-[#C2ABA3]">
          A distinctive standard of digital entertainment.
        </p>

      </div>

    </div>

    <!-- =====================================================
         FEATURE SHOWCASE
         ===================================================== -->

    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">

      <!-- FEATURE 01 -->
      <article class="group relative isolate min-w-0 overflow-hidden rounded-[1.75rem] border border-[#E7CA96]/25 bg-[#11080F] transition-all duration-500 hover:-translate-y-2 hover:border-[#FFAC96]/70 hover:shadow-[0_30px_80px_rgba(199, 22, 80,0.22)]">

        <!-- Card lighting -->
        <div class="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-br from-[#C71650]/25 via-transparent to-transparent opacity-80"></div>
        <div class="pointer-events-none absolute -right-20 -top-20 -z-10 h-56 w-56 rounded-full bg-[#B82A62]/20 blur-[80px] transition-all duration-500 group-hover:bg-[#B82A62]/35"></div>

        <!-- Top label -->
        <div class="flex items-center justify-between px-6 pt-6 sm:px-7">
          <span class="font-serif text-4xl text-[#E7CA96]/70">01</span>
          <span class="rounded-full border border-[#E7CA96]/25 bg-[#120810]/80 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.2em] text-[#E7CA96]">
            Performance
          </span>
        </div>

        <!-- Signature icon stage -->
        <div class="relative mx-auto my-8 flex h-40 items-center justify-center overflow-hidden">

          <div class="absolute h-36 w-36 rounded-full border border-[#E7CA96]/15"></div>
          <div class="absolute h-28 w-28 rounded-full border border-[#B82A62]/25"></div>

          <div class="absolute h-24 w-24 rotate-45 rounded-[1.4rem] border border-[#E7CA96]/30 bg-gradient-to-br from-[#68213D]/60 via-[#120810] to-black shadow-[0_0_40px_rgba(184,42,98,0.18),inset_0_0_20px_rgba(231, 202, 150,0.08)] transition-transform duration-700 group-hover:rotate-[135deg]"></div>

          <div class="absolute h-[68px] w-[68px] rounded-2xl border border-[#F6E9D5]/40 bg-gradient-to-br from-[#E7CA96]/20 to-[#0D070C]"></div>

          <i class="fas fa-bolt relative z-10 text-4xl text-[#FFD6AE] drop-shadow-[0_0_16px_rgba(255,172,150,0.65)] transition-transform duration-500 group-hover:scale-125"></i>

          <div class="absolute bottom-3 left-0 h-px w-full bg-gradient-to-r from-transparent via-[#E7CA96]/30 to-transparent"></div>

        </div>

        <!-- Content -->
        <div class="px-6 pb-7 sm:px-7">

          <p class="mb-3 text-[9px] font-bold uppercase tracking-[0.25em] text-[#E7CA96]">
            Seamless transactions
          </p>

          <h3 class="font-serif text-2xl font-bold leading-tight text-[#FAF4EB]">
            Instant Cashouts
          </h3>

          <p class="mt-4 min-h-[96px] text-sm leading-7 text-[#C2ABA3]">
            Experience streamlined withdrawal options and a convenient
            payment journey through supported methods.
          </p>

          <div class="mt-6 flex items-center justify-between border-t border-white/[0.08] pt-5">
            <span class="text-[9px] uppercase tracking-[0.16em] text-[#A88E99]">
              Built around speed
            </span>

            <span class="flex h-9 w-9 items-center justify-center rounded-full border border-[#E7CA96]/40 text-[#E7CA96] transition-all duration-300 group-hover:border-[#E7CA96] group-hover:bg-[#C71650] group-hover:text-[#070306]">
              <i class="fas fa-arrow-right text-xs"></i>
            </span>
          </div>

        </div>

        <div class="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-[#C71650] via-[#FFAC96] to-transparent shadow-[0_0_15px_#E7CA96] transition-all duration-700 group-hover:w-full"></div>

      </article>

      <!-- FEATURE 02 -->
      <article class="group relative isolate min-w-0 overflow-hidden rounded-[1.75rem] border border-[#E7CA96]/20 bg-[#11080F] transition-all duration-500 hover:-translate-y-2 hover:border-[#F6E9D5]/60 hover:shadow-[0_30px_80px_rgba(231, 202, 150,0.14)]">

        <div class="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-br from-[#F6E9D5]/[0.08] via-transparent to-transparent"></div>
        <div class="pointer-events-none absolute -right-20 -top-20 -z-10 h-56 w-56 rounded-full bg-[#C71650]/15 blur-[80px] transition-all duration-500 group-hover:bg-[#C71650]/30"></div>

        <div class="flex items-center justify-between px-6 pt-6 sm:px-7">
          <span class="font-serif text-4xl text-[#F6E9D5]/70">02</span>
          <span class="rounded-full border border-[#F6E9D5]/20 bg-[#120810]/80 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.2em] text-[#F6E9D5]">
            Benefits
          </span>
        </div>

        <div class="relative mx-auto my-8 flex h-40 items-center justify-center overflow-hidden">

          <div class="absolute h-36 w-36 rounded-full border border-[#F6E9D5]/15"></div>
          <div class="absolute h-28 w-28 rounded-full border border-[#E7CA96]/25"></div>

          <div class="absolute h-24 w-24 rotate-45 rounded-[1.4rem] border border-[#F6E9D5]/30 bg-gradient-to-br from-[#6A4435]/50 via-[#120810] to-black shadow-[0_0_40px_rgba(231, 202, 150,0.13),inset_0_0_20px_rgba(246,233,213,0.08)] transition-transform duration-700 group-hover:rotate-[135deg]"></div>

          <div class="absolute h-[68px] w-[68px] rounded-2xl border border-[#F6E9D5]/40 bg-gradient-to-br from-[#F6E9D5]/15 to-[#0D070C]"></div>

          <i class="fas fa-trophy relative z-10 text-4xl text-[#F6D6A5] drop-shadow-[0_0_16px_rgba(246,233,213,0.5)] transition-transform duration-500 group-hover:scale-125"></i>

          <div class="absolute bottom-3 left-0 h-px w-full bg-gradient-to-r from-transparent via-[#F6E9D5]/25 to-transparent"></div>

        </div>

        <div class="px-6 pb-7 sm:px-7">

          <p class="mb-3 text-[9px] font-bold uppercase tracking-[0.25em] text-[#E7CA96]">
            More ways to enjoy
          </p>

          <h3 class="font-serif text-2xl font-bold leading-tight text-[#FAF4EB]">
            Play To Earn
          </h3>

          <p class="mt-4 min-h-[96px] text-sm leading-7 text-[#C2ABA3]">
            Explore eligible tier points, promotional rewards, and
            exclusive benefits designed for participating players.
          </p>

          <div class="mt-6 flex items-center justify-between border-t border-white/[0.08] pt-5">
            <span class="text-[9px] uppercase tracking-[0.16em] text-[#A88E99]">
              Rewards &amp; perks
            </span>

            <span class="flex h-9 w-9 items-center justify-center rounded-full border border-[#F6E9D5]/35 text-[#F6E9D5] transition-all duration-300 group-hover:border-[#F6E9D5] group-hover:bg-[#F6E9D5] group-hover:text-[#070306]">
              <i class="fas fa-arrow-right text-xs"></i>
            </span>
          </div>

        </div>

        <div class="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-[#F6E9D5] via-[#E7CA96] to-transparent shadow-[0_0_15px_#E7CA96] transition-all duration-700 group-hover:w-full"></div>

      </article>

      <!-- FEATURE 03 -->
      <article class="group relative isolate min-w-0 overflow-hidden rounded-[1.75rem] border border-[#B82A62]/30 bg-[#11080F] transition-all duration-500 hover:-translate-y-2 hover:border-[#FFAC96]/70 hover:shadow-[0_30px_80px_rgba(199, 22, 80,0.22)]">

        <div class="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-br from-[#C71650]/20 via-transparent to-transparent"></div>
        <div class="pointer-events-none absolute -right-20 -top-20 -z-10 h-56 w-56 rounded-full bg-[#B82A62]/20 blur-[80px] transition-all duration-500 group-hover:bg-[#B82A62]/35"></div>

        <div class="flex items-center justify-between px-6 pt-6 sm:px-7">
          <span class="font-serif text-4xl text-[#E7CA96]/70">03</span>
          <span class="rounded-full border border-[#B82A62]/35 bg-[#120810]/80 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.2em] text-[#E7CA96]">
            Protection
          </span>
        </div>

        <div class="relative mx-auto my-8 flex h-40 items-center justify-center overflow-hidden">

          <div class="absolute h-36 w-36 rounded-full border border-[#E7CA96]/15"></div>
          <div class="absolute h-28 w-28 rounded-full border border-[#B82A62]/30"></div>

          <div class="absolute h-24 w-24 rotate-45 rounded-[1.4rem] border border-[#E7CA96]/30 bg-gradient-to-br from-[#68213D]/60 via-[#120810] to-black shadow-[0_0_40px_rgba(184,42,98,0.18),inset_0_0_20px_rgba(231, 202, 150,0.08)] transition-transform duration-700 group-hover:rotate-[135deg]"></div>

          <div class="absolute h-[68px] w-[68px] rounded-2xl border border-[#E7CA96]/40 bg-gradient-to-br from-[#B82A62]/20 to-[#0D070C]"></div>

          <i class="fas fa-shield-alt relative z-10 text-4xl text-[#FFAC96] drop-shadow-[0_0_16px_rgba(255,172,150,0.55)] transition-transform duration-500 group-hover:scale-125"></i>

          <div class="absolute bottom-3 left-0 h-px w-full bg-gradient-to-r from-transparent via-[#B82A62]/40 to-transparent"></div>

        </div>

        <div class="px-6 pb-7 sm:px-7">

          <p class="mb-3 text-[9px] font-bold uppercase tracking-[0.25em] text-[#E7CA96]">
            Trust by design
          </p>

          <h3 class="font-serif text-2xl font-bold leading-tight text-[#FAF4EB]">
            Fair &amp; Encrypted
          </h3>

          <p class="mt-4 min-h-[96px] text-sm leading-7 text-[#C2ABA3]">
            A security-conscious platform experience focused on data
            protection and transparent game mechanics where supported.
          </p>

          <div class="mt-6 flex items-center justify-between border-t border-white/[0.08] pt-5">
            <span class="text-[9px] uppercase tracking-[0.16em] text-[#A88E99]">
              Security first
            </span>

            <span class="flex h-9 w-9 items-center justify-center rounded-full border border-[#E7CA96]/40 text-[#FFAC96] transition-all duration-300 group-hover:border-[#E7CA96] group-hover:bg-[#C71650] group-hover:text-[#070306]">
              <i class="fas fa-arrow-right text-xs"></i>
            </span>
          </div>

        </div>

        <div class="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-[#C71650] via-[#FFAC96] to-transparent shadow-[0_0_15px_#E7CA96] transition-all duration-700 group-hover:w-full"></div>

      </article>

      <!-- FEATURE 04 -->
      <article class="group relative isolate min-w-0 overflow-hidden rounded-[1.75rem] border border-[#B82A62]/30 bg-[#11080F] transition-all duration-500 hover:-translate-y-2 hover:border-[#FFAC96]/70 hover:shadow-[0_30px_80px_rgba(184,42,98,0.25)]">

        <div class="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-br from-[#B82A62]/20 via-transparent to-transparent"></div>
        <div class="pointer-events-none absolute -right-20 -top-20 -z-10 h-56 w-56 rounded-full bg-[#B82A62]/20 blur-[80px] transition-all duration-500 group-hover:bg-[#B82A62]/40"></div>

        <div class="flex items-center justify-between px-6 pt-6 sm:px-7">
          <span class="font-serif text-4xl text-[#E7CA96]/70">04</span>
          <span class="rounded-full border border-[#B82A62]/35 bg-[#120810]/80 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.2em] text-[#E7CA96]">
            Exclusivity
          </span>
        </div>

        <div class="relative mx-auto my-8 flex h-40 items-center justify-center overflow-hidden">

          <div class="absolute h-36 w-36 rounded-full border border-[#E7CA96]/15"></div>
          <div class="absolute h-28 w-28 rounded-full border border-[#B82A62]/30"></div>

          <div class="absolute h-24 w-24 rotate-45 rounded-[1.4rem] border border-[#E7CA96]/30 bg-gradient-to-br from-[#68213D]/60 via-[#120810] to-black shadow-[0_0_40px_rgba(184,42,98,0.2),inset_0_0_20px_rgba(231, 202, 150,0.08)] transition-transform duration-700 group-hover:rotate-[135deg]"></div>

          <div class="absolute h-[68px] w-[68px] rounded-2xl border border-[#E7CA96]/40 bg-gradient-to-br from-[#B82A62]/20 to-[#0D070C]"></div>

          <i class="fas fa-crown relative z-10 text-4xl text-[#FFAC96] drop-shadow-[0_0_16px_rgba(255,172,150,0.6)] transition-transform duration-500 group-hover:scale-125"></i>

          <div class="absolute bottom-3 left-0 h-px w-full bg-gradient-to-r from-transparent via-[#B82A62]/40 to-transparent"></div>

        </div>

        <div class="px-6 pb-7 sm:px-7">

          <p class="mb-3 text-[9px] font-bold uppercase tracking-[0.25em] text-[#E7CA96]">
            A class of your own
          </p>

          <h3 class="font-serif text-2xl font-bold leading-tight text-[#FAF4EB]">
            VIP Club Rewards
          </h3>

          <p class="mt-4 min-h-[96px] text-sm leading-7 text-[#C2ABA3]">
            Discover member promotions, eligible cashback offers,
            personalized benefits, and priority support options.
          </p>

          <div class="mt-6 flex items-center justify-between border-t border-white/[0.08] pt-5">
            <span class="text-[9px] uppercase tracking-[0.16em] text-[#A88E99]">
              The VIP experience
            </span>

            <span class="flex h-9 w-9 items-center justify-center rounded-full border border-[#B82A62]/50 text-[#FFAC96] transition-all duration-300 group-hover:border-[#FFAC96] group-hover:bg-[#B82A62] group-hover:text-white">
              <i class="fas fa-arrow-right text-xs"></i>
            </span>
          </div>

        </div>

        <div class="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-[#B82A62] via-[#FFAC96] to-transparent shadow-[0_0_15px_#B82A62] transition-all duration-700 group-hover:w-full"></div>

      </article>

    </div>

    <!-- =====================================================
         PREMIUM BOTTOM SIGNATURE
         ===================================================== -->

    <div class="mt-16 flex flex-col items-center justify-center sm:mt-20">

      <div class="flex items-center gap-4">
        <span class="h-px w-12 bg-gradient-to-r from-transparent to-[#B82A62] sm:w-24"></span>
        <i class="fas fa-gem text-lg text-[#E7CA96] drop-shadow-[0_0_12px_rgba(231, 202, 150,0.4)]"></i>
        <span class="h-px w-12 bg-gradient-to-l from-transparent to-[#B82A62] sm:w-24"></span>
      </div>

      <p class="mt-5 text-center text-[9px] font-semibold uppercase tracking-[0.35em] text-[#A88E99] sm:text-[10px]">
        The Art of a Better Experience
      </p>

    </div>

  </div>
</section>








<!-- LUCKYCREST — GOLDEN ORBIT EXPERIENCE -->
<section id="spinnerScrollSection"
  class="relative isolate overflow-hidden bg-[#030204] text-[#F6E9D5]">

  <style>
    #spinnerScrollSection .lc-orbit {
      animation: lcOrbit 24s linear infinite;
    }

    #spinnerScrollSection .lc-orbit-reverse {
      animation: lcOrbit 32s linear infinite reverse;
    }

    #spinnerScrollSection .lc-wheel-frame {
      animation: lcGlow 4s ease-in-out infinite;
    }

    #spinnerScrollSection .lc-particle {
      animation: lcFloat 6s ease-in-out infinite;
    }

    #spinnerScrollSection .lc-particle:nth-child(2) {
      animation-delay: -2s;
    }

    #spinnerScrollSection .lc-particle:nth-child(3) {
      animation-delay: -4s;
    }

    #spinnerScrollSection .lc-cta:hover .lc-arrow {
      transform: translateX(5px);
    }

    @keyframes lcOrbit {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }

    @keyframes lcGlow {
      0%, 100% {
        box-shadow: 0 0 25px rgba(107,15,51,.15),
                    0 0 0 1px rgba(231,202,150,.35);
      }
      50% {
        box-shadow: 0 0 55px rgba(107,15,51,.35),
                    0 0 0 1px rgba(231,202,150,.7);
      }
    }

    @keyframes lcFloat {
      0%, 100% { transform: translateY(0); opacity: .35; }
      50% { transform: translateY(-14px); opacity: 1; }
    }

    @media (prefers-reduced-motion: reduce) {
      #spinnerScrollSection .lc-orbit,
      #spinnerScrollSection .lc-orbit-reverse,
      #spinnerScrollSection .lc-wheel-frame,
      #spinnerScrollSection .lc-particle {
        animation: none;
      }
    }
  </style>

  <!-- ATMOSPHERIC BACKGROUND -->
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
    <div class="absolute left-1/2 top-[-180px] h-[460px] w-[460px]
      -translate-x-1/2 rounded-full bg-[#9B0F3B]/20 blur-[120px]"></div>

    <div class="absolute -right-36 top-[40%] h-96 w-96 rounded-full
      bg-[#4D0A24]/25 blur-[110px]"></div>

    <div class="absolute bottom-[-200px] left-[-120px] h-96 w-96
      rounded-full bg-[#9B0F3B]/15 blur-[100px]"></div>

    <div class="absolute inset-0 opacity-[0.055]"
      style="background-image:radial-gradient(#E7CA96 0.8px,transparent 0.8px);background-size:22px 22px">
    </div>
  </div>

  <div class="mx-auto max-w-[1440px] px-5 py-14 sm:px-8 sm:py-20 lg:px-14 lg:py-24">

    <!-- EDITORIAL HEADER -->
    <div class="flex flex-col justify-between gap-8 border-b border-[#E7CA96]/20 pb-8 md:flex-row md:items-end">

      <div>
        <div class="mb-5 flex items-center gap-3">
          <span class="h-px w-9 bg-[#E7CA96]"></span>
          <span class="text-[10px] font-bold uppercase tracking-[0.38em] text-[#E7CA96]">
            The Luckycrest Collection
          </span>
        </div>

        <h2 class="max-w-3xl text-4xl font-black uppercase leading-[0.98]
          tracking-[-0.055em] sm:text-6xl lg:text-7xl">
          Your moment.<br>
          <span class="font-serif font-normal italic tracking-normal text-[#E7CA96]">
            Your fortune.
          </span>
        </h2>
      </div>

      <div class="flex items-center gap-3 md:pb-2">
        <span class="relative flex h-2.5 w-2.5">
          <span class="absolute inline-flex h-full w-full animate-ping
            rounded-full bg-[#C71650] opacity-50"></span>
          <span class="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#C71650]"></span>
        </span>
        <span class="text-[10px] font-semibold uppercase tracking-[0.25em] text-[#A88E99]">
          The experience awaits
        </span>
      </div>
    </div>

    <!-- MAIN STAGE -->
    <div class="relative grid items-center gap-10 py-12 sm:py-16
      lg:grid-cols-[0.75fr_1.5fr_0.75fr] lg:gap-5 lg:py-20">

      <!-- LEFT EDITORIAL -->
      <div class="relative z-10 order-2 lg:order-1">

        <div class="hidden lg:block">
          <span class="text-[10px] uppercase tracking-[0.32em] text-[#A88E99]">
            01 / The experience
          </span>

          <div class="my-5 h-px w-14 bg-[#E7CA96]/60"></div>

          <h3 class="max-w-[220px] text-3xl font-semibold leading-tight">
            Take a chance
            <span class="font-serif italic text-[#E7CA96]">on luck.</span>
          </h3>

          <p class="mt-5 max-w-[220px] text-sm leading-7 text-[#A88E99]">
            Step into the spotlight and discover what your next spin might bring.
          </p>
        </div>

        <div class="flex items-center justify-between border-y border-[#E7CA96]/15 py-4 lg:mt-12 lg:border-b-0">
          <div>
            <p class="text-[9px] uppercase tracking-[0.25em] text-[#A88E99]">Your next move</p>
            <p class="mt-1 text-sm font-semibold text-[#F6E9D5]">Spin the wheel</p>
          </div>
          <span class="font-serif text-3xl italic text-[#E7CA96]">↗</span>
        </div>
      </div>

      <!-- SIGNATURE WHEEL DISPLAY -->
      <div class="relative order-1 flex min-w-0 items-center justify-center lg:order-2">

        <!-- Ambient wheel glow -->
        <div class="pointer-events-none absolute h-[280px] w-[280px]
          rounded-full bg-[#9B0F3B]/25 blur-[75px] sm:h-[360px] sm:w-[360px]
          lg:h-[420px] lg:w-[420px]"></div>

        <!-- Animated outer orbit -->
        <div class="lc-orbit pointer-events-none absolute h-[290px] w-[290px]
          rounded-full border border-dashed border-[#E7CA96]/25
          sm:h-[400px] sm:w-[400px] lg:h-[490px] lg:w-[490px]">

          <span class="absolute left-1/2 top-[-5px] h-2.5 w-2.5
            -translate-x-1/2 rounded-full bg-[#E7CA96] shadow-[0_0_15px_#E7CA96]"></span>

          <span class="absolute bottom-[16%] left-[7%] h-2 w-2
            rounded-full bg-[#C71650] shadow-[0_0_12px_#E7CA96]"></span>
        </div>

        <!-- Inner orbit -->
        <div class="lc-orbit-reverse pointer-events-none absolute h-[255px] w-[255px]
          rounded-full border border-[#E7CA96]/20 sm:h-[355px] sm:w-[355px]
          lg:h-[440px] lg:w-[440px]">

          <span class="absolute right-[10%] top-[13%] h-2 w-2
            rounded-full bg-[#B82A62]"></span>
        </div>

        <!-- Floating decorative particles -->
        <span class="lc-particle pointer-events-none absolute left-[13%] top-[22%]
          h-1.5 w-1.5 rounded-full bg-[#E7CA96]"></span>

        <span class="lc-particle pointer-events-none absolute right-[12%] top-[30%]
          h-2 w-2 rounded-full bg-[#C71650]"></span>

        <span class="lc-particle pointer-events-none absolute bottom-[18%] right-[18%]
          h-1.5 w-1.5 rounded-full bg-[#E7CA96]"></span>

        <!-- Rotating-style decorative markers -->
        <div class="absolute left-0 top-[12%] z-20 hidden -rotate-90 sm:block lg:left-2">
          <span class="text-[9px] font-bold uppercase tracking-[0.4em] text-[#E7CA96]/80">
            The lucky circle
          </span>
        </div>

        <div class="absolute right-0 top-[16%] z-20 hidden rotate-90 sm:block lg:right-2">
          <span class="text-[9px] font-bold uppercase tracking-[0.4em] text-[#E7CA96]/80">
            Make it count
          </span>
        </div>

        <!-- Wheel housing -->
        <div class="lc-wheel-frame relative z-10 flex aspect-square w-full
          max-w-[420px] items-center justify-center rounded-full
          sm:max-w-[470px]">

          <div class="absolute inset-[3%] rounded-full border border-[#E7CA96]/50"></div>

          <div class="absolute inset-[6%] rounded-full border-[5px]
            border-[#4D0A24] bg-[#0D070C]"></div>

          <div class="absolute inset-[8%] rounded-full border border-[#E7CA96]/25"></div>

          <div class="relative z-10 flex h-[84%] w-[84%] items-center
            justify-center overflow-hidden rounded-full">

            <img
              src="Images/spin.png"
              alt="Luckycrest fortune wheel"
              class="h-full w-full object-contain drop-shadow-[0_0_25px_rgba(231, 202, 150,0.2)]"
            />
          </div>

          <!-- Premium fixed pointer -->
          <div class="absolute left-1/2 top-[0.5%] z-20 -translate-x-1/2">
            <div class="relative flex flex-col items-center">
              <div class="h-0 w-0 border-l-[13px] border-r-[13px]
                border-t-[29px] border-l-transparent border-r-transparent
                border-t-[#E7CA96] drop-shadow-[0_2px_7px_rgba(0,0,0,0.8)]"></div>
              <span class="-mt-1 h-2.5 w-2.5 rounded-full border-2
                border-[#E7CA96] bg-[#4D0A24]"></span>
            </div>
          </div>

          <!-- Wheel signature -->
          <div class="pointer-events-none absolute bottom-[8%] left-1/2
            z-20 -translate-x-1/2 whitespace-nowrap border
            border-[#E7CA96]/35 bg-[#030204]/90 px-4 py-2 backdrop-blur-md">
            <span class="text-[9px] font-bold uppercase tracking-[0.28em] text-[#E7CA96]">
              Feel the fortune
            </span>
          </div>
        </div>
      </div>

      <!-- RIGHT EDITORIAL -->
      <div class="relative z-10 order-3 lg:pl-8">

        <div class="flex items-center gap-3">
          <span class="h-8 w-[2px] bg-[#B82A62]"></span>
          <span class="text-[10px] uppercase tracking-[0.28em] text-[#A88E99]">
            Your lucky moment
          </span>
        </div>

        <h3 class="mt-5 text-3xl font-semibold leading-tight sm:text-4xl">
          One spin.<br>
          <span class="font-serif italic text-[#E7CA96]">Endless possibilities.</span>
        </h3>

        <p class="mt-4 max-w-sm text-sm leading-7 text-[#A88E99]">
          Ready to try your luck? Enter the Luckycrest experience and discover what awaits.
        </p>

        <button
          type="button"
          (click)="RedirectToSignUp()"
          class="lc-cta group mt-7 inline-flex w-full items-center
            justify-between gap-5 border border-[#E7CA96]/50
            bg-[#4D0A24] px-5 py-4 text-left transition duration-300
            hover:border-[#E7CA96] hover:bg-[#9B0F3B] sm:max-w-[300px]">

          <span>
            <span class="block text-[9px] font-semibold uppercase tracking-[0.25em] text-[#E7CA96]">
              Begin your journey
            </span>
            <span class="mt-1 block text-sm font-bold uppercase tracking-[0.13em] text-[#F6E9D5]">
              Try your luck
            </span>
          </span>

          <span class="lc-arrow flex h-10 w-10 shrink-0 items-center
            justify-center rounded-full border border-[#E7CA96]/35
            text-xl text-[#E7CA96] transition duration-300
            group-hover:bg-[#E7CA96] group-hover:text-[#030204]">
            →
          </span>
        </button>

        <p class="mt-4 text-[10px] leading-5 text-[#A88E99]/80">
          Discover the experience. Make your moment count.
        </p>
      </div>
    </div>

    <!-- PREMIUM JACKPOT RIBBON -->
    <div class="relative overflow-hidden border-y border-[#E7CA96]/30">

      <div class="pointer-events-none absolute inset-0 bg-gradient-to-r
        from-[#4D0A24]/70 via-[#0D070C]/70 to-[#4D0A24]/70"></div>

      <div class="pointer-events-none absolute -right-10 top-1/2
        h-48 w-48 -translate-y-1/2 rounded-full border border-[#E7CA96]/10"></div>

      <div class="pointer-events-none absolute -right-2 top-1/2
        h-32 w-32 -translate-y-1/2 rounded-full border border-[#E7CA96]/10"></div>

      <div class="relative grid gap-6 px-5 py-7 sm:px-8 sm:py-9
        lg:grid-cols-[1fr_auto_1fr] lg:items-center lg:gap-10">

        <div class="flex items-center gap-4">
          <div class="flex h-14 w-14 shrink-0 items-center justify-center
            border border-[#E7CA96]/35 bg-[#030204]/50">
            <i class="fa-solid fa-crown text-xl text-[#E7CA96]"></i>
          </div>

          <div>
            <p class="text-[9px] font-bold uppercase tracking-[0.35em] text-[#E7CA96]">
              The grand prize
            </p>
            <h3 class="mt-1 text-2xl font-black uppercase tracking-tight sm:text-3xl">
              Mega <span class="font-serif font-normal italic text-[#E7CA96]">Jackpot</span>
            </h3>
          </div>
        </div>

        <div class="min-w-0 lg:text-center">
          <p class="mb-2 text-[9px] uppercase tracking-[0.32em] text-[#A88E99]">
            A fortune worth chasing
          </p>

          <div class="flex flex-wrap items-baseline gap-x-2 gap-y-1 lg:justify-center">
            <span class="font-serif text-xl italic text-[#E7CA96]">Rs.</span>
            <span class="break-all text-4xl font-black leading-none tracking-[-0.06em]
              text-[#F6E9D5] sm:text-5xl lg:text-6xl">
              2,457,000
            </span>
          </div>
        </div>

        <div class="flex items-center justify-start lg:justify-end">
          <button
            type="button"
            (click)="RedirectToSignUp()"
            class="inline-flex items-center gap-3 border border-[#E7CA96]/40
              px-5 py-3 text-[10px] font-bold uppercase tracking-[0.22em]
              text-[#E7CA96] transition duration-300
              hover:bg-[#E7CA96] hover:text-[#030204]">
            Explore jackpot
            <span class="text-base">↗</span>
          </button>
        </div>
      </div>
    </div>

    <!-- SIGNATURE FOOTER -->
    <div class="flex flex-col gap-3 pt-6 sm:flex-row sm:items-center sm:justify-between">
      <p class="text-[9px] uppercase tracking-[0.28em] text-[#A88E99]/70">
        LUCKYCREST · THE ART OF ANTICIPATION
      </p>

      <div class="flex items-center gap-3">
        <span class="h-px w-8 bg-[#E7CA96]/40"></span>
        <span class="font-serif text-sm italic text-[#E7CA96]">
          Fortune favors the bold.
        </span>
      </div>
    </div>

  </div>
</section>






<!-- =========================================================================
     08. HOW IT WORKS — LUCKYCREST SIGNATURE EXPERIENCE
     Fresh editorial layout | Burgundy + Rose + Gold | Responsive
     ========================================================================= -->

<section id="howItWorks"
  class="relative overflow-hidden bg-[#030204] py-20 sm:py-28">

  <style>
    #howItWorks .journey-card {
      transition: transform .45s ease, border-color .45s ease;
    }

    #howItWorks .journey-card:hover {
      transform: translateY(-6px);
      border-color: rgba(231,202,150,.45);
    }

    #howItWorks .journey-card:hover .journey-icon {
      transform: scale(1.08) rotate(-6deg);
      background: #4D0A24;
    }

    #howItWorks .journey-icon {
      transition: all .4s ease;
    }

    #howItWorks .journey-number {
      -webkit-text-stroke: 1px rgba(231,202,150,.45);
      color: transparent;
    }

    #howItWorks .journey-card:hover .journey-number {
      -webkit-text-stroke-color: #E7CA96;
    }

    #howItWorks .journey-arrow {
      transition: transform .35s ease;
    }

    #howItWorks .journey-card:hover .journey-arrow {
      transform: translateX(5px);
    }

    @media (prefers-reduced-motion: reduce) {
      #howItWorks * {
        transition: none !important;
      }
    }
  </style>

  <!-- Atmospheric background -->
  <div class="absolute top-0 right-0 w-[500px] h-[500px]
              rounded-full bg-[#9B0F3B]/10 blur-[140px]
              pointer-events-none"></div>

  <div class="absolute bottom-0 left-[-150px] w-[400px] h-[400px]
              rounded-full bg-[#C71650]/[0.07] blur-[120px]
              pointer-events-none"></div>

  <div class="absolute inset-0 opacity-[0.035] pointer-events-none"
       style="background-image:linear-gradient(rgba(231,202,150,.5) 1px,transparent 1px),linear-gradient(90deg,rgba(231,202,150,.5) 1px,transparent 1px);background-size:70px 70px;">
  </div>

  <div class="max-w-[1500px] mx-auto px-4 sm:px-8 relative z-10">

    <!-- Asymmetric heading -->
    <div class="grid lg:grid-cols-[1fr_340px] gap-8 lg:gap-16
                items-end mb-16 lg:mb-20">

      <div>
        <div class="flex items-center gap-3 mb-6">
          <span class="text-[#E7CA96] text-[10px] font-bold
                       tracking-[.35em] uppercase">
            The art of getting started
          </span>
          <span class="w-12 h-px bg-[#E7CA96]/50"></span>
        </div>

        <h2 class="text-[#F6E9D5] text-5xl sm:text-6xl
                   lg:text-7xl font-black leading-[.98]
                   tracking-[-.055em]">
          Start with
          <span class="block mt-2 text-[#E7CA96] font-serif
                       italic font-medium tracking-[-.04em]">
            confidence.
          </span>
        </h2>
      </div>

      <div class="lg:border-l lg:border-[#E7CA96]/25
                  lg:pl-7 pb-1">
        <p class="text-[#A88E99] text-sm leading-7">
          Everything begins with a few simple steps. Set up your account,
          explore what's available, and understand the rules before you play.
        </p>

        <div class="flex items-center gap-3 mt-5">
          <span class="text-[#E7CA96] text-2xl font-serif italic">03</span>
          <span class="text-[#A88E99] text-[10px] uppercase
                       tracking-[.2em] leading-5">
            Steps to know<br>before you begin
          </span>
        </div>
      </div>

    </div>

    <!-- Journey layout -->
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-5">

      <!-- Step 1: wide feature panel -->
      <article class="journey-card lg:col-span-7 relative
                      overflow-hidden rounded-[30px]
                      border border-[#E7CA96]/20
                      bg-[#0D070C] p-7 sm:p-10 lg:p-12">

        <div class="absolute -right-8 -top-12
                    text-[200px] sm:text-[270px] font-black
                    leading-none journey-number select-none
                    pointer-events-none">
          01
        </div>

        <div class="relative z-10 flex flex-col h-full
                    min-h-[300px] justify-between">

          <div class="flex items-start justify-between gap-4">
            <span class="text-[10px] uppercase tracking-[.25em]
                         font-bold text-[#E7CA96]">
              First things first
            </span>

            <div class="journey-icon w-14 h-14 shrink-0
                        rounded-2xl border border-[#E7CA96]/30
                        bg-[#120810] flex items-center justify-center">
              <svg class="w-7 h-7 text-[#E7CA96]"
                   viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="1.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="8" r="4"></circle>
                <path d="M5 21v-2a7 7 0 0 1 14 0v2"></path>
                <path d="M19 8h3M20.5 6.5v3"></path>
              </svg>
            </div>
          </div>

          <div class="max-w-lg mt-12">
            <h3 class="text-[#F6E9D5] text-3xl sm:text-4xl
                       font-bold tracking-tight">
              Make it yours.
            </h3>

            <p class="text-[#A88E99] text-sm sm:text-base
                      leading-7 mt-4 max-w-md">
              Create your account with the required details.
              Keep your login information secure and review the
              account terms before continuing.
            </p>
          </div>

          <div class="flex items-center justify-between gap-4
                      border-t border-white/[.08] pt-5 mt-8">
            <div>
              <span class="block text-[#F6E9D5] text-sm font-semibold">
                Step one
              </span>
              <span class="block text-[#A88E99] text-xs mt-1">
                Set up your account
              </span>
            </div>

            <div class="journey-arrow w-10 h-10 rounded-full
                        border border-[#E7CA96]/30 flex
                        items-center justify-center text-[#E7CA96]">
              <svg class="w-5 h-5" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor"
                   stroke-width="1.6">
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </div>
          </div>

        </div>
      </article>

      <!-- Right stacked steps -->
      <div class="lg:col-span-5 flex flex-col gap-5">

        <!-- Step 2 -->
        <article class="journey-card relative flex-1
                        overflow-hidden rounded-[30px]
                        border border-[#E7CA96]/20
                        bg-gradient-to-br from-[#180B16] to-[#070306]
                        p-7 sm:p-8">

          <div class="absolute -right-3 -top-7
                      text-[150px] font-black leading-none
                      journey-number select-none pointer-events-none">
            02
          </div>

          <div class="relative z-10 flex items-start gap-5">
            <div class="journey-icon w-14 h-14 shrink-0
                        rounded-2xl border border-[#E7CA96]/25
                        bg-[#0D070C] flex items-center justify-center">
              <svg class="w-7 h-7 text-[#E7CA96]"
                   viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="1.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                <path d="M3 9h18M8 14h3M8 17h7"></path>
              </svg>
            </div>

            <div class="relative z-10 pt-1">
              <span class="text-[#E7CA96] text-[10px]
                           uppercase tracking-[.22em] font-bold">
                Step two
              </span>
              <h3 class="text-[#F6E9D5] text-2xl
                         font-bold mt-2">
                Explore the details.
              </h3>
            </div>
          </div>

          <p class="relative z-10 text-[#A88E99] text-sm
                    leading-7 mt-6 max-w-md">
            Browse available games and payment options.
            Check any bonus requirements, fees, and eligibility rules
            before making a decision.
          </p>

          <div class="relative z-10 mt-6 flex items-center
                      justify-between border-t border-white/[.08] pt-4">
            <span class="text-[#F6E9D5]/80 text-xs font-medium">
              Know your options
            </span>
            <svg class="w-5 h-5 text-[#E7CA96]"
                 viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="1.6">
              <path d="M5 12h14M13 6l6 6-6 6"></path>
            </svg>
          </div>

        </article>

        <!-- Step 3 -->
        <article class="journey-card relative flex-1
                        overflow-hidden rounded-[30px]
                        border border-[#E7CA96]/25
                        bg-[#1A0D16] p-7 sm:p-8">

          <div class="absolute -right-3 -top-7
                      text-[150px] font-black leading-none
                      journey-number select-none pointer-events-none">
            03
          </div>

          <div class="relative z-10 flex items-start gap-5">
            <div class="journey-icon w-14 h-14 shrink-0
                        rounded-2xl border border-[#E7CA96]/30
                        bg-[#24101D] flex items-center justify-center">
              <svg class="w-7 h-7 text-[#E7CA96]"
                   viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="1.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3l2.5 5.2 5.7.8-4.1 4 .9 5.7-5-2.7-5 2.7.9-5.7-4.1-4 5.7-.8L12 3z"></path>
              </svg>
            </div>

            <div class="relative z-10 pt-1">
              <span class="text-[#E7CA96] text-[10px]
                           uppercase tracking-[.22em] font-bold">
                Step three
              </span>
              <h3 class="text-[#F6E9D5] text-2xl
                         font-bold mt-2">
                Play responsibly.
              </h3>
            </div>
          </div>

          <p class="relative z-10 text-[#A88E99] text-sm
                    leading-7 mt-6 max-w-md">
            Set a budget that works for you, understand withdrawal
            conditions, and keep your play within limits you can afford.
          </p>

          <div class="relative z-10 mt-6 flex items-center
                      justify-between border-t border-white/[.08] pt-4">
            <span class="text-[#F6E9D5]/80 text-xs font-medium">
              Keep control in your hands
            </span>
            <svg class="w-5 h-5 text-[#E7CA96]"
                 viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="1.6">
              <path d="M5 12h14M13 6l6 6-6 6"></path>
            </svg>
          </div>

        </article>

      </div>
    </div>

    <!-- Closing brand strip -->
    <div class="relative mt-8 overflow-hidden rounded-[24px]
                border border-[#E7CA96]/20
                bg-gradient-to-r from-[#301020] via-[#190C15]
                to-[#070306] px-6 py-7 sm:px-9
                flex flex-col sm:flex-row items-start
                sm:items-center justify-between gap-5">

      <div class="flex items-center gap-4">
        <div class="w-12 h-12 shrink-0 rounded-full
                    border border-[#E7CA96]/35
                    flex items-center justify-center">
          <svg class="w-6 h-6 text-[#E7CA96]"
               viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3l2.5 5.2 5.7.8-4.1 4 .9 5.7-5-2.7-5 2.7.9-5.7-4.1-4 5.7-.8L12 3z"></path>
          </svg>
        </div>

        <div>
          <h4 class="text-[#F6E9D5] font-bold text-base">
            Every great experience starts with a clear choice.
          </h4>
          <p class="text-[#A88E99] text-xs leading-6 mt-1">
            Check the terms, understand the risks, and make informed decisions.
          </p>
        </div>
      </div>

      <span class="text-[#E7CA96] text-[10px] font-bold
                   uppercase tracking-[.25em] whitespace-nowrap">
        The Luckycrest Standard
      </span>

    </div>

  </div>
</section>



<!-- ============================================================
     LUCKYCREST — CELESTIAL PAYMENT DIAL
     Unique radial composition · Burgundy / Rose / Gold
     Tailwind CSS + Font Awesome
     ============================================================ -->

<section id="paymentExchange"
  class="relative isolate overflow-hidden bg-[#030204] text-[#F6E9D5]">

  <style>
    #paymentExchange .celestial-bg {
      background:
        radial-gradient(ellipse at 50% 47%, rgba(107,15,51,.24), transparent 38%),
        radial-gradient(ellipse at 15% 100%, rgba(231, 202, 150,.07), transparent 36%),
        linear-gradient(180deg, #030204, #100710 55%, #030204);
    }

    #paymentExchange .celestial-heading {
      background: linear-gradient(125deg, #F6E9D5 12%, #E7CA96 48%, #E7CA96 88%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }

    #paymentExchange .celestial-stage {
      perspective: 1100px;
    }

    #paymentExchange .celestial-dial {
      position: relative;
      width: min(100%, 600px);
      aspect-ratio: 1;
      transform: rotateX(7deg);
      transform-style: preserve-3d;
    }

    #paymentExchange .celestial-ring {
      position: absolute;
      inset: 4%;
      border: 1px solid rgba(231,202,150,.16);
      border-radius: 50%;
    }

    #paymentExchange .celestial-ring.ring-two {
      inset: 13%;
      border-style: dashed;
      border-color: rgba(231, 202, 150,.22);
      animation: celestialRotate 90s linear infinite;
    }

    #paymentExchange .celestial-ring.ring-three {
      inset: 24%;
      border-color: rgba(231,202,150,.19);
      box-shadow: 0 0 50px rgba(77,10,36,.14);
    }

    #paymentExchange .celestial-halo {
      position: absolute;
      inset: 28%;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(199, 22, 80,.26), rgba(77,10,36,.06) 56%, transparent 74%);
      filter: blur(12px);
    }

    #paymentExchange .celestial-center {
      position: absolute;
      inset: 31%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(231,202,150,.42);
      border-radius: 50%;
      background: radial-gradient(circle at 36% 25%, #321321, #0D070C 58%, #030204);
      box-shadow:
        inset 0 0 35px rgba(231,202,150,.06),
        0 0 70px rgba(77,10,36,.25),
        0 0 0 7px rgba(231,202,150,.025);
      transform: translateZ(30px);
    }

    #paymentExchange .celestial-center::before {
      content: "";
      position: absolute;
      inset: 8%;
      border: 1px solid rgba(231, 202, 150,.25);
      border-radius: 50%;
    }

    #paymentExchange .celestial-node {
      position: absolute;
      z-index: 5;
      display: flex;
      width: 94px;
      height: 94px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 7px;
      border: 1px solid rgba(231,202,150,.32);
      border-radius: 50%;
      background: linear-gradient(145deg, #25101D, #0D070C 76%);
      box-shadow: 0 12px 36px rgba(0,0,0,.45);
      color: #E7CA96;
      transition: transform .35s ease, border-color .35s ease,
                  color .35s ease, box-shadow .35s ease;
    }

    #paymentExchange .celestial-node:hover {
      transform: scale(1.09);
      border-color: #E7CA96;
      color: #F6E9D5;
      box-shadow: 0 0 34px rgba(231,202,150,.12);
    }

    #paymentExchange .celestial-node i {
      font-size: 25px;
    }

    #paymentExchange .celestial-node svg.celestial-node-svg {
      width: 25px;
      height: 25px;
    }

    #paymentExchange .celestial-node.node-cashapp {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    #paymentExchange .celestial-node.node-cashapp:hover {
      transform: translateX(-50%) scale(1.09);
    }

    #paymentExchange .celestial-node.node-gpay {
      top: 18%;
      right: 3%;
    }

    #paymentExchange .celestial-node.node-paypal {
      right: 3%;
      bottom: 18%;
    }

    #paymentExchange .celestial-node span {
      font-size: 8px;
      font-weight: 600;
      letter-spacing: .13em;
    }

    #paymentExchange .celestial-node.node-btc {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    #paymentExchange .celestial-node.node-btc:hover {
      transform: translateX(-50%) scale(1.09);
    }

    #paymentExchange .celestial-node.node-eth {
      top: 18%;
      right: 3%;
    }

    #paymentExchange .celestial-node.node-usdt {
      right: 3%;
      bottom: 18%;
    }

    #paymentExchange .celestial-node.node-visa {
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    #paymentExchange .celestial-node.node-visa:hover {
      transform: translateX(-50%) scale(1.09);
    }

    #paymentExchange .celestial-node.node-mastercard {
      bottom: 18%;
      left: 3%;
    }

    #paymentExchange .celestial-node.node-apple {
      top: 18%;
      left: 3%;
    }

    #paymentExchange .celestial-route {
      position: absolute;
      left: 50%;
      top: 50%;
      height: 1px;
      width: 36%;
      transform-origin: left center;
      background: linear-gradient(90deg, rgba(231,202,150,.5), transparent);
      pointer-events: none;
    }

    #paymentExchange .celestial-star {
      animation: celestialPulse 3.6s ease-in-out infinite;
    }

    #paymentExchange .celestial-rule {
      background: linear-gradient(90deg, transparent, #E7CA96 50%, transparent);
    }

    @keyframes celestialRotate {
      to { transform: rotate(360deg); }
    }

    @keyframes celestialPulse {
      0%, 100% { opacity: .35; }
      50% { opacity: 1; }
    }

    @media (max-width: 639px) {
      #paymentExchange .celestial-dial {
        width: min(100%, 390px);
      }

      #paymentExchange .celestial-node {
        width: 66px;
        height: 66px;
        gap: 4px;
      }

      #paymentExchange .celestial-node i {
        font-size: 19px;
      }

      #paymentExchange .celestial-node span {
        font-size: 7px;
        letter-spacing: .06em;
      }

      #paymentExchange .celestial-node.node-eth,
      #paymentExchange .celestial-node.node-gpay,
      #paymentExchange .celestial-node.node-usdt,
      #paymentExchange .celestial-node.node-paypal {
        right: 0;
      }

      #paymentExchange .celestial-node svg.celestial-node-svg {
        width: 19px;
        height: 19px;
      }

      #paymentExchange .celestial-node.node-apple,
      #paymentExchange .celestial-node.node-mastercard {
        left: 0;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      #paymentExchange .celestial-ring,
      #paymentExchange .celestial-star {
        animation: none;
      }
    }
  </style>

  <div aria-hidden="true" class="celestial-bg absolute inset-0"></div>

  <!-- Subtle edge decoration -->
  <div aria-hidden="true"
    class="pointer-events-none absolute -left-32 top-20 h-80 w-80 rounded-full bg-[#4D0A24]/20 blur-[120px]">
  </div>

  <div aria-hidden="true"
    class="pointer-events-none absolute -right-32 bottom-10 h-80 w-80 rounded-full bg-[#E7CA96]/[0.06] blur-[130px]">
  </div>

  <!-- Header -->
  <div class="relative z-10 mx-auto flex max-w-[1440px] items-center justify-between px-5 py-6 sm:px-8 lg:px-14">
    <div class="flex items-center gap-3">
      <span class="h-2 w-2 rotate-45 bg-[#E7CA96]"></span>
      <span class="text-[9px] font-semibold uppercase tracking-[.3em] text-[#E7CA96] sm:text-[10px]">
        Luckycrest / The payment universe
      </span>
    </div>
   
  </div>

  <!-- Main composition -->
  <div class="relative z-10 mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-8 px-5 pb-14 pt-9 sm:px-8 sm:pb-20 lg:grid-cols-12 lg:gap-5 lg:px-14 lg:py-16">

    <!-- Asymmetric title column -->
    <div class="relative z-10 lg:col-span-4">

      <div class="mb-7 flex items-center gap-3">
        <span class="h-px w-8 bg-[#E7CA96]"></span>
        <span class="text-[9px] uppercase tracking-[.3em] text-[#A88E99]">
          The art of choice
        </span>
      </div>

      <h2 class="font-serif text-[clamp(3.8rem,8vw,7rem)] leading-[.82] tracking-[-.07em]">
        One
        <span class="celestial-heading mt-3 block italic">orbit.</span>
        <span class="mt-3 block">Many</span>
        <span class="block text-[#E7CA96]">ways.</span>
      </h2>

      <div class="celestial-rule mt-8 h-px w-24"></div>

      <p class="mt-7 max-w-xs text-sm leading-7 text-[#A88E99]">
        A universe of payment possibilities, brought together in one distinctive experience.
      </p>

      <div class="mt-10 flex items-center gap-4">
        <div class="flex h-11 w-11 items-center justify-center rounded-full border border-[#E7CA96]/30 text-[#E7CA96]">
          <i class="fa-solid fa-compass text-sm" aria-hidden="true"></i>
        </div>
        <div>
          <p class="text-[10px] font-semibold uppercase tracking-[.2em]">Find your method</p>
          <p class="mt-1 text-[10px] text-[#A88E99]">Explore the available options</p>
        </div>
      </div>

      <div class="mt-12 hidden border-l border-[#E7CA96]/35 pl-4 lg:block">
        <p class="font-serif text-4xl text-[#E7CA96]">06</p>
        <p class="mt-1 text-[9px] uppercase tracking-[.22em] text-[#A88E99]">
          Payment methods displayed
        </p>
      </div>
    </div>

    <!-- Main celestial dial -->
    <div class="celestial-stage relative flex items-center justify-center lg:col-span-8">

      <div class="celestial-dial">

        <div aria-hidden="true" class="celestial-ring"></div>
        <div aria-hidden="true" class="celestial-ring ring-two"></div>
        <div aria-hidden="true" class="celestial-ring ring-three"></div>
        <div aria-hidden="true" class="celestial-halo"></div>

        <!-- Trajectory lines -->
        <div aria-hidden="true" class="celestial-route" style="transform: rotate(-90deg)"></div>
        <div aria-hidden="true" class="celestial-route" style="transform: rotate(-30deg)"></div>
        <div aria-hidden="true" class="celestial-route" style="transform: rotate(30deg)"></div>
        <div aria-hidden="true" class="celestial-route" style="transform: rotate(90deg)"></div>
        <div aria-hidden="true" class="celestial-route" style="transform: rotate(150deg)"></div>
        <div aria-hidden="true" class="celestial-route" style="transform: rotate(210deg)"></div>

        <!-- Orbit points -->
        <span aria-hidden="true" class="celestial-star absolute left-[20%] top-[27%] h-1.5 w-1.5 rounded-full bg-[#E7CA96]"></span>
        <span aria-hidden="true" class="celestial-star absolute right-[22%] top-[31%] h-1 w-1 rounded-full bg-[#C71650]" style="animation-delay:.8s"></span>
        <span aria-hidden="true" class="celestial-star absolute bottom-[25%] right-[26%] h-1.5 w-1.5 rounded-full bg-[#E7CA96]" style="animation-delay:1.2s"></span>
        <span aria-hidden="true" class="celestial-star absolute bottom-[24%] left-[27%] h-1 w-1 rounded-full bg-[#C71650]" style="animation-delay:1.7s"></span>

        <!-- Central crest -->
        <div class="celestial-center">
          <div class="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-[#E7CA96]/40 bg-[#4D0A24]/50 sm:h-16 sm:w-16">
            <i class="fa-solid fa-gem text-lg text-[#E7CA96] sm:text-2xl" aria-hidden="true"></i>
          </div>

          <p class="relative z-10 mt-4 text-center text-[7px] uppercase tracking-[.25em] text-[#A88E99] sm:text-[9px]">
            Luckycrest
          </p>

          <p class="relative z-10 mt-1 text-center font-serif text-lg italic text-[#F6E9D5] sm:text-2xl">
            Your choice
          </p>

          <div class="celestial-rule relative z-10 mt-3 h-px w-8 sm:w-12"></div>
        </div>

        <!-- Six method nodes -->
        <div class="celestial-node node-cashapp" aria-label="Cash App">
          <svg class="celestial-node-svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="2" y="2" width="20" height="20" rx="6" stroke="currentColor" stroke-width="1.8"/>
            <path d="M14.6 9.2c-.3-.7-.9-1.1-1.7-1.1-1 0-1.6.6-1.6 1.3 0 .8.7 1.2 1.8 1.6l.8.3c1.7.6 2.7 1.4 2.7 2.9 0 1.7-1.4 2.8-3.4 3v1.3h-1.6v-1.3c-1.3-.1-2.3-.8-2.7-2l1.4-.5c.3.8.9 1.3 1.8 1.3 1.1 0 1.8-.6 1.8-1.4 0-.8-.7-1.3-1.9-1.7l-.8-.3c-1.6-.5-2.6-1.4-2.6-2.8 0-1.6 1.3-2.7 3.2-2.9V5.5h1.6v1.3c1.1.1 2 .7 2.4 1.7l-1.4.7z" fill="currentColor"/>
          </svg>
          <span>CASH APP</span>
        </div>

        <div class="celestial-node node-gpay" aria-label="Google Pay">
          <i class="fa-brands fa-google-pay" aria-hidden="true"></i>
          <span>GOOGLE PAY</span>
        </div>

        <div class="celestial-node node-paypal" aria-label="PayPal">
          <i class="fa-brands fa-paypal" aria-hidden="true"></i>
          <span>PAYPAL</span>
        </div>

        <div class="celestial-node node-visa" aria-label="Visa">
          <i class="fa-brands fa-cc-visa" aria-hidden="true"></i>
          <span>VISA</span>
        </div>

        <div class="celestial-node node-mastercard" aria-label="Mastercard">
          <i class="fa-brands fa-cc-mastercard" aria-hidden="true"></i>
          <span>MASTERCARD</span>
        </div>

        <div class="celestial-node node-apple" aria-label="Apple Pay">
          <i class="fa-brands fa-apple-pay" aria-hidden="true"></i>
          <span>APPLE PAY</span>
        </div>

      </div>
    </div>
  </div>

  <!-- Footer strip -->
  <div class="relative z-10 border-t border-[#E7CA96]/20 bg-[#0D070C]/80">
    <div class="mx-auto flex max-w-[1440px] flex-col gap-4 px-5 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-14">

      <div class="flex items-center gap-3">
        <i class="fa-solid fa-circle-info text-xs text-[#E7CA96]" aria-hidden="true"></i>
        <p class="text-[10px] leading-5 text-[#A88E99]">
          Availability and fees depend on your location and payment provider.
        </p>
      </div>

      <div class="flex items-center gap-3">
        <span class="h-px w-7 bg-[#E7CA96]/50"></span>
        <span class="text-[9px] uppercase tracking-[.24em] text-[#E7CA96]">
          The Luckycrest experience
        </span>
      </div>

    </div>
  </div>

</section>




<!-- =========================================================
     LUCKYCREST — THE COLLECTOR'S GALLERY
     Replace the old reviews section with this concept.
     ========================================================= -->

<section id="reviewsScrollSection" class="lc-gallery">

  <div class="lc-gallery-bg"></div>

  <div class="lc-gallery-container">

    <!-- Header -->
    <header class="lc-gallery-header">
      <div class="lc-gallery-brand">
        <span class="lc-brand-icon"><i class="fas fa-gem"></i></span>
        <span>LUCKYCREST <b> / </b> THE COLLECTION</span>
      </div>

      <span class="lc-edition">COMMUNITY EDITION · 010</span>
    </header>

    <!-- Hero -->
    <div class="lc-gallery-hero">
      <div class="lc-hero-copy">
        <span class="lc-overline">
          <span></span> A COLLECTION OF EXPERIENCES
        </span>

        <h2>
          Every voice.<br>
          <em>One of a kind.</em>
        </h2>

        <p>
          Discover the stories and experiences shared by our community.
          Every perspective brings something different to the collection.
        </p>

        <a href="#lc-collection" class="lc-explore-link">
          EXPLORE THE COLLECTION
          <span><i class="fas fa-arrow-down"></i></span>
        </a>
      </div>

      <!-- Decorative collectible stack -->
      <div class="lc-hero-art" aria-hidden="true">
        <div class="lc-art-ring lc-ring-one"></div>
        <div class="lc-art-ring lc-ring-two"></div>

        <div class="lc-art-ticket lc-ticket-back">
          <span>LC / ARCHIVE</span>
          <i class="fas fa-asterisk"></i>
          <b>EXPERIENCE</b>
        </div>

        <div class="lc-art-ticket lc-ticket-front">
          <span class="lc-ticket-topline">LUCKYCREST · ORIGINALS</span>
          <div class="lc-ticket-emblem"><i class="fas fa-gem"></i></div>
          <strong>THE<br>HUMAN<br><em>STORY.</em></strong>
          <div class="lc-ticket-bottom">
            <span>COLLECTION 01</span>
            <span>LC—010</span>
          </div>
        </div>

        <div class="lc-art-stamp">THE<br>REAL<br>THING</div>
      </div>
    </div>

    <!-- Collection divider -->
    <div id="lc-collection" class="lc-collection-heading">
      <div>
        <span class="lc-overline">01 / THE REVIEW ARCHIVE</span>
        <h3>Voices worth <em>keeping.</em></h3>
      </div>
      <span class="lc-collection-count">THE COLLECTION <i class="fas fa-arrow-right"></i></span>
    </div>

    <!-- Completely redesigned cards -->
    <div class="lc-collectibles">

      <!-- Card 01: oversized archive card -->
      <article class="lc-collectible lc-card-feature">
        <div class="lc-card-index">
          <span>COLLECTIBLE / 001</span>
          <i class="fas fa-quote-right"></i>
        </div>

        <div class="lc-card-art">
          <span class="lc-art-orbit orbit-small"></span>
          <span class="lc-art-orbit orbit-large"></span>
          <span class="lc-art-center"><i class="fas fa-comment-dots"></i></span>
          <span class="lc-art-side-label">PERSONAL PERSPECTIVE</span>
        </div>

        <div class="lc-card-copy">
          <span class="lc-card-category">THE EXPERIENCE SERIES</span>
          <h4>Every experience has its own story.</h4>
          <p>
            Replace this text with the actual review from your customer.
            Keep the original wording to preserve their experience.
          </p>

          <div class="lc-card-author">
            <span class="lc-author-monogram">01</span>
            <div>
              <strong>Customer review</strong>
              <small>Use the actual customer name or approved display name</small>
            </div>
            <span class="lc-card-arrow"><i class="fas fa-arrow-up"></i></span>
          </div>
        </div>

        <span class="lc-card-watermark">01</span>
      </article>

      <!-- Card 02: ticket / pass design -->
      <article class="lc-collectible lc-card-ticket">
        <div class="lc-ticket-header">
          <span><i class="fas fa-star"></i> COMMUNITY ARCHIVE</span>
          <span>NO. 002</span>
        </div>

        <div class="lc-ticket-body">
          <div class="lc-ticket-vertical">LUCKYCREST</div>

          <div class="lc-ticket-content">
            <span class="lc-card-category">THE PERSONAL NOTE</span>
            <div class="lc-ticket-quote">“</div>

            <h4>Your customer's words go here.</h4>

            <p>
              Add another real customer review here. This card uses a
              ticket-inspired layout instead of a standard rectangle.
            </p>

            <div class="lc-ticket-author">
              <span class="lc-ticket-avatar"><i class="fas fa-user"></i></span>
              <div>
                <strong>Customer review</strong>
                <small>Customer name</small>
              </div>
            </div>
          </div>
        </div>

        <div class="lc-ticket-perforation"></div>

        <div class="lc-ticket-footer">
          <span>PERSONAL EXPERIENCE</span>
          <span><i class="fas fa-fingerprint"></i> LC-002</span>
        </div>
      </article>

      <!-- Card 03: dark editorial card -->
      <article class="lc-collectible lc-card-editorial">
        <div class="lc-editorial-top">
          <span>FIELD NOTES / 003</span>
          <span class="lc-editorial-symbol"><i class="fas fa-asterisk"></i></span>
        </div>

        <div class="lc-editorial-main">
          <span class="lc-editorial-label">A VOICE FROM THE COMMUNITY</span>

          <h4>
            More than<br>
            <em>a moment.</em>
          </h4>

          <div class="lc-editorial-rule"></div>

          <p>
            Add a third real review here. Shorter testimonials work
            especially well with this editorial design.
          </p>
        </div>

        <div class="lc-editorial-bottom">
          <div class="lc-editorial-author">
            <span class="lc-author-monogram">03</span>
            <span>Customer review</span>
          </div>
          <span class="lc-editorial-number">003</span>
        </div>
      </article>

    </div>


    <!-- <div class="lc-film-section">
      <div class="lc-film-header">
        <div>
          <span class="lc-overline">02 / MOVING STORIES</span>
          <h3>The collection, <em>in motion.</em></h3>
        </div>

        <div class="lc-film-reel-icon">
          <i class="fas fa-film"></i>
        </div>
      </div>

      <div class="lc-film-frame">
        <div class="lc-film-top">
          <span>LUCKYCREST FILM ARCHIVE</span>
          <span>VIDEO COLLECTION <i class="fas fa-circle"></i></span>
        </div>

      
        <div class="lc-film-content">
          <app-video-reels></app-video-reels>
        </div>

        <div class="lc-film-bottom">
          <span>REAL PEOPLE. REAL PERSPECTIVES.</span>
          <span class="lc-film-perforations">▪ ▪ ▪ ▪ ▪ ▪ ▪ ▪ ▪</span>
        </div>
      </div>
    </div> -->

  
 

  </div>
</section>

<style>

#reviewsScrollSection.lc-gallery {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  padding: 72px 0 64px;
  color: #F6E9D5;
  background: #030204;
}

#reviewsScrollSection .lc-gallery-bg {
  position: absolute;
  z-index: -1;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(ellipse at 83% 9%, rgba(199, 22, 80,.23), transparent 28%),
    radial-gradient(ellipse at 0% 52%, rgba(77,10,36,.18), transparent 32%),
    linear-gradient(180deg, #030204 0%, #0D070C 48%, #030204 100%);
}

#reviewsScrollSection .lc-gallery-container {
  width: min(1450px, calc(100% - 40px));
  margin: 0 auto;
}

#reviewsScrollSection .lc-gallery-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  padding-bottom: 19px;
  border-bottom: 1px solid rgba(231,202,150,.22);
}

#reviewsScrollSection .lc-gallery-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .19em;
}

#reviewsScrollSection .lc-brand-icon {
  display: grid;
  width: 31px;
  height: 31px;
  place-items: center;
  border: 1px solid rgba(231,202,150,.45);
  color: #E7CA96;
}

#reviewsScrollSection .lc-gallery-brand b {
  color: #B82A62;
}

#reviewsScrollSection .lc-edition {
  font-size: 8px;
  letter-spacing: .17em;
  color: #A88E99;
}

#reviewsScrollSection .lc-gallery-hero {
  display: grid;
  grid-template-columns: 1fr .9fr;
  align-items: center;
  gap: 30px;
  min-height: 490px;
  padding: 50px 0 58px;
}

#reviewsScrollSection .lc-overline {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .2em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-overline > span {
  width: 22px;
  height: 2px;
  background: #B82A62;
}

#reviewsScrollSection .lc-hero-copy h2 {
  margin-top: 25px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(45px, 6.4vw, 86px);
  font-weight: 700;
  line-height: .98;
  letter-spacing: -.055em;
}

#reviewsScrollSection .lc-hero-copy h2 em {
  color: #E7CA96;
  font-weight: 400;
}

#reviewsScrollSection .lc-hero-copy > p {
  max-width: 450px;
  margin-top: 22px;
  font-size: 13px;
  line-height: 1.9;
  color: #A88E99;
}

#reviewsScrollSection .lc-explore-link {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  margin-top: 29px;
  color: #E7CA96;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .16em;
  text-decoration: none;
}

#reviewsScrollSection .lc-explore-link > span {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid rgba(231,202,150,.45);
  border-radius: 50%;
  transition: transform .25s ease, background .25s ease;
}

#reviewsScrollSection .lc-explore-link:hover > span {
  transform: translateY(3px);
  background: rgba(107,15,51,.4);
}

/* Collectible art */
#reviewsScrollSection .lc-hero-art {
  position: relative;
  display: grid;
  min-height: 405px;
  place-items: center;
  perspective: 1000px;
}

#reviewsScrollSection .lc-art-ring {
  position: absolute;
  width: 320px;
  height: 320px;
  border: 1px solid rgba(231,202,150,.16);
  border-radius: 50%;
}

#reviewsScrollSection .lc-ring-two {
  width: 250px;
  height: 250px;
  border-style: dashed;
  border-color: rgba(231, 202, 150,.24);
}

#reviewsScrollSection .lc-art-ticket {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: min(260px, 70%);
  height: 330px;
  padding: 20px;
  border: 1px solid rgba(231,202,150,.4);
  box-shadow: 0 28px 65px rgba(0,0,0,.4);
}

#reviewsScrollSection .lc-ticket-back {
  transform: translate(36px, -12px) rotate(10deg);
  background: linear-gradient(145deg, #4D0A24, #0D070C);
}

#reviewsScrollSection .lc-ticket-back > span {
  font-size: 8px;
  letter-spacing: .16em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-ticket-back > i {
  align-self: center;
  font-size: 100px;
  color: rgba(231, 202, 150,.18);
}

#reviewsScrollSection .lc-ticket-back > b {
  font-family: Georgia, serif;
  font-size: 17px;
  letter-spacing: .12em;
}

#reviewsScrollSection .lc-ticket-front {
  transform: translate(-22px, 6px) rotate(-5deg);
  background:
    radial-gradient(circle at 80% 30%, rgba(199, 22, 80,.32), transparent 45%),
    #070306;
}

#reviewsScrollSection .lc-ticket-topline,
#reviewsScrollSection .lc-ticket-bottom {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 7px;
  letter-spacing: .13em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-ticket-emblem {
  display: grid;
  width: 45px;
  height: 45px;
  place-items: center;
  border: 1px solid rgba(231,202,150,.5);
  border-radius: 50%;
  color: #E7CA96;
  font-size: 17px;
}

#reviewsScrollSection .lc-ticket-front > strong {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 39px;
  line-height: .9;
  letter-spacing: -.06em;
}

#reviewsScrollSection .lc-ticket-front > strong em {
  color: #E7CA96;
  font-weight: 400;
}

#reviewsScrollSection .lc-ticket-bottom {
  padding-top: 13px;
  border-top: 1px solid rgba(231,202,150,.23);
}

#reviewsScrollSection .lc-art-stamp {
  position: absolute;
  right: 2%;
  bottom: 11%;
  display: grid;
  width: 76px;
  height: 76px;
  place-items: center;
  border: 1px solid #E7CA96;
  border-radius: 50%;
  color: #E7CA96;
  font-size: 9px;
  font-weight: 900;
  line-height: 1.3;
  text-align: center;
  letter-spacing: .12em;
  transform: rotate(12deg);
}

/* Section headings */
#reviewsScrollSection .lc-collection-heading,
#reviewsScrollSection .lc-film-header {
  display: flex;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 25px;
}

#reviewsScrollSection .lc-collection-heading h3,
#reviewsScrollSection .lc-film-header h3 {
  margin-top: 12px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(31px, 4vw, 48px);
  line-height: 1.08;
  letter-spacing: -.045em;
}

#reviewsScrollSection .lc-collection-heading h3 em,
#reviewsScrollSection .lc-film-header h3 em {
  color: #E7CA96;
  font-weight: 400;
}

#reviewsScrollSection .lc-collection-count {
  padding-bottom: 5px;
  font-size: 8px;
  letter-spacing: .16em;
  color: #A88E99;
}

#reviewsScrollSection .lc-collection-count i {
  margin-left: 9px;
  color: #E7CA96;
}

/* Three deliberately different review cards */
#reviewsScrollSection .lc-collectibles {
  display: grid;
  grid-template-columns: 1.12fr .94fr .94fr;
  align-items: stretch;
  gap: 17px;
}

#reviewsScrollSection .lc-collectible {
  position: relative;
  min-width: 0;
  overflow: hidden;
  transition: transform .3s ease, border-color .3s ease;
}

#reviewsScrollSection .lc-collectible:hover {
  transform: translateY(-5px);
}

#reviewsScrollSection .lc-card-feature {
  display: flex;
  flex-direction: column;
  padding: 19px;
  border: 1px solid rgba(231,202,150,.3);
  background: linear-gradient(160deg, #120810, #0D070C 75%);
}

#reviewsScrollSection .lc-card-index {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 8px;
  letter-spacing: .15em;
  color: #A88E99;
}

#reviewsScrollSection .lc-card-index i {
  color: #E7CA96;
  font-size: 14px;
}

#reviewsScrollSection .lc-card-art {
  position: relative;
  display: grid;
  min-height: 150px;
  margin: 20px -19px;
  overflow: hidden;
  place-items: center;
  background:
    radial-gradient(circle, rgba(199, 22, 80,.45), transparent 65%),
    #030204;
}

#reviewsScrollSection .lc-art-orbit {
  position: absolute;
  border: 1px solid rgba(231, 202, 150,.25);
  border-radius: 50%;
}

#reviewsScrollSection .orbit-small {
  width: 95px;
  height: 95px;
}

#reviewsScrollSection .orbit-large {
  width: 140px;
  height: 140px;
  border-style: dashed;
  border-color: rgba(231,202,150,.2);
}

#reviewsScrollSection .lc-art-center {
  display: grid;
  width: 55px;
  height: 55px;
  place-items: center;
  border: 1px solid rgba(231,202,150,.5);
  border-radius: 50%;
  color: #E7CA96;
  font-size: 19px;
}

#reviewsScrollSection .lc-art-side-label {
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 7px;
  letter-spacing: .12em;
  color: #A88E99;
}

#reviewsScrollSection .lc-card-category {
  font-size: 8px;
  font-weight: 800;
  letter-spacing: .16em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-card-copy h4 {
  margin-top: 12px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 26px;
  line-height: 1.12;
  letter-spacing: -.035em;
}

#reviewsScrollSection .lc-card-copy > p,
#reviewsScrollSection .lc-ticket-content > p,
#reviewsScrollSection .lc-editorial-main > p {
  margin-top: 13px;
  font-size: 11px;
  line-height: 1.85;
  color: #A88E99;
}

#reviewsScrollSection .lc-card-author {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: auto;
  padding-top: 22px;
}

#reviewsScrollSection .lc-author-monogram {
  display: grid;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  place-items: center;
  border: 1px solid rgba(231,202,150,.35);
  color: #E7CA96;
  font-family: Georgia, serif;
  font-size: 12px;
}

#reviewsScrollSection .lc-card-author > div,
#reviewsScrollSection .lc-ticket-author > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

#reviewsScrollSection .lc-card-author strong,
#reviewsScrollSection .lc-ticket-author strong {
  font-size: 10px;
  color: #F6E9D5;
}

#reviewsScrollSection .lc-card-author small,
#reviewsScrollSection .lc-ticket-author small {
  font-size: 8px;
  line-height: 1.5;
  color: #A88E99;
}

#reviewsScrollSection .lc-card-arrow {
  display: grid;
  width: 29px;
  height: 29px;
  flex-shrink: 0;
  margin-left: auto;
  place-items: center;
  border: 1px solid rgba(231,202,150,.3);
  border-radius: 50%;
  color: #E7CA96;
  font-size: 10px;
}

#reviewsScrollSection .lc-card-watermark {
  position: absolute;
  right: -5px;
  bottom: 40px;
  pointer-events: none;
  font-family: Georgia, serif;
  font-size: 85px;
  font-weight: 900;
  color: rgba(231, 202, 150,.04);
}

/* Ticket-style review */
#reviewsScrollSection .lc-card-ticket {
  align-self: center;
  padding: 17px;
  border: 1px solid rgba(231, 202, 150,.4);
  background: #0D070C;
}

#reviewsScrollSection .lc-ticket-header,
#reviewsScrollSection .lc-ticket-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 7px;
  font-weight: 700;
  letter-spacing: .11em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-ticket-body {
  display: grid;
  grid-template-columns: 23px minmax(0, 1fr);
  gap: 12px;
  margin: 20px 0;
}

#reviewsScrollSection .lc-ticket-vertical {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  padding-right: 10px;
  border-right: 1px dashed rgba(231,202,150,.35);
  font-size: 8px;
  letter-spacing: .15em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-ticket-quote {
  margin-top: 12px;
  font-family: Georgia, serif;
  font-size: 58px;
  line-height: 1;
  color: #B82A62;
}

#reviewsScrollSection .lc-ticket-content h4 {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 23px;
  line-height: 1.12;
}

#reviewsScrollSection .lc-ticket-author {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 23px;
}

#reviewsScrollSection .lc-ticket-avatar {
  display: grid;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  place-items: center;
  border-radius: 50%;
  background: #4D0A24;
  color: #E7CA96;
  font-size: 11px;
}

#reviewsScrollSection .lc-ticket-perforation {
  height: 1px;
  margin: 0 -17px 14px;
  border-top: 1px dashed rgba(231,202,150,.35);
}

#reviewsScrollSection .lc-ticket-footer {
  font-size: 7px;
  color: #A88E99;
}

/* Editorial card */
#reviewsScrollSection .lc-card-editorial {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 430px;
  padding: 19px;
  border: 1px solid rgba(231,202,150,.2);
  background:
    radial-gradient(ellipse at 100% 0%, rgba(199, 22, 80,.4), transparent 45%),
    linear-gradient(160deg, #120810, #030204 75%);
}

#reviewsScrollSection .lc-editorial-top,
#reviewsScrollSection .lc-editorial-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 8px;
  letter-spacing: .13em;
  color: #A88E99;
}

#reviewsScrollSection .lc-editorial-symbol {
  display: grid;
  width: 31px;
  height: 31px;
  place-items: center;
  border: 1px solid rgba(231,202,150,.4);
  color: #E7CA96;
}

#reviewsScrollSection .lc-editorial-main {
  margin: 35px 0;
}

#reviewsScrollSection .lc-editorial-label {
  font-size: 7px;
  letter-spacing: .12em;
  color: #E7CA96;
}

#reviewsScrollSection .lc-editorial-main h4 {
  margin-top: 17px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(28px, 3vw, 39px);
  line-height: 1.04;
  letter-spacing: -.04em;
}

#reviewsScrollSection .lc-editorial-main h4 em {
  color: #E7CA96;
  font-weight: 400;
}

#reviewsScrollSection .lc-editorial-rule {
  width: 38px;
  height: 2px;
  margin-top: 18px;
  background: #B82A62;
}

#reviewsScrollSection .lc-editorial-author {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 9px;
  color: #F6E9D5;
}

#reviewsScrollSection .lc-editorial-author .lc-author-monogram {
  width: 28px;
  height: 28px;
}

#reviewsScrollSection .lc-editorial-number {
  color: #E7CA96;
  font-family: Georgia, serif;
  font-size: 22px;
}

/* Film archive */
#reviewsScrollSection .lc-film-section {
  margin-top: 80px;
}

#reviewsScrollSection .lc-film-reel-icon {
  display: grid;
  width: 49px;
  height: 49px;
  flex-shrink: 0;
  place-items: center;
  border: 1px solid rgba(231,202,150,.35);
  color: #E7CA96;
}

#reviewsScrollSection .lc-film-frame {
  padding: 15px;
  border: 1px solid rgba(231,202,150,.26);
  background: #070306;
}

#reviewsScrollSection .lc-film-top,
#reviewsScrollSection .lc-film-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 8px;
  letter-spacing: .14em;
  color: #A88E99;
}

#reviewsScrollSection .lc-film-top {
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(231,202,150,.16);
}

#reviewsScrollSection .lc-film-top i {
  margin-left: 5px;
  font-size: 6px;
  color: #B82A62;
}

#reviewsScrollSection .lc-film-content {
  padding: 20px 0;
  min-width: 0;
}

#reviewsScrollSection .lc-film-bottom {
  padding-top: 14px;
  border-top: 1px solid rgba(231,202,150,.16);
}

#reviewsScrollSection .lc-film-bottom > span:first-child {
  color: #E7CA96;
}

#reviewsScrollSection .lc-film-perforations {
  letter-spacing: .4em;
  color: #9B0F3B;
}

/* Footer */
#reviewsScrollSection .lc-gallery-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 65px;
  text-align: center;
}

#reviewsScrollSection .lc-footer-star {
  display: grid;
  width: 39px;
  height: 39px;
  place-items: center;
  border: 1px solid rgba(231,202,150,.4);
  border-radius: 50%;
  color: #E7CA96;
}

#reviewsScrollSection .lc-gallery-footer p {
  margin-top: 17px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 23px;
  font-style: italic;
  color: #E7CA96;
}

#reviewsScrollSection .lc-gallery-footer > span:last-child {
  margin-top: 9px;
  font-size: 8px;
  letter-spacing: .2em;
  color: #A88E99;
}

/* Responsive */
@media (max-width: 1000px) {
  #reviewsScrollSection .lc-collectibles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #reviewsScrollSection .lc-card-feature {
    grid-column: 1 / -1;
  }

  #reviewsScrollSection .lc-card-editorial {
    min-height: 390px;
  }
}

@media (max-width: 640px) {
  #reviewsScrollSection.lc-gallery {
    padding: 48px 0;
  }

  #reviewsScrollSection .lc-gallery-container {
    width: calc(100% - 28px);
  }

  #reviewsScrollSection .lc-gallery-hero {
    grid-template-columns: 1fr;
    padding: 40px 0;
    gap: 0;
  }

  #reviewsScrollSection .lc-hero-copy h2 {
    font-size: clamp(44px, 12vw, 68px);
  }

  #reviewsScrollSection .lc-hero-art {
    min-height: 365px;
    margin-top: 10px;
  }

  #reviewsScrollSection .lc-art-ticket {
    height: 295px;
  }

  #reviewsScrollSection .lc-art-ring {
    width: 270px;
    height: 270px;
  }

  #reviewsScrollSection .lc-ring-two {
    width: 220px;
    height: 220px;
  }

  #reviewsScrollSection .lc-collectibles {
    grid-template-columns: 1fr;
    gap: 13px;
  }

  #reviewsScrollSection .lc-card-feature {
    grid-column: auto;
    min-height: 420px;
  }

  #reviewsScrollSection .lc-card-ticket {
    min-height: 360px;
  }

  #reviewsScrollSection .lc-card-editorial {
    min-height: 350px;
  }

  #reviewsScrollSection .lc-film-section {
    margin-top: 55px;
  }

  #reviewsScrollSection .lc-film-frame {
    padding: 10px;
  }

  #reviewsScrollSection .lc-film-top,
  #reviewsScrollSection .lc-film-bottom {
    font-size: 7px;
  }
}

@media (prefers-reduced-motion: reduce) {
  #reviewsScrollSection .lc-collectible,
  #reviewsScrollSection .lc-explore-link > span {
    transition: none;
  }
}
</style>


<!-- ============================================================
     11. LUCKYCREST — PRIVATE CONCIERGE LOUNGE
     New concept: Luxury service desk / editorial split layout
     Angular reactive form logic preserved
     ============================================================ -->

<section id="contactScrollSection" class="lc-concierge relative overflow-hidden">

  <!-- Background details -->
  <div class="lc-concierge-orb lc-orb-left"></div>
  <div class="lc-concierge-orb lc-orb-right"></div>
  <div class="lc-concierge-grid"></div>

  <div class="relative z-10 mx-auto max-w-[1400px] px-4 py-16 sm:px-8 sm:py-24">

    <!-- TOP LABEL -->
    <!-- <div class="lc-concierge-top">
      <div class="lc-concierge-kicker">
        <span class="lc-kicker-dot"></span>
        <span>THE LUCKYCREST SERVICE DESK</span>
      </div>

      <span class="lc-concierge-number">LC / 011</span>
    </div> -->

    <!-- MAIN HEADING -->
    <div class="lc-concierge-heading">
      <div>
        <p class="lc-heading-overline">YOUR EXPERIENCE, OUR PRIORITY</p>

        <h2>
          Consider it
          <span>taken care of.</span>
        </h2>
      </div>

      <p class="lc-heading-description">
        Exceptional service starts with a conversation.
        Tell us what you need, and our support team will help
        you find the right way forward.
      </p>
    </div>

    <!-- MAIN CONCIERGE PANEL -->
    <div class="lc-concierge-shell">

      <!-- LEFT: SERVICE LOUNGE -->
      <aside class="lc-concierge-sidebar">

        <div class="lc-sidebar-top">
          <div class="lc-concierge-emblem">
            <span class="lc-emblem-inner">
              <i class="fas fa-key"></i>
            </span>
          </div>

          <span class="lc-sidebar-caption">PRIVATE CONCIERGE</span>
        </div>

        <div class="lc-sidebar-copy">
          <p class="lc-sidebar-overline">HERE WHEN YOU NEED US</p>

          <h3>
            A real team.
            <br />
            A personal touch.
          </h3>

          <p>
            From account questions to payment assistance,
            we're here to help you navigate your experience.
          </p>
        </div>

        <!-- SERVICE MENU -->
        <div class="lc-service-menu">

          <div class="lc-service-item">
            <span class="lc-service-icon">
              <i class="fas fa-wallet"></i>
            </span>

            <span class="lc-service-text">
              <strong>Payments & Transactions</strong>
              <small>Deposits and withdrawals</small>
            </span>

            <i class="fas fa-arrow-up-right-from-square lc-service-arrow"></i>
          </div>

          <div class="lc-service-item">
            <span class="lc-service-icon">
              <i class="fas fa-shield-alt"></i>
            </span>

            <span class="lc-service-text">
              <strong>Account & Verification</strong>
              <small>Access and account assistance</small>
            </span>

            <i class="fas fa-arrow-up-right-from-square lc-service-arrow"></i>
          </div>

          <div class="lc-service-item">
            <span class="lc-service-icon">
              <i class="fas fa-comment-dots"></i>
            </span>

            <span class="lc-service-text">
              <strong>General Enquiries</strong>
              <small>Questions and feedback</small>
            </span>

            <i class="fas fa-arrow-up-right-from-square lc-service-arrow"></i>
          </div>

        </div>

        <!-- SUPPORT STATUS -->
        <div class="lc-support-status">
          <span class="lc-status-indicator"></span>

          <div>
            <strong>Concierge support</strong>
            <p>Available around the clock</p>
          </div>

          <i class="fas fa-headset lc-status-headset"></i>
        </div>

        <div class="lc-sidebar-footer">
          <span>DISCREET</span>
          <span class="lc-footer-separator"></span>
          <span>DEDICATED</span>
          <span class="lc-footer-separator"></span>
          <span>PERSONAL</span>
        </div>

      </aside>

      <!-- RIGHT: CONTACT FORM -->
      <div class="lc-concierge-form-panel">

        <div class="lc-form-header">
          <div>
            <p class="lc-form-overline">LET'S START A CONVERSATION</p>
            <h3>How can we help?</h3>
            <p class="lc-form-subtitle">
              Complete the details below and send us your enquiry.
            </p>
          </div>

          <div class="lc-form-icon">
            <i class="fas fa-envelope-open-text"></i>
          </div>
        </div>

        <div class="lc-form-divider"></div>

        <form
          [formGroup]="contactForm"
          (ngSubmit)="onContactSubmit()"
          class="lc-contact-form"
        >

          <!-- NAME FIELDS -->
          <div class="lc-field-row">

            <div class="lc-field">
              <label for="lcFirstName">
                FIRST NAME <span>*</span>
              </label>

              <div class="lc-input-wrap">
                <i class="far fa-user lc-input-icon"></i>

                <input
                  id="lcFirstName"
                  type="text"
                  formControlName="firstName"
                  placeholder="Your first name"
                  autocomplete="given-name"
                />
              </div>

              <p
                *ngIf="contactForm.get('firstName')?.invalid &&
                       contactForm.get('firstName')?.touched"
                class="lc-field-error"
              >
                First name is required.
              </p>
            </div>

            <div class="lc-field">
              <label for="lcLastName">
                LAST NAME <span>*</span>
              </label>

              <div class="lc-input-wrap">
                <i class="far fa-user lc-input-icon"></i>

                <input
                  id="lcLastName"
                  type="text"
                  formControlName="lastName"
                  placeholder="Your last name"
                  autocomplete="family-name"
                />
              </div>

              <p
                *ngIf="contactForm.get('lastName')?.invalid &&
                       contactForm.get('lastName')?.touched"
                class="lc-field-error"
              >
                Last name is required.
              </p>
            </div>

          </div>

          <!-- EMAIL -->
          <div class="lc-field">
            <label for="lcContactEmail">
              EMAIL ADDRESS <span>*</span>
            </label>

            <div class="lc-input-wrap">
              <i class="far fa-envelope lc-input-icon"></i>

              <input
                id="lcContactEmail"
                type="email"
                formControlName="email"
                placeholder="you@example.com"
                autocomplete="email"
              />
            </div>

            <p
              *ngIf="contactForm.get('email')?.invalid &&
                     contactForm.get('email')?.touched"
              class="lc-field-error"
            >
              {{
                contactForm.get('email')?.errors?.['required']
                  ? 'Email is required.'
                  : 'Please enter a valid email address.'
              }}
            </p>
          </div>

          <!-- MESSAGE -->
          <div class="lc-field">
            <div class="lc-label-row">
              <label for="lcContactMessage">
                YOUR MESSAGE <span>*</span>
              </label>

              <span class="lc-private-label">
                <i class="fas fa-lock"></i> PRIVATE ENQUIRY
              </span>
            </div>

            <div class="lc-textarea-wrap">
              <textarea
                id="lcContactMessage"
                rows="5"
                formControlName="message"
                placeholder="Tell us how we can assist you..."
              ></textarea>

              <i class="far fa-comment-dots lc-textarea-icon"></i>
            </div>

            <p
              *ngIf="contactForm.get('message')?.invalid &&
                     contactForm.get('message')?.touched"
              class="lc-field-error"
            >
              Message is required.
            </p>
          </div>

          <!-- SUBMIT -->
          <button
            type="submit"
            [disabled]="contactForm.invalid"
            class="lc-send-button"
          >
            <span class="lc-send-button-content">
              <i class="far fa-paper-plane"></i>
              <span>Send Your Enquiry</span>
            </span>

            <span class="lc-send-arrow">
              <i class="fas fa-arrow-right"></i>
            </span>
          </button>

          <div class="lc-form-footnote">
            <i class="fas fa-shield-alt"></i>

            <p>
              Your details are submitted through our contact form.
              Please avoid including passwords or payment credentials.
            </p>
          </div>

        </form>
      </div>

    </div>

    <!-- BOTTOM SIGNATURE -->
    <div class="lc-concierge-bottom">
      <div class="lc-bottom-line"></div>

      <p>
        <span>LUCKYCREST</span>
        <i class="fas fa-asterisk"></i>
        SERVICE WITH DISTINCTION
      </p>

      <div class="lc-bottom-line"></div>
    </div>

  </div>
</section>

<style>
/* ============================================================
   CONCIERGE LOUNGE — VISUAL SYSTEM
   ============================================================ */

#contactScrollSection.lc-concierge {
  --lc-bg: #030204;
  --lc-panel: #0D070C;
  --lc-panel-light: #120810;
  --lc-input: #0D070C;
  --lc-burgundy: #4D0A24;
  --lc-burgundy-mid: #9B0F3B;
  --lc-rose: #E7CA96;
  --lc-gold: #E7CA96;
  --lc-cream: #F6E9D5;
  --lc-muted: #A88E99;

  isolation: isolate;
  background:
    radial-gradient(ellipse at 0% 30%, #4D0A242e, transparent 38%),
    radial-gradient(ellipse at 100% 85%, #9B0F3B1c, transparent 34%),
    var(--lc-bg);
  color: var(--lc-cream);
}

/* Background atmosphere */
#contactScrollSection .lc-concierge-orb {
  position: absolute;
  z-index: -1;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  filter: blur(100px);
  opacity: .13;
  pointer-events: none;
}

#contactScrollSection .lc-orb-left {
  left: -190px;
  top: 35%;
  background: var(--lc-rose);
}

#contactScrollSection .lc-orb-right {
  right: -190px;
  top: 8%;
  background: var(--lc-burgundy-mid);
}

#contactScrollSection .lc-concierge-grid {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: .13;
  pointer-events: none;
  background-image:
    linear-gradient(#E7CA9608 1px, transparent 1px),
    linear-gradient(90deg, #E7CA9608 1px, transparent 1px);
  background-size: 65px 65px;
  mask-image: linear-gradient(to bottom, black, transparent 85%);
}

/* Top bar */
#contactScrollSection .lc-concierge-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding-bottom: 23px;
  border-bottom: 1px solid #E7CA9626;
}

#contactScrollSection .lc-concierge-kicker {
  display: flex;
  align-items: center;
  gap: 11px;
  color: var(--lc-gold);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .18em;
}

#contactScrollSection .lc-kicker-dot,
#contactScrollSection .lc-status-indicator {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--lc-rose);
  box-shadow: 0 0 12px #E7CA9666;
}

#contactScrollSection .lc-concierge-number {
  color: var(--lc-muted);
  font-size: 10px;
  letter-spacing: .12em;
}

/* Heading */
#contactScrollSection .lc-concierge-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 35px;
  padding: 45px 0 42px;
}

#contactScrollSection .lc-heading-overline,
#contactScrollSection .lc-form-overline {
  margin-bottom: 13px;
  color: var(--lc-rose);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .17em;
}

#contactScrollSection .lc-concierge-heading h2 {
  margin: 0;
  font-size: clamp(36px, 5vw, 65px);
  font-weight: 900;
  line-height: 1.04;
  letter-spacing: -.055em;
  color: var(--lc-cream);
}

#contactScrollSection .lc-concierge-heading h2 span {
  display: block;
  color: var(--lc-rose);
}

#contactScrollSection .lc-heading-description {
  max-width: 350px;
  margin: 0 0 5px;
  color: var(--lc-muted);
  font-size: 14px;
  line-height: 1.9;
}

/* Main shell */
#contactScrollSection .lc-concierge-shell {
  display: grid;
  grid-template-columns: minmax(0, .78fr) minmax(0, 1.22fr);
  overflow: hidden;
  border: 1px solid #E7CA9633;
  border-radius: 7px 26px 7px 26px;
  background: #070306;
  box-shadow: 0 30px 90px #00000040;
}

/* Sidebar */
#contactScrollSection .lc-concierge-sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: clamp(25px, 4vw, 46px);
  overflow: hidden;
  background:
    radial-gradient(ellipse at 0% 0%, #C7165040, transparent 50%),
    linear-gradient(150deg, #120810, #0D070C 68%, #0D070C);
  border-right: 1px solid #E7CA9628;
}

#contactScrollSection .lc-sidebar-top {
  display: flex;
  align-items: center;
  gap: 13px;
}

#contactScrollSection .lc-concierge-emblem {
  display: grid;
  place-items: center;
  width: 58px;
  height: 58px;
  border: 1px solid #E7CA9666;
  border-radius: 50%;
  transform: rotate(-10deg);
}

#contactScrollSection .lc-emblem-inner {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #E7CA9615;
  color: var(--lc-gold);
  font-size: 17px;
}

#contactScrollSection .lc-sidebar-caption {
  color: var(--lc-gold);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .12em;
}

#contactScrollSection .lc-sidebar-copy {
  margin-top: 43px;
}

#contactScrollSection .lc-sidebar-overline {
  margin-bottom: 13px;
  color: var(--lc-rose);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .16em;
}

#contactScrollSection .lc-sidebar-copy h3 {
  margin: 0;
  color: var(--lc-cream);
  font-size: clamp(25px, 3vw, 36px);
  font-weight: 900;
  line-height: 1.18;
  letter-spacing: -.04em;
}

#contactScrollSection .lc-sidebar-copy > p:last-child {
  max-width: 330px;
  margin-top: 17px;
  color: var(--lc-muted);
  font-size: 13px;
  line-height: 1.9;
}

/* Service list */
#contactScrollSection .lc-service-menu {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 32px;
}

#contactScrollSection .lc-service-item {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 14px 11px;
  border: 1px solid transparent;
  border-radius: 10px;
  transition: background .25s ease, border-color .25s ease;
}

#contactScrollSection .lc-service-item:hover {
  border-color: #E7CA9624;
  background: #E7CA9609;
}

#contactScrollSection .lc-service-icon {
  display: grid;
  place-items: center;
  width: 37px;
  height: 37px;
  flex-shrink: 0;
  border: 1px solid #E7CA9630;
  border-radius: 10px;
  background: #4D0A2438;
  color: var(--lc-rose);
  font-size: 13px;
}

#contactScrollSection .lc-service-text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

#contactScrollSection .lc-service-text strong {
  color: var(--lc-cream);
  font-size: 11px;
  font-weight: 700;
}

#contactScrollSection .lc-service-text small {
  color: var(--lc-muted);
  font-size: 10px;
}

#contactScrollSection .lc-service-arrow {
  color: var(--lc-gold);
  font-size: 10px;
  opacity: .5;
  transition: opacity .25s ease, transform .25s ease;
}

#contactScrollSection .lc-service-item:hover .lc-service-arrow {
  opacity: 1;
  transform: translate(2px, -2px);
}

/* Support status */
#contactScrollSection .lc-support-status {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 27px;
  padding: 16px 14px;
  border: 1px solid #E7CA9628;
  border-radius: 12px;
  background: #03020460;
}

#contactScrollSection .lc-status-indicator {
  background: var(--lc-gold);
  box-shadow: 0 0 12px #E7CA9670;
}

#contactScrollSection .lc-support-status > div {
  flex: 1;
}

#contactScrollSection .lc-support-status strong {
  color: var(--lc-cream);
  font-size: 11px;
}

#contactScrollSection .lc-support-status p {
  margin-top: 4px;
  color: var(--lc-muted);
  font-size: 10px;
}

#contactScrollSection .lc-status-headset {
  color: var(--lc-rose);
  font-size: 17px;
}

#contactScrollSection .lc-sidebar-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 9px;
  margin-top: auto;
  padding-top: 28px;
  color: #A88E99a8;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: .1em;
}

#contactScrollSection .lc-footer-separator {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: var(--lc-gold);
}

/* Form panel */
#contactScrollSection .lc-concierge-form-panel {
  min-width: 0;
  padding: clamp(25px, 4.5vw, 54px);
  background:
    radial-gradient(ellipse at 100% 0%, #4D0A2418, transparent 42%),
    #070306;
}

#contactScrollSection .lc-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

#contactScrollSection .lc-form-header h3 {
  margin: 0;
  color: var(--lc-cream);
  font-size: clamp(25px, 3vw, 34px);
  font-weight: 900;
  letter-spacing: -.04em;
}

#contactScrollSection .lc-form-subtitle {
  margin-top: 10px;
  color: var(--lc-muted);
  font-size: 12px;
  line-height: 1.8;
}

#contactScrollSection .lc-form-icon {
  display: grid;
  place-items: center;
  width: 49px;
  height: 49px;
  flex-shrink: 0;
  border: 1px solid #E7CA9645;
  border-radius: 14px;
  background: #E7CA960d;
  color: var(--lc-gold);
  font-size: 19px;
}

#contactScrollSection .lc-form-divider {
  height: 1px;
  margin: 27px 0 29px;
  background: linear-gradient(90deg, #E7CA9650, #E7CA9617, transparent);
}

/* Inputs */
#contactScrollSection .lc-contact-form {
  display: flex;
  flex-direction: column;
  gap: 23px;
}

#contactScrollSection .lc-field-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 17px;
}

#contactScrollSection .lc-field {
  min-width: 0;
}

#contactScrollSection .lc-field label {
  display: block;
  margin-bottom: 10px;
  color: #DCCBD2;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .13em;
}

#contactScrollSection .lc-field label span {
  color: var(--lc-rose);
}

#contactScrollSection .lc-input-wrap,
#contactScrollSection .lc-textarea-wrap {
  position: relative;
}

#contactScrollSection .lc-input-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  z-index: 1;
  color: #A88E99;
  font-size: 13px;
  pointer-events: none;
  transform: translateY(-50%);
  transition: color .2s ease;
}

#contactScrollSection .lc-input-wrap input,
#contactScrollSection .lc-textarea-wrap textarea {
  display: block;
  width: 100%;
  border: 1px solid #E7CA9628;
  border-radius: 10px;
  outline: none;
  background: var(--lc-input);
  color: var(--lc-cream);
  font-family: inherit;
  font-size: 12px;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

#contactScrollSection .lc-input-wrap input {
  height: 51px;
  padding: 0 14px 0 42px;
}

#contactScrollSection .lc-input-wrap input::placeholder,
#contactScrollSection .lc-textarea-wrap textarea::placeholder {
  color: #806B76;
  opacity: 1;
}

#contactScrollSection .lc-input-wrap:focus-within input,
#contactScrollSection .lc-textarea-wrap:focus-within textarea {
  border-color: #E7CA9690;
  background: #0D070C;
  box-shadow: 0 0 0 3px #E7CA9610;
}

#contactScrollSection .lc-input-wrap:focus-within .lc-input-icon {
  color: var(--lc-gold);
}

#contactScrollSection .lc-textarea-wrap textarea {
  min-height: 145px;
  padding: 16px;
  resize: vertical;
  line-height: 1.8;
}

#contactScrollSection .lc-textarea-icon {
  position: absolute;
  right: 15px;
  bottom: 16px;
  color: #A88E9955;
  pointer-events: none;
}

#contactScrollSection .lc-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

#contactScrollSection .lc-private-label {
  margin-bottom: 10px;
  color: var(--lc-muted);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: .06em;
}

#contactScrollSection .lc-private-label i {
  margin-right: 4px;
  color: var(--lc-gold);
}

#contactScrollSection .lc-field-error {
  margin-top: 7px;
  color: #E7CA96;
  font-size: 11px;
  line-height: 1.5;
}

/* Submit button */
#contactScrollSection .lc-send-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-height: 57px;
  padding: 7px 8px 7px 20px;
  border: 1px solid #E7CA9650;
  border-radius: 11px;
  background: linear-gradient(100deg, #680825, #9B0F3B 65%, #C71650);
  color: var(--lc-cream);
  cursor: pointer;
  box-shadow: 0 10px 28px #4D0A2430;
  transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;
}

#contactScrollSection .lc-send-button:hover:not(:disabled) {
  transform: translateY(-2px);
  border-color: var(--lc-gold);
  box-shadow: 0 15px 32px #4D0A2450;
}

#contactScrollSection .lc-send-button:focus-visible {
  outline: 2px solid var(--lc-gold);
  outline-offset: 4px;
}

#contactScrollSection .lc-send-button:disabled {
  cursor: not-allowed;
  opacity: .45;
}

#contactScrollSection .lc-send-button-content {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .02em;
}

#contactScrollSection .lc-send-button-content > i {
  color: var(--lc-gold);
}

#contactScrollSection .lc-send-arrow {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #F6E9D511;
  color: var(--lc-gold);
  transition: transform .25s ease, background .25s ease;
}

#contactScrollSection .lc-send-button:hover:not(:disabled) .lc-send-arrow {
  transform: translateX(3px);
  background: #F6E9D51f;
}

/* Privacy footnote */
#contactScrollSection .lc-form-footnote {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: var(--lc-muted);
  font-size: 10px;
  line-height: 1.8;
}

#contactScrollSection .lc-form-footnote > i {
  margin-top: 2px;
  color: var(--lc-gold);
  font-size: 12px;
}

#contactScrollSection .lc-form-footnote p {
  margin: 0;
}

/* Footer signature */
#contactScrollSection .lc-concierge-bottom {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-top: 31px;
}

#contactScrollSection .lc-bottom-line {
  flex: 1;
  height: 1px;
  background: #E7CA9623;
}

#contactScrollSection .lc-concierge-bottom p {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--lc-muted);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: .15em;
  text-align: center;
}

#contactScrollSection .lc-concierge-bottom p span {
  color: var(--lc-gold);
}

#contactScrollSection .lc-concierge-bottom p i {
  color: var(--lc-rose);
  font-size: 7px;
}

/* Responsive */
@media (max-width: 900px) {
  #contactScrollSection .lc-concierge-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 19px;
  }

  #contactScrollSection .lc-heading-description {
    max-width: 520px;
  }

  #contactScrollSection .lc-concierge-shell {
    grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr);
  }

  #contactScrollSection .lc-concierge-sidebar {
    padding: 27px 22px;
  }

  #contactScrollSection .lc-concierge-form-panel {
    padding: 30px 24px;
  }

  #contactScrollSection .lc-field-row {
    grid-template-columns: 1fr;
    gap: 23px;
  }
}

@media (max-width: 650px) {
  #contactScrollSection.lc-concierge {
    padding-top: 10px;
  }

  #contactScrollSection .lc-concierge-top {
    align-items: flex-start;
  }

  #contactScrollSection .lc-concierge-kicker {
    font-size: 8px;
    letter-spacing: .12em;
  }

  #contactScrollSection .lc-concierge-number {
    font-size: 8px;
  }

  #contactScrollSection .lc-concierge-heading {
    padding: 35px 0 28px;
  }

  #contactScrollSection .lc-concierge-heading h2 {
    font-size: clamp(35px, 10vw, 49px);
  }

  #contactScrollSection .lc-heading-description {
    font-size: 13px;
  }

  #contactScrollSection .lc-concierge-shell {
    grid-template-columns: 1fr;
    border-radius: 7px 20px 7px 20px;
  }

  #contactScrollSection .lc-concierge-sidebar {
    padding: 27px 22px 24px;
    border-right: 0;
    border-bottom: 1px solid #E7CA9628;
  }

  #contactScrollSection .lc-sidebar-copy {
    margin-top: 28px;
  }

  #contactScrollSection .lc-sidebar-copy h3 {
    font-size: 30px;
  }

  #contactScrollSection .lc-service-menu {
    margin-top: 19px;
  }

  #contactScrollSection .lc-support-status {
    margin-top: 18px;
  }

  #contactScrollSection .lc-sidebar-footer {
    padding-top: 22px;
  }

  #contactScrollSection .lc-concierge-form-panel {
    padding: 28px 21px;
  }

  #contactScrollSection .lc-form-header {
    align-items: flex-start;
  }

  #contactScrollSection .lc-form-icon {
    width: 42px;
    height: 42px;
    font-size: 16px;
  }

  #contactScrollSection .lc-form-header h3 {
    font-size: 27px;
  }

  #contactScrollSection .lc-form-divider {
    margin: 22px 0 25px;
  }

  #contactScrollSection .lc-contact-form {
    gap: 21px;
  }

  #contactScrollSection .lc-field-row {
    grid-template-columns: 1fr;
    gap: 21px;
  }

  #contactScrollSection .lc-concierge-bottom {
    gap: 12px;
  }

  #contactScrollSection .lc-concierge-bottom p {
    flex-wrap: wrap;
    gap: 6px;
    font-size: 7px;
  }
}

@media (prefers-reduced-motion: reduce) {
  #contactScrollSection *,
  #contactScrollSection *::before,
  #contactScrollSection *::after {
    transition-duration: .01ms !important;
    animation-duration: .01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>



<!-- =========================================================================
     12. LUCKYCREST FAQ — PREMIUM INTERACTIVE HELP CENTER
     New concept: Category-led navigation + high-contrast accordion
     Angular FAQ logic preserved: faqColumns, openFaqIndex, toggleFaq()
     ========================================================================= -->

<section id="lcFaqCenter" class="lq-center">

  <div class="lq-container">

    <!-- ===================== HERO ===================== -->
    <header class="lq-hero">

      <div class="lq-hero-copy">
        <div class="lq-eyebrow">
          <span class="lq-live-dot"></span>
          LUCKYCREST HELP CENTER
          <span class="lq-eyebrow-line"></span>
          <span class="lq-eyebrow-code">LC / 012</span>
        </div>

        <h2 class="lq-title">
          How can we
          <span>help you?</span>
        </h2>

        <p class="lq-subtitle">
          Everything you need to know, all in one place.
          Explore our guides or open a question to find your answer.
        </p>

        <div class="lq-hero-pills">
          <span><i class="fas fa-check-circle"></i> Quick answers</span>
          <span><i class="fas fa-layer-group"></i> Easy to explore</span>
        </div>
      </div>

      <div class="lq-hero-visual" aria-hidden="true">
        <div class="lq-visual-glow"></div>

        <div class="lq-visual-card">
          <div class="lq-visual-card-top">
            <span class="lq-visual-brand">
              <span class="lq-brand-mark">L</span>
              LUCKYCREST
            </span>
            <span class="lq-visual-status">
              <span></span> HELP DESK
            </span>
          </div>

          <div class="lq-visual-question">
            <span class="lq-visual-question-mark">?</span>
            <div class="lq-visual-lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <div class="lq-visual-card-bottom">
            <span>ANSWERS, MADE SIMPLE.</span>
            <i class="fas fa-arrow-right"></i>
          </div>
        </div>

        <div class="lq-floating-tag lq-floating-tag-one">
          <i class="fas fa-bolt"></i>
          <span>QUICK GUIDE</span>
        </div>

        <div class="lq-floating-tag lq-floating-tag-two">
          <i class="fas fa-comment-dots"></i>
          <span>NEED TO KNOW</span>
        </div>
      </div>

    </header>

    <!-- ===================== CATEGORY NAVIGATION ===================== -->
    <div class="lq-categories-heading">
      <div>
        <span class="lq-overline">BROWSE BY TOPIC</span>
        <h3>Find your answer faster.</h3>
      </div>

      <div class="lq-category-note">
        <i class="fas" [class.fa-hand-pointer]="selectedFaqCategory === 'all'" [class.fa-filter]="selectedFaqCategory !== 'all'"></i>
        <span>{{ selectedFaqCategory === 'all' ? 'Click a topic below to filter' : 'Category: ' + (selectedFaqCategory | titlecase) }}</span>
        <button
          *ngIf="selectedFaqCategory !== 'all'"
          type="button"
          (click)="setFaqCategory('all')"
          class="lq-reset-filter-btn"
          title="Show all questions"
        >
          <i class="fas fa-rotate-left"></i> View All ({{ faqs.length }})
        </button>
      </div>
    </div>

    <div class="lq-categories" role="tablist">

      <button
        type="button"
        class="lq-category"
        [class.lq-category-active]="selectedFaqCategory === 'payments'"
        (click)="setFaqCategory('payments')"
        role="tab"
        [attr.aria-selected]="selectedFaqCategory === 'payments'"
        title="View Payments FAQs"
      >
        <span class="lq-category-icon lq-icon-rose">
          <i class="fas fa-wallet"></i>
        </span>
        <span class="lq-category-text">
          <span class="lq-category-title-wrap">
            <strong>Payments</strong>
            <span class="lq-pill-badge" *ngIf="selectedFaqCategory === 'payments'">Active</span>
          </span>
          <small>Deposits &amp; withdrawals</small>
        </span>
        <span class="lq-category-arrow">
          <i class="fas" [class.fa-check]="selectedFaqCategory === 'payments'" [class.fa-chevron-right]="selectedFaqCategory !== 'payments'"></i>
        </span>
      </button>

      <button
        type="button"
        class="lq-category"
        [class.lq-category-active]="selectedFaqCategory === 'bonuses'"
        (click)="setFaqCategory('bonuses')"
        role="tab"
        [attr.aria-selected]="selectedFaqCategory === 'bonuses'"
        title="View Bonuses FAQs"
      >
        <span class="lq-category-icon lq-icon-gold">
          <i class="fas fa-gift"></i>
        </span>
        <span class="lq-category-text">
          <span class="lq-category-title-wrap">
            <strong>Bonuses</strong>
            <span class="lq-pill-badge" *ngIf="selectedFaqCategory === 'bonuses'">Active</span>
          </span>
          <small>Offers &amp; rewards</small>
        </span>
        <span class="lq-category-arrow">
          <i class="fas" [class.fa-check]="selectedFaqCategory === 'bonuses'" [class.fa-chevron-right]="selectedFaqCategory !== 'bonuses'"></i>
        </span>
      </button>

      <button
        type="button"
        class="lq-category"
        [class.lq-category-active]="selectedFaqCategory === 'account'"
        (click)="setFaqCategory('account')"
        role="tab"
        [attr.aria-selected]="selectedFaqCategory === 'account'"
        title="View My account FAQs"
      >
        <span class="lq-category-icon lq-icon-plum">
          <i class="fas fa-user-shield"></i>
        </span>
        <span class="lq-category-text">
          <span class="lq-category-title-wrap">
            <strong>My account</strong>
            <span class="lq-pill-badge" *ngIf="selectedFaqCategory === 'account'">Active</span>
          </span>
          <small>Profile &amp; verification</small>
        </span>
        <span class="lq-category-arrow">
          <i class="fas" [class.fa-check]="selectedFaqCategory === 'account'" [class.fa-chevron-right]="selectedFaqCategory !== 'account'"></i>
        </span>
      </button>

      <button
        type="button"
        class="lq-category"
        [class.lq-category-active]="selectedFaqCategory === 'games'"
        (click)="setFaqCategory('games')"
        role="tab"
        [attr.aria-selected]="selectedFaqCategory === 'games'"
        title="View Games FAQs"
      >
        <span class="lq-category-icon lq-icon-cream">
          <i class="fas fa-gamepad"></i>
        </span>
        <span class="lq-category-text">
          <span class="lq-category-title-wrap">
            <strong>Games</strong>
            <span class="lq-pill-badge" *ngIf="selectedFaqCategory === 'games'">Active</span>
          </span>
          <small>Playing &amp; game info</small>
        </span>
        <span class="lq-category-arrow">
          <i class="fas" [class.fa-check]="selectedFaqCategory === 'games'" [class.fa-chevron-right]="selectedFaqCategory !== 'games'"></i>
        </span>
      </button>

    </div>

    <!-- ===================== FAQ AREA ===================== -->
    <div class="lq-faq-layout">

      <main class="lq-faq-main">

        <div class="lq-faq-heading">
          <div>
            <span class="lq-overline">THE ANSWER LIBRARY</span>
            <h3>
              Frequently asked questions
              <span class="lq-active-filter-badge" *ngIf="selectedFaqCategory !== 'all'">
                &bull; {{ selectedFaqCategory | titlecase }}
              </span>
            </h3>
            <p>
              Showing {{ filteredFaqs.length }} question{{ filteredFaqs.length > 1 ? 's' : '' }}
              <span *ngIf="selectedFaqCategory !== 'all'">for <strong>{{ selectedFaqCategory | titlecase }}</strong></span>
              — click any question to reveal the details.
            </p>
          </div>

          <div class="lq-faq-heading-icon">
            <i class="fas fa-circle-question"></i>
          </div>
        </div>

        <div class="lq-faq-list">

          <div
            *ngFor="let column of faqColumns; trackBy: trackByIndex"
            class="lq-faq-column"
          >

            <article
              *ngFor="let entry of column; trackBy: trackByFaqEntryIndex"
              class="lq-faq-item"
              [class.lq-is-open]="openFaqIndex === entry.index"
            >

              <button
                type="button"
                class="lq-faq-question"
                [attr.aria-expanded]="openFaqIndex === entry.index"
                [attr.aria-controls]="'faq-panel-' + entry.index"
                (click)="toggleFaq(entry.index)"
              >

                <span class="lq-faq-number">
                  {{ entry.index + 1 | number: "2.0-0" }}
                </span>

                <span class="lq-faq-question-text">
                  {{ entry.faq.question }}
                </span>

                <span class="lq-faq-toggle">
                  <i
                    class="fas"
                    [class.fa-plus]="openFaqIndex !== entry.index"
                    [class.fa-minus]="openFaqIndex === entry.index"
                  ></i>
                </span>

              </button>

              <div
                *ngIf="openFaqIndex === entry.index"
                class="lq-faq-answer"
                [id]="'faq-panel-' + entry.index"
                role="region"
                [attr.aria-label]="entry.faq.question"
              >
                <div class="lq-answer-inner">

                  <div class="lq-answer-icon">
                    <i class="fas fa-check"></i>
                  </div>

                  <div class="lq-answer-copy">
                    <div class="lq-answer-header-row">
                      <span class="lq-answer-label">HERE'S WHAT TO KNOW</span>
                      <span class="lq-answer-badge" *ngIf="entry.faq.badge">
                        {{ entry.faq.badge }}
                      </span>
                    </div>
                    <p>{{ entry.faq.answer }}</p>
                  </div>

                </div>

                <div class="lq-answer-bottom">
                  <span><i class="fas fa-shield-alt"></i> LUCKYCREST VERIFIED INFORMATION</span>
                  <span *ngIf="entry.faq.category"><i class="fas fa-tag"></i> {{ entry.faq.category | uppercase }}</span>
                  <span>REF. {{ entry.index + 1 | number: "3.0-0" }}</span>
                </div>
              </div>

            </article>

          </div>

        </div>

      </main>

      <!-- ===================== SIDE CARD ===================== -->
      <aside class="lq-help-sidebar">

        <div class="lq-sidebar-top">
          <span class="lq-sidebar-label">QUICK ASSISTANCE</span>
          <span class="lq-sidebar-icon">
            <i class="fas fa-headset"></i>
          </span>
        </div>

        <div class="lq-sidebar-illustration">
          <div class="lq-sidebar-orbit lq-sidebar-orbit-one"></div>
          <div class="lq-sidebar-orbit lq-sidebar-orbit-two"></div>
          <div class="lq-sidebar-headset">
            <i class="fas fa-headset"></i>
          </div>
          <span class="lq-sidebar-spark lq-spark-one">✦</span>
          <span class="lq-sidebar-spark lq-spark-two">✧</span>
        </div>

        <span class="lq-sidebar-overline">STILL NEED HELP?</span>

        <h3>We're here to make things easier.</h3>

        <p>
          If you can't find what you're looking for, reach out to the
          support team for further assistance.
        </p>

        <div class="lq-sidebar-divider"></div>

        <div class="lq-sidebar-feature">
          <span><i class="fas fa-check"></i></span>
          <div>
            <strong>Clear guidance</strong>
            <small>Help with your questions</small>
          </div>
        </div>

        <div class="lq-sidebar-feature">
          <span><i class="fas fa-check"></i></span>
          <div>
            <strong>24/7 Live Desk</strong>
            <small>Dedicated support response team</small>
          </div>
        </div>

        <button
          type="button"
          (click)="scrollTo('contactScrollSection')"
          class="lq-sidebar-action-btn"
        >
          <span>Contact Support</span>
          <i class="fas fa-arrow-right"></i>
        </button>

        <div class="lq-sidebar-footer">
          <span>LUCKYCREST</span>
          <span>LC / HELP</span>
        </div>

      </aside>

    </div>
    <!-- ===================== BOTTOM STRIP ===================== -->
    <footer class="lq-footer">
      <div class="lq-footer-brand">
        <span class="lq-footer-logo">L</span>
        <span>LUCKYCREST</span>
      </div>

      <div class="lq-footer-message">
        <span class="lq-footer-line"></span>
        A BETTER EXPERIENCE STARTS WITH CLARITY
        <span class="lq-footer-line"></span>
      </div>

      <span class="lq-footer-reference">HELP CENTER / 012</span>
    </footer>

  </div>

</section>

<style>
/* ==========================================================================
   LUCKYCREST HELP CENTER
   Scoped styles
   ========================================================================== */

#lcFaqCenter {
  --lq-bg: #070306;
  --lq-panel: #0D070C;
  --lq-panel-hover: #180B16;
  --lq-burgundy: #4D0A24;
  --lq-burgundy-light: #9B0F3B;
  --lq-rose: #E7CA96;
  --lq-gold: #E7CA96;
  --lq-cream: #F6E9D5;
  --lq-muted: #A88E99;
  --lq-border: rgba(231, 202, 150, 0.16);

  position: relative;
  isolation: isolate;
  overflow: hidden;
  padding: 75px 24px 30px;
  background:
    radial-gradient(ellipse at 10% 0%, rgba(77, 10, 36, 0.24), transparent 35%),
    var(--lq-bg);
  color: var(--lq-cream);
  font-family: inherit;
}

#lcFaqCenter *,
#lcFaqCenter *::before,
#lcFaqCenter *::after {
  box-sizing: border-box;
}

#lcFaqCenter .lq-container {
  max-width: 1220px;
  width: 100%;
  margin: 0 auto;
}

/* HERO */

#lcFaqCenter .lq-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.85fr);
  align-items: center;
  gap: clamp(35px, 6vw, 85px);
  padding: 0 0 53px;
  border-bottom: 1px solid var(--lq-border);
}

#lcFaqCenter .lq-hero-copy,
#lcFaqCenter .lq-hero-visual {
  min-width: 0;
}

#lcFaqCenter .lq-eyebrow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  color: var(--lq-gold);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.15em;
}

#lcFaqCenter .lq-live-dot {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--lq-rose);
  box-shadow: 0 0 12px rgba(231, 202, 150, 0.6);
}

#lcFaqCenter .lq-eyebrow-line {
  width: 25px;
  height: 1px;
  background: var(--lq-rose);
}

#lcFaqCenter .lq-eyebrow-code {
  color: var(--lq-muted);
  font-size: 8px;
}

#lcFaqCenter .lq-title {
  margin: 25px 0 0;
  color: var(--lq-cream);
  font-size: clamp(45px, 6.3vw, 76px);
  font-weight: 850;
  letter-spacing: -0.075em;
  line-height: 0.98;
}

#lcFaqCenter .lq-title span {
  display: block;
  margin-top: 7px;
  color: var(--lq-rose);
  font-family: Georgia, "Times New Roman", serif;
  font-weight: 400;
  font-style: italic;
  letter-spacing: -0.06em;
}

#lcFaqCenter .lq-subtitle {
  max-width: 460px;
  margin: 22px 0 0;
  color: var(--lq-muted);
  font-size: 13px;
  line-height: 1.9;
}

#lcFaqCenter .lq-hero-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px;
}

#lcFaqCenter .lq-hero-pills span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid rgba(231, 202, 150, 0.18);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.018);
  color: var(--lq-cream);
  font-size: 9px;
  font-weight: 600;
}

#lcFaqCenter .lq-hero-pills i {
  color: var(--lq-gold);
  font-size: 10px;
}

/* HERO VISUAL */

#lcFaqCenter .lq-hero-visual {
  position: relative;
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
}

#lcFaqCenter .lq-visual-glow {
  position: absolute;
  width: 230px;
  height: 230px;
  border-radius: 50%;
  background: rgba(107, 15, 51, 0.22);
  filter: blur(50px);
}

#lcFaqCenter .lq-visual-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 345px;
  padding: 20px;
  border: 1px solid rgba(231, 202, 150, 0.27);
  border-radius: 13px;
  background:
    linear-gradient(145deg, rgba(107, 15, 51, 0.2), transparent 55%),
    #0D070C;
  box-shadow: 0 25px 65px rgba(0, 0, 0, 0.25);
  transform: rotate(-2deg);
  transition: transform 0.35s ease, border-color 0.35s ease;
}

#lcFaqCenter .lq-visual-card:hover {
  transform: rotate(0deg) translateY(-3px);
  border-color: rgba(231, 202, 150, 0.5);
}

#lcFaqCenter .lq-visual-card-top,
#lcFaqCenter .lq-visual-card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

#lcFaqCenter .lq-visual-brand {
  display: flex;
  align-items: center;
  gap: 9px;
  color: var(--lq-cream);
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.12em;
}

#lcFaqCenter .lq-brand-mark {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.5);
  color: var(--lq-gold);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
}

#lcFaqCenter .lq-visual-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--lq-muted);
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

#lcFaqCenter .lq-visual-status > span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--lq-gold);
}

#lcFaqCenter .lq-visual-question {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 21px;
  min-height: 165px;
  margin: 17px 0;
  border-top: 1px solid var(--lq-border);
  border-bottom: 1px solid var(--lq-border);
  background: radial-gradient(ellipse at center, rgba(107, 15, 51, 0.22), transparent 72%);
}

#lcFaqCenter .lq-visual-question-mark {
  display: grid;
  width: 91px;
  height: 91px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.5);
  border-radius: 50%;
  color: var(--lq-cream);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 65px;
  font-style: italic;
  line-height: 1;
  box-shadow: 0 0 35px rgba(77, 10, 36, 0.25);
}

#lcFaqCenter .lq-visual-lines {
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 65px;
}

#lcFaqCenter .lq-visual-lines span {
  display: block;
  height: 5px;
  border-radius: 5px;
  background: rgba(231, 202, 150, 0.3);
}

#lcFaqCenter .lq-visual-lines span:nth-child(1) {
  width: 100%;
  background: var(--lq-rose);
}

#lcFaqCenter .lq-visual-lines span:nth-child(2) {
  width: 75%;
}

#lcFaqCenter .lq-visual-lines span:nth-child(3) {
  width: 48%;
}

#lcFaqCenter .lq-visual-card-bottom {
  color: var(--lq-muted);
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

#lcFaqCenter .lq-visual-card-bottom i {
  color: var(--lq-gold);
  font-size: 12px;
}

#lcFaqCenter .lq-floating-tag {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 13px;
  border: 1px solid rgba(231, 202, 150, 0.25);
  border-radius: 7px;
  background: #180B16;
  color: var(--lq-cream);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.06em;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
}

#lcFaqCenter .lq-floating-tag i {
  color: var(--lq-gold);
  font-size: 12px;
}

#lcFaqCenter .lq-floating-tag-one {
  top: 22px;
  left: -5px;
}

#lcFaqCenter .lq-floating-tag-two {
  right: -5px;
  bottom: 22px;
}

/* CATEGORY HEADING */

#lcFaqCenter .lq-categories-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin: 43px 0 20px;
}

#lcFaqCenter .lq-overline {
  display: block;
  margin-bottom: 8px;
  color: var(--lq-rose);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

#lcFaqCenter .lq-categories-heading h3 {
  margin: 0;
  color: var(--lq-cream);
  font-size: clamp(22px, 2.6vw, 30px);
  font-weight: 800;
  letter-spacing: -0.05em;
}

#lcFaqCenter .lq-category-note {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
  color: var(--lq-muted);
  font-size: 10px;
}

#lcFaqCenter .lq-category-note i {
  color: var(--lq-gold);
}

/* CATEGORY CARDS */

#lcFaqCenter .lq-categories {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 13px;
}

#lcFaqCenter .lq-category {
  position: relative;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 16px 14px;
  border: 1px solid rgba(231, 202, 150, 0.16);
  border-radius: 12px;
  background: #0D070C;
  color: var(--lq-cream);
  text-align: left;
  font: inherit;
  cursor: pointer;
  transition:
    background 0.25s ease,
    border-color 0.25s ease,
    transform 0.25s ease,
    box-shadow 0.25s ease;
  outline: none;
  user-select: none;
}

#lcFaqCenter .lq-category:hover {
  transform: translateY(-3px);
  border-color: rgba(231, 202, 150, 0.45);
  background: #180B16;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

#lcFaqCenter .lq-category.lq-category-active {
  background: linear-gradient(135deg, rgba(107, 15, 51, 0.48) 0%, rgba(27, 12, 23, 0.98) 72%);
  border-color: var(--lq-gold);
  box-shadow:
    0 0 0 1px rgba(231, 202, 150, 0.12),
    0 0 25px rgba(231, 202, 150, 0.18),
    0 10px 30px rgba(0, 0, 0, 0.45);
  transform: translateY(-3px);
}

#lcFaqCenter .lq-category.lq-category-active .lq-category-icon {
  transform: scale(1.06);
  box-shadow: 0 0 16px rgba(231, 202, 150, 0.35);
  border: 1px solid rgba(231, 202, 150, 0.4);
}

#lcFaqCenter .lq-category.lq-category-active .lq-category-text strong {
  color: var(--lq-gold);
}

#lcFaqCenter .lq-category-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

#lcFaqCenter .lq-pill-badge {
  display: inline-flex;
  align-items: center;
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(231, 202, 150, 0.2);
  color: var(--lq-gold);
  border: 1px solid rgba(231, 202, 150, 0.35);
}

#lcFaqCenter .lq-category-icon {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 10px;
  font-size: 16px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

#lcFaqCenter .lq-icon-rose {
  background: rgba(231, 202, 150, 0.12);
  color: var(--lq-rose);
}

#lcFaqCenter .lq-icon-gold {
  background: rgba(231, 202, 150, 0.1);
  color: var(--lq-gold);
}

#lcFaqCenter .lq-icon-plum {
  background: rgba(107, 15, 51, 0.32);
  color: #E5A4B8;
}

#lcFaqCenter .lq-icon-cream {
  background: rgba(246, 233, 213, 0.08);
  color: var(--lq-cream);
}

#lcFaqCenter .lq-category-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
}

#lcFaqCenter .lq-category-text strong {
  color: var(--lq-cream);
  font-size: 13px;
  font-weight: 750;
  transition: color 0.2s ease;
}

#lcFaqCenter .lq-category-text small {
  color: var(--lq-muted);
  font-size: 9.5px;
  line-height: 1.5;
}

#lcFaqCenter .lq-category-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 10px;
  color: var(--lq-muted);
  background: rgba(255, 255, 255, 0.04);
  transition: all 0.25s ease;
}

#lcFaqCenter .lq-category:hover .lq-category-arrow {
  color: var(--lq-rose);
  background: rgba(231, 202, 150, 0.15);
  transform: translateX(2px);
}

#lcFaqCenter .lq-category.lq-category-active .lq-category-arrow {
  color: #070306;
  background: var(--lq-gold);
  box-shadow: 0 0 10px rgba(231, 202, 150, 0.5);
}

#lcFaqCenter .lq-reset-filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 11px;
  font-size: 9px;
  font-weight: 700;
  color: var(--lq-gold);
  background: rgba(231, 202, 150, 0.12);
  border: 1px solid rgba(231, 202, 150, 0.3);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 8px;
}

#lcFaqCenter .lq-reset-filter-btn:hover {
  background: rgba(231, 202, 150, 0.25);
  border-color: var(--lq-gold);
  box-shadow: 0 0 14px rgba(231, 202, 150, 0.18);
  transform: scale(1.04);
}

#lcFaqCenter .lq-active-filter-badge {
  font-size: 0.8em;
  color: var(--lq-gold);
  font-weight: 600;
}

#lcFaqCenter .lq-answer-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

#lcFaqCenter .lq-answer-badge {
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(231, 202, 150, 0.15);
  color: var(--lq-gold);
  border: 1px solid rgba(231, 202, 150, 0.3);
}

#lcFaqCenter .lq-sidebar-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  margin-top: 18px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4D0A24 0%, #9B0F3B 58%, #C71650 100%);
  border: 1px solid rgba(231, 202, 150, 0.35);
  color: var(--lq-cream);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: all 0.25s ease;
}

#lcFaqCenter .lq-sidebar-action-btn:hover {
  background: linear-gradient(135deg, #9B0F3B 0%, #C71650 68%, #A91D55 100%);
  border-color: var(--lq-gold);
  transform: translateY(-2px);
  box-shadow: 0 5px 18px rgba(107, 15, 51, 0.45), 0 0 12px rgba(231, 202, 150, 0.12);
}

/* FAQ LAYOUT */

#lcFaqCenter .lq-faq-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 275px;
  align-items: start;
  gap: 30px;
  margin-top: 57px;
}

#lcFaqCenter .lq-faq-main {
  min-width: 0;
}

#lcFaqCenter .lq-faq-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;
}

#lcFaqCenter .lq-faq-heading h3 {
  margin: 0;
  color: var(--lq-cream);
  font-size: clamp(20px, 2.4vw, 28px);
  font-weight: 800;
  letter-spacing: -0.045em;
}

#lcFaqCenter .lq-faq-heading p {
  margin: 9px 0 0;
  color: var(--lq-muted);
  font-size: 11px;
  line-height: 1.7;
}

#lcFaqCenter .lq-faq-heading-icon {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.22);
  border-radius: 10px;
  background: rgba(107, 15, 51, 0.15);
  color: var(--lq-rose);
  font-size: 21px;
}

/* FAQ ITEMS */

#lcFaqCenter .lq-faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#lcFaqCenter .lq-faq-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#lcFaqCenter .lq-faq-item {
  min-width: 0;
  overflow: hidden;
  border: 1px solid rgba(231, 202, 150, 0.15);
  border-radius: 9px;
  background: #0D070C;
  transition:
    border-color 0.25s ease,
    background 0.25s ease,
    box-shadow 0.25s ease;
}

#lcFaqCenter .lq-faq-item:hover {
  border-color: rgba(231, 202, 150, 0.35);
}

#lcFaqCenter .lq-faq-item.lq-is-open {
  border-color: rgba(231, 202, 150, 0.52);
  background: #120810;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.14);
}

#lcFaqCenter .lq-faq-question {
  display: grid;
  grid-template-columns: 39px minmax(0, 1fr) 36px;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 78px;
  padding: 15px 17px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  font: inherit;
  cursor: pointer;
}

#lcFaqCenter .lq-faq-question:focus-visible {
  outline-offset: 3px;
}

#lcFaqCenter .lq-faq-number {
  display: grid;
  width: 39px;
  height: 39px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.17);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.025);
  color: var(--lq-rose);
  font-family: "Courier New", monospace;
  font-size: 12px;
  font-weight: 800;
  transition:
    background 0.25s ease,
    color 0.25s ease,
    border-color 0.25s ease;
}

#lcFaqCenter .lq-is-open .lq-faq-number {
  border-color: var(--lq-rose);
  background: var(--lq-rose);
  color: #070306;
}

#lcFaqCenter .lq-faq-question-text {
  color: var(--lq-cream);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.65;
  overflow-wrap: anywhere;
  transition: color 0.25s ease;
}

#lcFaqCenter .lq-faq-question:hover .lq-faq-question-text,
#lcFaqCenter .lq-is-open .lq-faq-question-text {
  color: var(--lq-rose);
}

#lcFaqCenter .lq-faq-toggle {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.025);
  color: var(--lq-rose);
  font-size: 11px;
  transition:
    background 0.25s ease,
    color 0.25s ease,
    transform 0.25s ease;
}

#lcFaqCenter .lq-is-open .lq-faq-toggle {
  transform: rotate(180deg);
  border-color: var(--lq-gold);
  background: var(--lq-gold);
  color: var(--lq-bg);
}

/* ANSWER PANEL */

#lcFaqCenter .lq-faq-answer {
  margin: 0 17px 16px 70px;
  padding: 17px;
  border: 1px solid rgba(231, 202, 150, 0.12);
  border-radius: 8px;
  background: #070306;
  animation: lqAnswerIn 0.25s ease both;
}

#lcFaqCenter .lq-answer-inner {
  display: grid;
  grid-template-columns: 27px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
}

#lcFaqCenter .lq-answer-icon {
  display: grid;
  width: 27px;
  height: 27px;
  place-items: center;
  border-radius: 7px;
  background: rgba(231, 202, 150, 0.12);
  color: var(--lq-gold);
  font-size: 11px;
}

#lcFaqCenter .lq-answer-copy {
  min-width: 0;
}

#lcFaqCenter .lq-answer-label {
  display: block;
  margin: 2px 0 9px;
  color: var(--lq-gold);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

#lcFaqCenter .lq-answer-copy p {
  margin: 0;
  color: #D9C9D0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.9;
  overflow-wrap: anywhere;
}

#lcFaqCenter .lq-answer-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 9px;
  margin-top: 17px;
  padding-top: 12px;
  border-top: 1px solid rgba(231, 202, 150, 0.12);
  color: var(--lq-muted);
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.07em;
}

#lcFaqCenter .lq-answer-bottom i {
  margin-right: 5px;
  color: var(--lq-gold);
}

/* HELP SIDEBAR */

#lcFaqCenter .lq-help-sidebar {
  position: relative;
  min-width: 0;
  overflow: hidden;
  padding: 21px;
  border: 1px solid rgba(231, 202, 150, 0.2);
  border-radius: 12px;
  background:
    linear-gradient(155deg, rgba(107, 15, 51, 0.25), transparent 48%),
    #0D070C;
}

#lcFaqCenter .lq-sidebar-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

#lcFaqCenter .lq-sidebar-label {
  color: var(--lq-gold);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

#lcFaqCenter .lq-sidebar-icon {
  display: grid;
  width: 35px;
  height: 35px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.2);
  border-radius: 8px;
  color: var(--lq-rose);
  font-size: 15px;
}

#lcFaqCenter .lq-sidebar-illustration {
  position: relative;
  display: grid;
  height: 155px;
  place-items: center;
  margin: 16px 0 21px;
  overflow: hidden;
  border: 1px solid rgba(231, 202, 150, 0.1);
  border-radius: 9px;
  background: radial-gradient(ellipse at center, rgba(107, 15, 51, 0.28), transparent 70%);
}

#lcFaqCenter .lq-sidebar-orbit {
  position: absolute;
  border: 1px solid rgba(231, 202, 150, 0.25);
  border-radius: 50%;
}

#lcFaqCenter .lq-sidebar-orbit-one {
  width: 105px;
  height: 105px;
}

#lcFaqCenter .lq-sidebar-orbit-two {
  width: 135px;
  height: 135px;
  border-color: rgba(231, 202, 150, 0.15);
}

#lcFaqCenter .lq-sidebar-headset {
  position: relative;
  z-index: 1;
  display: grid;
  width: 62px;
  height: 62px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.55);
  border-radius: 50%;
  background: #0D070C;
  color: var(--lq-gold);
  font-size: 25px;
  box-shadow: 0 0 35px rgba(77, 10, 36, 0.4);
}

#lcFaqCenter .lq-sidebar-spark {
  position: absolute;
  color: var(--lq-rose);
  font-size: 20px;
}

#lcFaqCenter .lq-spark-one {
  top: 23px;
  right: 30px;
}

#lcFaqCenter .lq-spark-two {
  bottom: 23px;
  left: 30px;
  color: var(--lq-gold);
}

#lcFaqCenter .lq-sidebar-overline {
  display: block;
  margin-bottom: 9px;
  color: var(--lq-rose);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

#lcFaqCenter .lq-help-sidebar h3 {
  margin: 0;
  color: var(--lq-cream);
  font-size: 23px;
  font-weight: 800;
  letter-spacing: -0.05em;
  line-height: 1.25;
}

#lcFaqCenter .lq-help-sidebar > p {
  margin: 12px 0 0;
  color: var(--lq-muted);
  font-size: 11px;
  line-height: 1.9;
}

#lcFaqCenter .lq-sidebar-divider {
  height: 1px;
  margin: 21px 0;
  background: var(--lq-border);
}

#lcFaqCenter .lq-sidebar-feature {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 14px;
}

#lcFaqCenter .lq-sidebar-feature > span {
  display: grid;
  width: 23px;
  height: 23px;
  flex: 0 0 23px;
  place-items: center;
  border-radius: 6px;
  background: rgba(231, 202, 150, 0.1);
  color: var(--lq-gold);
  font-size: 9px;
}

#lcFaqCenter .lq-sidebar-feature > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

#lcFaqCenter .lq-sidebar-feature strong {
  color: var(--lq-cream);
  font-size: 10px;
  font-weight: 700;
}

#lcFaqCenter .lq-sidebar-feature small {
  color: var(--lq-muted);
  font-size: 9px;
  line-height: 1.6;
}

#lcFaqCenter .lq-sidebar-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 25px;
  padding-top: 13px;
  border-top: 1px solid var(--lq-border);
  color: rgba(168, 142, 153, 0.7);
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

/* FOOTER */

#lcFaqCenter .lq-footer {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 15px;
  margin-top: 40px;
  padding-top: 18px;
  border-top: 1px solid var(--lq-border);
}

#lcFaqCenter .lq-footer-brand {
  display: flex;
  align-items: center;
  gap: 9px;
  color: var(--lq-cream);
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.13em;
}

#lcFaqCenter .lq-footer-logo {
  display: grid;
  width: 27px;
  height: 27px;
  place-items: center;
  border: 1px solid rgba(231, 202, 150, 0.4);
  color: var(--lq-gold);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
}

#lcFaqCenter .lq-footer-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--lq-muted);
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-align: center;
}

#lcFaqCenter .lq-footer-line {
  display: block;
  width: 15px;
  height: 1px;
  background: var(--lq-rose);
}

#lcFaqCenter .lq-footer-reference {
  color: var(--lq-muted);
  font-family: "Courier New", monospace;
  font-size: 7px;
  letter-spacing: 0.07em;
  text-align: right;
}

/* ANIMATION */

@keyframes lqAnswerIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* TABLET */

@media (max-width: 1000px) {
  #lcFaqCenter {
    padding: 65px 22px 28px;
  }

  #lcFaqCenter .lq-hero {
    gap: 32px;
  }

  #lcFaqCenter .lq-title {
    font-size: clamp(44px, 6.5vw, 65px);
  }

  #lcFaqCenter .lq-categories {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #lcFaqCenter .lq-faq-layout {
    grid-template-columns: minmax(0, 1fr) 245px;
    gap: 22px;
  }

  #lcFaqCenter .lq-faq-question {
    grid-template-columns: 35px minmax(0, 1fr) 32px;
    gap: 10px;
    padding-right: 12px;
    padding-left: 12px;
  }

  #lcFaqCenter .lq-faq-answer {
    margin-left: 57px;
    margin-right: 12px;
  }
}

/* MOBILE */

@media (max-width: 700px) {
  #lcFaqCenter {
    padding: 53px 16px 24px;
  }

  #lcFaqCenter .lq-hero {
    grid-template-columns: 1fr;
    gap: 22px;
    padding-bottom: 36px;
  }

  #lcFaqCenter .lq-title {
    font-size: clamp(47px, 11vw, 68px);
  }

  #lcFaqCenter .lq-subtitle {
    font-size: 12px;
  }

  #lcFaqCenter .lq-hero-visual {
    min-height: 245px;
  }

  #lcFaqCenter .lq-visual-card {
    max-width: 340px;
  }

  #lcFaqCenter .lq-floating-tag-one {
    left: 0;
  }

  #lcFaqCenter .lq-floating-tag-two {
    right: 0;
  }

  #lcFaqCenter .lq-categories-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    margin-top: 33px;
  }

  #lcFaqCenter .lq-categories-heading h3 {
    font-size: 25px;
  }

  #lcFaqCenter .lq-categories {
    gap: 10px;
  }

  #lcFaqCenter .lq-category {
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 9px;
    padding: 13px 10px;
  }

  #lcFaqCenter .lq-category-icon {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }

  #lcFaqCenter .lq-category-text strong {
    font-size: 11px;
  }

  #lcFaqCenter .lq-category-text small {
    font-size: 8px;
  }

  #lcFaqCenter .lq-faq-layout {
    grid-template-columns: 1fr;
    gap: 28px;
    margin-top: 41px;
  }

  #lcFaqCenter .lq-faq-heading {
    margin-bottom: 18px;
  }

  #lcFaqCenter .lq-faq-heading h3 {
    font-size: 23px;
  }

  #lcFaqCenter .lq-faq-heading p {
    font-size: 10px;
  }

  #lcFaqCenter .lq-faq-heading-icon {
    width: 42px;
    height: 42px;
    flex-basis: 42px;
    font-size: 18px;
  }

  #lcFaqCenter .lq-faq-list,
  #lcFaqCenter .lq-faq-column {
    gap: 9px;
  }

  #lcFaqCenter .lq-faq-question {
    grid-template-columns: 36px minmax(0, 1fr) 32px;
    min-height: 72px;
    gap: 11px;
    padding: 12px;
  }

  #lcFaqCenter .lq-faq-number {
    width: 36px;
    height: 36px;
    font-size: 11px;
  }

  #lcFaqCenter .lq-faq-question-text {
    font-size: 12px;
  }

  #lcFaqCenter .lq-faq-toggle {
    width: 31px;
    height: 31px;
  }

  #lcFaqCenter .lq-faq-answer {
    margin: 0 10px 11px;
    padding: 14px;
  }

  #lcFaqCenter .lq-answer-copy p {
    font-size: 11px;
  }

  #lcFaqCenter .lq-help-sidebar {
    padding: 18px;
  }

  #lcFaqCenter .lq-sidebar-illustration {
    height: 130px;
  }

  #lcFaqCenter .lq-help-sidebar h3 {
    font-size: 24px;
  }

  #lcFaqCenter .lq-footer {
    grid-template-columns: 1fr auto;
    row-gap: 14px;
    margin-top: 30px;
  }

  #lcFaqCenter .lq-footer-message {
    grid-column: 1 / -1;
    grid-row: 2;
    justify-content: flex-start;
    text-align: left;
  }
}

/* SMALL MOBILE */

@media (max-width: 390px) {
  #lcFaqCenter {
    padding-right: 12px;
    padding-left: 12px;
  }

  #lcFaqCenter .lq-eyebrow {
    gap: 7px;
    font-size: 7px;
  }

  #lcFaqCenter .lq-title {
    font-size: 46px;
  }

  #lcFaqCenter .lq-hero-pills {
    gap: 7px;
  }

  #lcFaqCenter .lq-hero-pills span {
    padding: 8px;
    font-size: 8px;
  }

  #lcFaqCenter .lq-category {
    grid-template-columns: 31px minmax(0, 1fr);
    gap: 7px;
    padding: 11px 8px;
  }

  #lcFaqCenter .lq-category-icon {
    width: 31px;
    height: 31px;
    font-size: 12px;
  }

  #lcFaqCenter .lq-category-text strong {
    font-size: 10px;
  }

  #lcFaqCenter .lq-category-text small {
    font-size: 7px;
  }

  #lcFaqCenter .lq-faq-question {
    grid-template-columns: 32px minmax(0, 1fr) 29px;
    gap: 9px;
    padding: 10px;
  }

  #lcFaqCenter .lq-faq-number {
    width: 32px;
    height: 32px;
    font-size: 10px;
  }

  #lcFaqCenter .lq-faq-question-text {
    font-size: 11px;
  }

  #lcFaqCenter .lq-faq-toggle {
    width: 28px;
    height: 28px;
    font-size: 9px;
  }

  #lcFaqCenter .lq-faq-answer {
    padding: 11px;
  }

  #lcFaqCenter .lq-answer-inner {
    grid-template-columns: 23px minmax(0, 1fr);
    gap: 9px;
  }

  #lcFaqCenter .lq-answer-icon {
    width: 23px;
    height: 23px;
  }

  #lcFaqCenter .lq-footer-brand {
    font-size: 8px;
  }

  #lcFaqCenter .lq-footer-reference {
    font-size: 6px;
  }
}

/* ACCESSIBILITY */

@media (prefers-reduced-motion: reduce) {
  #lcFaqCenter *,
  #lcFaqCenter *::before,
  #lcFaqCenter *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>

<!-- ===================== NEW LUXURY NEXT-GEN FOOTER ===================== -->
<footer class="relative z-20 overflow-hidden border-t border-[#E7CA96]/20 bg-[#030204] text-slate-300">

  <!-- Ambient Luxury Glows -->
  <div class="pointer-events-none absolute -top-40 left-1/4 h-96 w-96 rounded-full bg-[#4D0A24]/25 blur-[120px]"></div>
  <div class="pointer-events-none absolute -bottom-40 right-1/4 h-96 w-96 rounded-full bg-[#E7CA96]/10 blur-[130px]"></div>

  <div class="relative mx-auto max-w-[1600px] px-4 py-12 sm:px-8 lg:py-16">

    <!-- ================= 1. VIP LOUNGE CONNECT BAR ================= -->
    <div class="relative mb-14 overflow-hidden rounded-2xl border border-[#E7CA96]/20 bg-gradient-to-r from-[#0D070C] via-[#180B16] to-[#0D070C] p-6 shadow-2xl sm:p-8 lg:p-10">
      <div class="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#E7CA96]/15 blur-[80px]"></div>

      <div class="relative z-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
        <!-- Left: Copy & Badge -->
        <div class="lg:col-span-7">
          <div class="mb-3 inline-flex items-center gap-2 rounded-full border border-[#E7CA96]/30 bg-[#E7CA96]/10 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-[#E7CA96]">
            <i class="fas fa-crown"></i>
            <span>Luckycrest VIP Lounge</span>
          </div>
          <h2 class="text-2xl font-black tracking-tight text-[#F6E9D5] sm:text-3xl lg:text-4xl">
            Connect &amp; Elevate Your Gaming Journey.
          </h2>
          <p class="mt-2 text-xs leading-relaxed text-slate-400 sm:text-sm">
            Join the inner circle of 100,000+ players. Receive weekly coin drops, VIP multiplier boosts, and private tournament invites straight to your inbox.
          </p>
        </div>

        <!-- Right: Interactive VIP Connect Input -->
        <div class="lg:col-span-5">
          <div *ngIf="!footerSubscribed" class="flex flex-col gap-3 sm:flex-row sm:items-center">
            <div class="relative flex-1">
              <i class="fas fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-xs text-slate-500"></i>
              <input
                #footerEmailInput
                type="email"
                placeholder="Enter email for instant coin drop..."
                (keyup.enter)="subscribeFooter(footerEmailInput.value)"
                class="w-full rounded-xl border border-white/10 bg-white/5 py-3.5 pl-10 pr-4 text-xs text-white placeholder-slate-500 backdrop-blur-sm transition focus:border-[#E7CA96] focus:bg-[#070306] focus:outline-none focus:ring-1 focus:ring-[#E7CA96] sm:text-sm"
              />
            </div>
            <button
              type="button"
              (click)="subscribeFooter(footerEmailInput.value)"
              class="inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl border border-[#E7CA96]/40 bg-gradient-to-r from-[#E7CA96] via-[#E7CA96] to-[#E7CA96] px-6 py-3.5 text-xs font-black uppercase tracking-wider text-[#070306] shadow-lg shadow-[#C71650]/20 transition-all duration-300 hover:scale-[1.03] hover:shadow-[#E7CA96]/30 active:scale-[0.98] sm:text-sm"
            >
              <span>Claim Perks</span>
              <i class="fas fa-bolt"></i>
            </button>
          </div>

          <!-- Subscribed Success State -->
          <div
            *ngIf="footerSubscribed"
            class="flex items-center gap-3 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4 text-emerald-300"
          >
            <i class="fas fa-circle-check text-lg text-emerald-400"></i>
            <div>
              <p class="text-xs font-bold sm:text-sm">Welcome to the Luckycrest VIP Lounge!</p>
              <p class="text-[11px] text-emerald-400/80">Check your inbox for your exclusive coin voucher.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= 2. CORE VALUE PILLARS ================= -->
    <div class="mb-14 grid grid-cols-2 gap-4 border-b border-white/10 pb-12 sm:grid-cols-4 lg:gap-6">
      <div class="flex items-start gap-3 rounded-xl border border-white/5 bg-white/[0.02] p-4 backdrop-blur-sm transition hover:border-[#E7CA96]/30 hover:bg-white/[0.04]">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-[#E7CA96]/30 bg-[#C71650]/10 text-[#E7CA96]">
          <i class="fas fa-bolt text-sm"></i>
        </div>
        <div>
          <h4 class="text-xs font-bold text-[#F6E9D5] sm:text-sm">Instant Delivery</h4>
          <p class="mt-0.5 text-[11px] text-slate-400">Instant coin load &amp; swift payouts</p>
        </div>
      </div>

      <div class="flex items-start gap-3 rounded-xl border border-white/5 bg-white/[0.02] p-4 backdrop-blur-sm transition hover:border-[#E7CA96]/30 hover:bg-white/[0.04]">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-[#E7CA96]/30 bg-[#E7CA96]/10 text-[#E7CA96]">
          <i class="fas fa-shield-halved text-sm"></i>
        </div>
        <div>
          <h4 class="text-xs font-bold text-[#F6E9D5] sm:text-sm">Vault Security</h4>
          <p class="mt-0.5 text-[11px] text-slate-400">256-bit bank-grade encryption</p>
        </div>
      </div>

      <div class="flex items-start gap-3 rounded-xl border border-white/5 bg-white/[0.02] p-4 backdrop-blur-sm transition hover:border-[#E7CA96]/30 hover:bg-white/[0.04]">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-[#E7CA96]/30 bg-[#C71650]/10 text-[#E7CA96]">
          <i class="fas fa-dice text-sm"></i>
        </div>
        <div>
          <h4 class="text-xs font-bold text-[#F6E9D5] sm:text-sm">Provably Fair</h4>
          <p class="mt-0.5 text-[11px] text-slate-400">RNG certified randomness</p>
        </div>
      </div>

      <div class="flex items-start gap-3 rounded-xl border border-white/5 bg-white/[0.02] p-4 backdrop-blur-sm transition hover:border-[#E7CA96]/30 hover:bg-white/[0.04]">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-[#E7CA96]/30 bg-[#E7CA96]/10 text-[#E7CA96]">
          <i class="fas fa-headset text-sm"></i>
        </div>
        <div>
          <h4 class="text-xs font-bold text-[#F6E9D5] sm:text-sm">24/7 Concierge</h4>
          <p class="mt-0.5 text-[11px] text-slate-400">Always on live assistance</p>
        </div>
      </div>
    </div>

    <!-- ================= 3. MULTI-COLUMN NAVIGATION HUB ================= -->
    <div class="grid grid-cols-2 gap-8 border-b border-white/10 pb-12 sm:grid-cols-3 lg:grid-cols-6 lg:gap-8">

      <!-- Column 1 & 2: Brand Information & Socials -->
      <div class="col-span-2">
        <a (click)="scrollToTop()" class="mb-4 inline-flex cursor-pointer items-center gap-3">
          <img
            src="mainLogo.webp"
            alt="Luckycrest Logo"
            class="h-10 w-auto transition-transform hover:scale-105"
            onerror="this.src='assets/images/logo.png'"
          />
        </a>

        <p class="max-w-sm text-xs leading-relaxed text-slate-400 sm:text-sm">
          Luckycrest is the premier digital entertainment and social casino platform. Enjoy exhilarating games, daily bonus rewards, and next-generation interactive gameplay.
        </p>

        <!-- Live Status Pill -->
        <div class="mt-5 inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 text-[11px] font-semibold text-emerald-400">
          <span class="relative flex h-2 w-2">
            <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
            <span class="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
          </span>
          <span>System Online • 99.98% Uptime</span>
        </div>

        <!-- Social Connect Hub -->
        <div class="mt-6 flex flex-wrap items-center gap-2.5">
          <a
            href="https://www.facebook.com/Luckycrest.game"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            class="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-400 transition hover:border-[#E7CA96] hover:bg-[#C71650]/10 hover:text-white"
          >
            <i class="fab fa-facebook-f text-xs"></i>
          </a>

          <a
            href="#"
            aria-label="Instagram"
            class="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-400 transition hover:border-[#E7CA96] hover:bg-[#C71650]/10 hover:text-white"
          >
            <i class="fab fa-instagram text-xs"></i>
          </a>

          <a
            href="#"
            aria-label="Telegram"
            class="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-400 transition hover:border-[#E7CA96] hover:bg-[#E7CA96]/10 hover:text-white"
          >
            <i class="fab fa-telegram-plane text-xs"></i>
          </a>

          <a
            href="#"
            aria-label="Discord"
            class="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-400 transition hover:border-[#E7CA96] hover:bg-[#C71650]/10 hover:text-white"
          >
            <i class="fab fa-discord text-xs"></i>
          </a>

          <a
            href="#"
            aria-label="Twitter / X"
            class="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-400 transition hover:border-[#E7CA96] hover:bg-[#E7CA96]/10 hover:text-white"
          >
            <i class="fab fa-x-twitter text-xs"></i>
          </a>
        </div>
      </div>

      <!-- Column 3: Game Chambers -->
      <div>
        <h3 class="mb-4 text-xs font-extrabold uppercase tracking-wider text-[#E7CA96]">
          Game Chambers
        </h3>
        <ul class="flex flex-col gap-2.5 text-xs sm:text-sm">
          <li>
            <a (click)="scrollTo('gameScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Featured Slots
            </a>
          </li>
          <li>
            <a (click)="scrollTo('spinnerScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Spin &amp; Win Wheel
            </a>
          </li>
          <li>
            <a (click)="scrollTo('scratchScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Scratch Cards
            </a>
          </li>
          <li>
            <a (click)="scrollTo('gameScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Crash &amp; Aviator
            </a>
          </li>
          <li>
            <a (click)="scrollTo('gameScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Plinko Ball Drops
            </a>
          </li>
          <li>
            <a (click)="scrollTo('gameScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Table Classics
            </a>
          </li>
        </ul>
      </div>

      <!-- Column 4: Perks & VIP -->
      <div>
        <h3 class="mb-4 text-xs font-extrabold uppercase tracking-wider text-[#E7CA96]">
          Perks &amp; VIP
        </h3>
        <ul class="flex flex-col gap-2.5 text-xs sm:text-sm">
          <li>
            <a (click)="RedirectToSignUp()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Welcome Bonus
            </a>
          </li>
          <li>
            <a (click)="RedirectToSignUp()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Daily Login Streak
            </a>
          </li>
          <li>
            <a (click)="RedirectToSignUp()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              VIP Tier Perks
            </a>
          </li>
          <li>
            <a (click)="RedirectToSignUp()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Invite &amp; Earn
            </a>
          </li>
          <li>
            <a (click)="RedirectToSignUp()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Coin Packages
            </a>
          </li>
          <li>
            <a (click)="RedirectToSignUp()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Hall of Fame
            </a>
          </li>
        </ul>
      </div>

      <!-- Column 5: Support Desk -->
      <div>
        <h3 class="mb-4 text-xs font-extrabold uppercase tracking-wider text-[#E7CA96]">
          Player Support
        </h3>
        <ul class="flex flex-col gap-2.5 text-xs sm:text-sm">
          <li>
            <a (click)="scrollTo('lcFaqCenter')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              FAQ Answer Library
            </a>
          </li>
          <li>
            <a (click)="scrollTo('contactScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              24/7 Live Concierge
            </a>
          </li>
          <li>
            <a (click)="scrollTo('lcFaqCenter')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              KYC Verification
            </a>
          </li>
          <li>
            <a (click)="scrollTo('lcFaqCenter')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Payment Assistance
            </a>
          </li>
          <li>
            <a (click)="scrollTo('lcFaqCenter')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Responsible Play
            </a>
          </li>
          <li>
            <a (click)="RedirectToLogin()" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Account Recovery
            </a>
          </li>
        </ul>
      </div>

      <!-- Column 6: Legal & Safety -->
      <div>
        <h3 class="mb-4 text-xs font-extrabold uppercase tracking-wider text-[#E7CA96]">
          Trust &amp; Legal
        </h3>
        <ul class="flex flex-col gap-2.5 text-xs sm:text-sm">
          <li>
            <a routerLink="/Terms&Condition" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Terms of Service
            </a>
          </li>
          <li>
            <a routerLink="/Help" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Privacy Policy
            </a>
          </li>
          <li>
            <a routerLink="/Terms&Condition" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Sweepstakes Rules
            </a>
          </li>
          <li>
            <a routerLink="/Terms&Condition" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Redemption Rules
            </a>
          </li>
          <li>
            <a routerLink="/Terms&Condition" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Fair Play &amp; RNG
            </a>
          </li>
          <li>
            <a (click)="scrollTo('contactScrollSection')" class="cursor-pointer text-slate-400 transition hover:text-[#F6E9D5]">
              Complaints &amp; Inquiries
            </a>
          </li>
        </ul>
      </div>

    </div>

    <!-- ================= 4. RESPONSIBLE PLAY & COMPLIANCE SEAL ================= -->
    <div class="flex flex-col gap-6 border-b border-white/10 py-8 lg:flex-row lg:items-center lg:justify-between">

      <!-- 18+ & Social Gaming Disclaimer -->
      <div class="flex items-start gap-4 max-w-3xl">
        <div class="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl border border-[#E7CA96]/40 bg-[#E7CA96]/10 text-base font-black text-[#E7CA96]">
          18+
        </div>
        <p class="text-[11px] leading-relaxed text-slate-400 sm:text-xs">
          <strong>NO PURCHASE NECESSARY TO PLAY.</strong> Luckycrest is a social entertainment platform intended exclusively for adult audiences aged 18 or older (or the age of legal majority in your jurisdiction). Virtual coins have no cash value. Play responsibly.
        </p>
      </div>

      <!-- Payment & Security Trust Badges -->
      <div class="flex flex-wrap items-center gap-3">
        <span class="rounded-lg border border-white/10 bg-white/5 px-2.5 py-1 text-[10px] font-bold tracking-wider text-slate-400">
          <i class="fab fa-cc-visa text-sm mr-1"></i> VISA
        </span>
        <span class="rounded-lg border border-white/10 bg-white/5 px-2.5 py-1 text-[10px] font-bold tracking-wider text-slate-400">
          <i class="fab fa-cc-mastercard text-sm mr-1"></i> MASTERCARD
        </span>
        <span class="rounded-lg border border-white/10 bg-white/5 px-2.5 py-1 text-[10px] font-bold tracking-wider text-slate-400">
          <i class="fab fa-bitcoin text-sm mr-1 text-[#E7CA96]"></i> BITCOIN
        </span>
        <span class="rounded-lg border border-white/10 bg-white/5 px-2.5 py-1 text-[10px] font-bold tracking-wider text-slate-400">
          <i class="fab fa-ethereum text-sm mr-1 text-[#E7CA96]"></i> ETHEREUM
        </span>
        <span class="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-2.5 py-1 text-[10px] font-bold tracking-wider text-emerald-400">
          <i class="fas fa-lock text-xs mr-1"></i> 256-BIT SSL
        </span>
      </div>

    </div>

    <!-- ================= 5. COPYRIGHT & BACK TO TOP ================= -->
    <div class="flex flex-col gap-4 pt-8 text-xs sm:flex-row sm:items-center sm:justify-between text-slate-400">
      <div class="flex flex-wrap items-center gap-2">
        <p>&copy; 2026 Luckycrest Entertainment Inc. All rights reserved.</p>
        <span class="hidden sm:inline text-slate-600">•</span>
        <span class="text-slate-500">Designed for luxury digital gaming.</span>
      </div>

      <div class="flex items-center gap-4">
        <a routerLink="/Terms&Condition" class="transition hover:text-[#F6E9D5]">Terms</a>
        <a routerLink="/Help" class="transition hover:text-[#F6E9D5]">Privacy</a>

        <button
          type="button"
          (click)="scrollToTop()"
          class="inline-flex cursor-pointer items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs font-semibold text-[#F6E9D5] shadow-sm transition hover:border-[#E7CA96] hover:bg-[#E7CA96]/10 hover:text-[#E7CA96]"
        >
          <span>Back to Top</span>
          <i class="fas fa-arrow-up text-[10px]"></i>
        </button>
      </div>
    </div>

  </div>

</footer>
</div>
